export default {
  "t-menu": "menu",
  "t-device-trend-chart": "graphique de tendance de l’appareil",
  "t-dashboard": "tableau de bord",
  "t-search": "recherche",
  "t-reset": "réinitialiser",
  "t-default": "par défaut",
  "t-system": "système",
  "t-system-param": "paramètres système",
  "t-normal": "normal",
  "t-not-supported": "Non pris en charge",
  "t-suspend": "pause",
  "t-create": "ajouter",
  "t-edit": "modifier",
  "t-copy": "copie",
  "t-export": "exportation",
  "t-download": "Télécharger",
  "t-install": "installer",
  "t-clean": "Простовання",
  "t-enter": "entrée",
  "t-select": "Sélectionner",
  "t-selected": "sélectionné",
  "t-next": "suivant",
  "t-submit": "soumettre",
  "t-update": "mise à jour",
  "t-cancel": "annuler",
  "t-cancel-reset": "réinitialiser et annuler",
  "t-name": "nom",
  "t-alias": "alias",
  "t-value": "valeur",
  "t-from": "de",
  "t-user-name": "nom d’utilisateur",
  "t-current": "actuel",
  "t-new": "nouveau",
  "t-password": "mot de passe",
  "t-confirm-password": "Confirmer le mot de passe",
  "t-length": "longueur",
  "t-type": "type",
  "t-check": "vérifier",
  "t-radius": "rayon",
  "t-refresh": "actualiser",
  "t-delete": "supprimer",
  "t-deleting": "Suppression",
  "t-import": "importer",
  "t-confirm": "confirmer",
  "t-confirm-to": "Vous êtes sûr",
  "t-confirm-delete": "Êtes-vous sûr de vouloir supprimer - {param}",
  "t-confirm-unbind": "Êtes-vous sûr de vouloir détacher - {param}",
  "t-confirm-clean-logs": "Êtes-vous sûr de vouloir supprimer les journaux?",
  "t-detail": "détail",
  "t-usage": "utiliser",
  "t-records": "détails",
  "t-location": "Emplacement",
  "t-add": "ajouter",
  "t-size": "taille",
  "t-website": "URL",
  "t-address": "adresse",
  "t-remark": "remarques",
  "t-description": "description",
  "t-description-max-length": "La description ne peut pas dépasser 500 caractères",
  "t-phone": "téléphone",
  "t-phone-number": "téléphone",
  "t-file": "fichier",
  "t-batch-file": "Fichier par lot",
  "t-push-decompressed-file": "Extraire automatiquement l'archive après le téléchargement",
  "t-push-decompressed-file-tip": "Si activé, l'archive téléchargée sera extraite automatiquement sur l'appareil cible.",
  "t-icon": "icône",
  "t-status": "statut",
  "t-action": "action",
  "t-code": "code",
  "t-revoke": "annuler",
  "t-create-by": "Créé par",
  "t-create-time": "créer du temps",
  "t-first-connect-time": "Première connexion",
  "t-executed-at": "Temps d’exécution",
  "t-execution-time": "Temps d’exécution",
  "t-execute-by": "exécuteur",
  "t-expiration-time": "Temps d’expiration",
  "t-modified-by": "modifier",
  "t-modified-time": "date de modification",
  "t-last-update-by": "Dernière mise à jour par",
  "t-last-update-time": "Dernière mise à jour",
  "t-date": "date",
  "t-seconds": "secondes",
  "t-minute": "minute",
  "t-hour": "heure",
  "t-day": "Простовання",
  "t-day-number": "rd",
  "t-month": "mois",
  "t-week": "semaine",
  "t-year": "année",
  "t-region": "Région",
  "t-continent": "continent",
  "t-basic": "classique",
  "t-premium": "Premium",
  "t-switch": "interrupteur",
  "t-quantity": "quantité",
  "t-success": "succès",
  "t-fail": "Échec",
  "t-pending": "En cours",
  "t-reverted": "Révoqué",
  "t-revoke-success-tip": "Révocation soumise, vérifiez la liste des tâches plus tard.",
  "t-yes": "oui",
  "t-no": "non",
  "t-login": "connexion",
  "t-logout": "quitter",
  "t-last-online-time": "dernier en ligne",
  "t-last-updated-time": "Dernières données mises à jour",
  "t-back": "Retour",
  "t-duration": "durée",
  "t-click-check": "Cliquez pour voir",
  "t-aborted": "Révoquer",
  "t-terminal-supported-functions": "type de terminal",
  "t-format": "format",
  "t-disable-signature": "Désactiver la signature",
  "t-polygon": "polygone",
  "t-radius-in-meters": "Rayon [50-9999]mètres",
  "t-radius-in-hours": "Durée [0-72]heures",
  "t-duration-value-range": "La durée est comprise entre 0 et 72 heures",
  "t-radius-value-range": "Le rayon est compris entre 50 et 9999 mètres",
  "t-loading": "Chargement...",
  "t-image": "image",
  "t-video": "audio",
  "t-text": "texte",
  "t-html": "HTML",
  "t-required": "est requis",
  "t-remove": "supprimer",
  "t-logo": "logo",
  "t-partner-portal-logo": "Logo du portail partenaire",
  "t-notfound-result": "Désolé ! Aucun résultat trouvé",
  "t-set": "ensemble",
  "t-number": "quantité",
  "t-login-as-partner": "Se connecter en tant que partenaire",
  "t-logout-as-partner": "Déconnexion en tant que partenaire",
  "t-anormal-devices": "dispositif anormal",
  "t-anormal-device-status": "état anormal de l’appareil",
  "t-last-7-days": "7 derniers jours",
  "t-last-14-days": "14 derniers jours",
  "t-last-30-days": "30 derniers jours",
  "t-last-90-days": "90 derniers jours",
  "t-last-365-days": "365 derniers jours",
  "t-last-days-number": "Derniers {param} jours",
  "t-table": "table",
  "t-head": "titre",
  "t-open": "ouvert",
  "t-close": "fermer",
  "t-notification": "notification",
  "t-public": "Простовання",
  "t-welcome-back": "Bienvenue",
  "t-sign-in-continue-storm": "Continuer STORM pour se connecter",
  "t-remember-me": "Souviens-toi de moi",
  "t-sign-in": "connexion",
  "t-please-wait": "Connecté",
  "t-storm-introduction-title1": "Système de gestion de contrôle à distance intelligent du terminal",
  "t-storm-introduction-title2": "Feitian a développé la prochaine génération de plateforme de gestion TMS, à savoir la plateforme “STORM”",
  "t-storm-introduction-title3": "Comprend des fonctions telles que le service de push de messages, l’injection de clés à distance, la mise à niveau à distance OTA et la gestion à distance des terminaux",
  "t-login-status-expired": "La connexion a expiré, veuillez vous connecter à nouveau !",
  "t-tooltip-device": "numéro de l’appareil,TID,MID,IMEI",
  "t-sn": "numéro de l’appareil",
  "t-terminal-management-system": "Système de gestion de terminal",
  "t-device-mgmt": "Gestion des appareils",
  "t-uninstall": "désinstaller",
  "t-uninstall-block": "Interdire la désinstallation",
  "t-device": "appareil",
  "t-device-type": "appareil Type",
  "t-ecr-pos": "ECR POS",
  "t-pos": "POS",
  "t-ecr": "ECR",
  "t-serial-number": "Numéro de série",
  "t-product-bundle": "Ensemble de produits",
  "t-device-detail": "Détails de l'équipement",
  "t-charts-devices": "appareil",
  "t-charts-push-report": "Push record",
  "t-bind": "lier",
  "t-bind-to": "lier à",
  "t-unbind": "délier",
  "t-device-secret": "Clé de l’appareil",
  "t-product-key": "Clé de produit",
  "t-available": "disponible",
  "t-used": "Utilisé",
  "t-current-version-deleted": "supprimé",
  "t-available-list": "Appareils disponibles",
  "t-bound-list": "périphérique lié",
  "t-selected-list": "appareils sélectionnés",
  "t-select-device-bind": "Veuillez sélectionner le périphérique à lier",
  "t-batch": "lot",
  "t-upload": "télécharger",
  "t-refresh-device": "actualiser l’appareil",
  "t-remote-control": "télécommande",
  "t-remote-control-auto-pwd": "Contrôle à distance (Mot de passe automatique)",
  "t-enable-unattended": "RCA Sans surveillance",
  "t-remote-control-approve-click": "Connexion autorisée",
  "t-remote-control-approve-password": "Sans surveillance",
  "t-disable-remote-control": "Désactiver le RC",
  "t-device-not-partner": "L’appareil n’est pas lié à un partenaire",
  "t-remote-control-failed": "La télécommande a échoué, veuillez d'abord annuler le mode de domination de l'écran",
  "t-health-check-failed-kiosk": "Le contrôle de santé a échoué, veuillez d'abord annuler le mode de domination de l'écran",
  "t-remote-control-steps": "Dans la télécommande de l'appareil connecté...",
  "t-disable-device": "désactiver l’appareil",
  "t-out-of-fence": "hors de geofence",
  "t-active-statistics": "statistiques d’activation",
  "t-online-statistics": "Statistiques en ligne",
  "t-active": "activé",
  "t-inactive": "inactif",
  "t-out-of-country": "au-delà de la clôture de l’aire nationale",
  "t-under-activation": "À activer",
  "t-online": "en ligne",
  "t-offline": "hors ligne",
  "t-abnormal": "Anormal",
  "t-block": "démontage",
  "t-device-disabled": "Appareil désactivé",
  "t-device-disabled-tamper": "Appareil désactivé",
  "t-device-tamper-no": "L’appareil est normal",
  "t-device-tamper-yes": "L’appareil est démonté",
  "t-filters": "requête avancée",
  "t-basic-information": "Informations de base",
  "t-installed-application": "Application installée sur l’appareil",
  "t-last-factory-settings-time": "Derniers paramètres d’usine",
  "t-timeline": "Pousser l’enregistrement de la tâche",
  "t-android": "Android",
  "t-build-number": "version du système",
  "t-sp-bootloader": "Chargeur d’amorçage SP",
  "t-sma-version-code": "Version SMA",
  "t-version-code": "code de version",
  "t-version-type": "type de version",
  "t-upgrade-model": "Mode de mise à niveau",
  "t-sma-status": "Statut SMA",
  "t-pubkey-status": "état de la clé publique",
  "t-cortex-scanner": "Scanner de cortex",
  "t-total": "Total",
  "t-cpu-statistics": "Statistiques du processeur",
  "t-ram-statistics": "Statistiques de RAM",
  "t-storage-statistics": "statistiques de stockage",
  "t-authorisations": "Autorisation",
  "t-kiosk-mode": "Dominer le mode écran",
  "t-set-kiosk-mode": "Règle le mode de domination de l’écran",
  "t-cancel-kiosk-mode": "Annuler le mode Kiosk",
  "t-open-immediately": "Ouvrir immédiatement",
  "t-options": "Options",
  "t-application-starts-automatically-after-installation": "L'application démarre automatiquement une fois l'installation terminée.",
  "t-cancel-open-immediately": "Annuler l’ouverture immédiate",
  "t-screen-resolution": "résolution de l’écran",
  "t-battery-capacity": "capacité de la batterie",
  "t-sim-number": "Numéro SIM",
  "t-sp-firmware": "Micrologiciel SP",
  "t-cpu": "CPU",
  "t-iccid": "ICCID - (SIM)",
  "t-production-batch": "lot de production",
  "t-category": "catégorie",
  "t-sales-batch": "lot de ventes",
  "t-network": "réseau",
  "t-router-address": "Adresse du routeur",
  "t-router-name": "Nom du routeur",
  "t-communication-type": "type de communication",
  "t-signal-strength": "intensité du signal",
  "t-transmission-speed": "vitesse de transmission",
  "t-wifi": "WIFI",
  "t-mobile": "Mobile",
  "t-wifi-mac-address": "Adresse MAC WIFI",
  "t-push-mgmt": "gestion push",
  "t-RKI-MGMT": "Gestion des clés",
  "t-partner": "Partenaire",
  "t-parent": "parent partenaire",
  "t-continent-region-exist": "Les mêmes données de continent et de région existent déjà. Veuillez supprimer les données existantes et les ajouter à nouveau",
  "t-customer": "client",
  "t-merchant": "marchand",
  "t-store": "Boutique",
  "t-excel-sample-file": "Fichier d’exemple Excel",
  "t-import-strip": "bande",
  "t-number-of-successes": "nombre de succès",
  "t-number-of-failed": "nombre de défaillances",
  "t-import-failed-file": "Échec de l’importation du fichier (cliquez pour télécharger)",
  "t-device-settings": "Configuration de l’appareil",
  "t-manufacturer": "fournisseur d’équipement",
  "t-model": "modèle d’appareil",
  "t-model-version": "version du modèle",
  "t-general": "version générique",
  "t-beta": "version en niveaux de gris",
  "t-resolution": "résolution",
  "t-connection-type": "type de connexion",
  "t-message-protocol": "Protocole de message",
  "t-hardware-parameter": "Paramètre matériel",
  "t-version": "Version",
  "t-version-list": "numéro de version",
  "t-json-layout": "Format JSON",
  "t-general-parameter": "Paramètre général du système",
  "t-terminal-profiles": "fichier d’initialisation du terminal",
  "t-force-initialization": "Forcer l’initialisation",
  "t-group": "groupe d’appareils",
  "t-add-device-to-group": "Ajouter un appareil au groupe",
  "t-upload-file-bind-device": "Télécharger des fichiers et lier/dissocier des appareils par lots",
  "t-geo-fence": "géo-clôture",
  "t-erase-drawing": "Supprimer le dessin",
  "t-log-capture": "capture de journal",
  "t-log": "log",
  "t-firmware": "firmware",
  "t-firmware-version": "version du firmware",
  "t-md5": "MD5",
  "t-application-mgmt": "Gestion des applications",
  "t-application": "application",
  "t-application-name": "Nom de l’application",
  "t-application-version": "Version de l’application",
  "t-application-certificates": "certificats d’application",
  "t-api-sign": "Applications API",
  "t-sign-status-created": "En attente",
  "t-sign-status-queued": "En file",
  "t-sign-status-signing": "Signature",
  "t-sign-status-completed": "Terminée",
  "t-sign-status-failed": "Échec",
  "t-Certificates": "Certificat",
  "t-certificate-level": "niveau de certificat",
  "t-tls-certificates": "Certificats TLS",
  "t-certificate-version": "version du certificat",
  "t-certificate-owner": "propriétaire du certificat",
  "t-certificate-issuer": "émetteur de certificat",
  "t-certificate-serial-number": "numéro de série du certificat",
  "t-certificate-effective-date": "Date d’entrée en vigueur du certificat",
  "t-certificate-expiration-date": "Date d’expiration du certificat",
  "t-certificate": "Certificat",
  "t-certificate-signing-algorithm": "algorithme de signature de certificat",
  "t-subject-dn": "DN du sujet",
  "t-issuer-dn": "DN de l'émetteur",
  "t-not-before": "Pas avant",
  "t-not-after": "Pas après",
  "t-batch-upload": "téléchargement par lot",
  "t-friendly-name": "Nom du certificat",
  "t-name-common": "nom commun",
  "t-country": "pays",
  "t-currency": "monnaie",
  "t-city": "ville",
  "t-org-unit": "unité organisationnelle",
  "t-org": "organisation",
  "t-state-province": "état/province",
  "t-common-name": "Nom commun",
  "t-organization": "Organisation",
  "t-organizational-unit-name": "Nom de l'unité organisationnelle",
  "t-locality": "Localité",
  "t-key-store-password": "Mot de passe du magasin de clés",
  "t-calendar": "calendrier",
  "t-transaction-param": "Paramètres de transaction",
  "t-byte": "octet",
  "t-copy-code": "copier le code",
  "t-offline-data-authentication-was-not-effected": "L’authentification des données hors ligne n’a pas été effectuée",
  "t-sda-failed": "Echec SDA",
  "t-icc-data-missing": "Perte de données ICC",
  "t-card-appears-on-terminal-exception-file": "La carte apparaît sur le fichier d’exception du terminal",
  "t-dda-failed": "Échec de la DDA",
  "t-cda-failed": "Échec de l’ADC",
  "t-rfu": "RFU",
  "t-icc-and-terminal-have-different-application": "ICC et terminal ont des versions d’application différentes",
  "t-expired-application": "Application expirée",
  "t-application-not-yet-effective": "L’application n’a pas encore pris effet",
  "t-requested-service-not-allowed-for-card-product": "Le produit de la carte ne permet pas le service demandé",
  "t-new-card": "nouvelle carte",
  "t-cardholder-verification-was-not-successful": "La vérification du titulaire de la carte n’a pas réussi",
  "t-unrecognised-cvm": "CVM non reconnu",
  "t-pin-try-limit-exceed": "Limite de tentative de code PIN dépassée",
  "t-pin-entry-required-and-pin-pad-not-present-or-not-working": "Code PIN requis, le clavier PIN n’existe pas ou ne fonctionne pas",
  "t-pin-entry-required-pin-pad-present-but-pin-was-not-entered": "Code PIN requis, le code PIN existe sur le clavier, mais le code PIN n’est pas entré",
  "t-online-pin-entered": "Code PIN en ligne saisi",
  "t-transaction-exceeds-floor-limit": "Transaction exceeds-floor-limit",
  "t-lower-consecutive-offline-limit-exceed": "Dépassement de la limite inférieure du continu hors ligne",
  "t-upper-consecutive-offline-limit-exceed": "Limite hors ligne continue dépassée",
  "t-transaction-selected-randomly-for-online-processing": "Transactions sélectionnées aléatoirement pour le traitement en ligne",
  "t-merchant-forced-transaction-online": "transaction en ligne forcée par le marchand",
  "t-package": "paquet",
  "t-package-name": "Nom du package",
  "server.mam.ft.package.mismatch": "Le nom du package ne correspond pas",
  "t-application-token": "jeton d’application",
  "t-client-token": "jeton client",
  "t-intent-name": "Nom de l’intention",
  "t-file-name": "nom_fichier",
  "t-file-size": "Taille du fichier",
  "t-silent-upgrade": "Mise à Jour Manuelle",
  "t-prompt-for-upgrade": "Mise à Jour Automatique",
  "t-upgrade-strategy": "stratégie de mise à niveau",
  "t-upgrade": "mise à niveau",
  "t-upgrade-strategy-for-supports-sma": "La politique de mise à niveau ne prend en charge que SMA, et la version SMA 100517 et supérieure prend en charge cette politique de mise à niveau",
  "t-allow-use-network-download": "Autoriser le téléchargement à l’aide du réseau mobile",
  "t-selected-range-not-allowed": "La plage sélectionnée ne peut pas dépasser 18 heures",
  "t-terminal-allow-use-network-download-network": "Sélectionnez cette option et le terminal permettra le téléchargement de fichiers de firmware à l’aide du réseau mobile",
  "t-time-period-upgrade-tip": "Le terminal sera automatiquement mis à niveau dans la période spécifiée, si le terminal annule la mise à niveau, il entrera à nouveau dans la mise à niveau dans la prochaine période",
  "t-period-of-time": "période",
  "t-start-time-and-end-time-cannot-be-same": "L’intervalle de sélection n’est pas autorisé à être le même",
  "t-push-to-device-group": "Pousser vers l’appareil ou le groupe",
  "t-push-login-as-partner": "Veuillez vous connecter en tant que partenaire pour exécuter cette fonction",
  "t-push-to-device": "Pousser vers l'appareil",
  "t-push-to-group": "Pousser vers le groupe",
  "t-push-report": "Enregistrement de poussée",
  "t-abort-push": "Révoquer push",
  "t-not-start": "non démarré",
  "t-warning-to-cancel-push": "Êtes-vous sûr de vouloir révoquer le push",
  "t-scheduler-tasks": "Pousser les tâches planifiées",
  "t-planned": "planifié",
  "t-message": "Message",
  "t-message-type": "type de message",
  "t-push-message": "Le message programmé a expiré",
  "t-showing-duration": "durée du spectacle",
  "t-unlimited": "illimité",
  "t-plan-time": "planifier le temps",
  "t-message-from": "de",
  "t-every": "every",
  "t-content": "contenu",
  "t-advertisement": "publicité",
  "t-advertising-planner": "Plan publicitaire",
  "t-planner": "Plan",
  "t-advertisement-file": "fichier de ressources",
  "t-loop": "boucle",
  "t-ads-start-date": "Date et heure de début de l’annonce",
  "t-ads-end-date": "La date et l’heure de la fin de l’annonce",
  "t-more-detail-url": "URL plus détaillée",
  "t-detail-url": "URL détaillée",
  "t-folder": "dossier",
  "t-key-capture": "Générer la clé",
  "t-key": "clé secrète",
  "t-index": "indice",
  "t-algorithm": "algorithme",
  "t-key-type": "Type de clé",
  "t-number-keys": "nombre de touches",
  "t-key-group": "groupe de touches",
  "t-key-value": "valeur clé",
  "t-kcv": "KCV",
  "t-clear-key": "clé claire",
  "t-encrypted-key-under": "clé de chiffrement",
  "t-key-capture-report": "Enregistrement de génération de clé",
  "t-key-injection": "injection de clé",
  "t-ksi": "KSI",
  "t-did": "DID",
  "t-counter": "Compteur",
  "t-ksn": "KSN",
  "t-ksn-example": "Exemple KSN",
  "t-hsm": "HSM",
  "t-hsm-model": "Modèle HSM",
  "t-interface": "interface",
  "t-primary-host": "adresse de l’hôte",
  "t-primary-port": "port hôte",
  "t-secondary-host": "adresse de l’hôte secondaire",
  "t-secondary-port": "port hôte secondaire",
  "t-hsm-enable": "HSM Activer",
  "t-lmk-index": "Indice LMK",
  "t-enable": "s’il faut l’activer",
  "t-key-block": "bloc de clé",
  "t-widgets": "plugin",
  "t-settings": "paramètres",
  "t-device-locations": "Emplacement de l’appareil",
  "t-role-widget-save-successfully": "Les paramètres de rapport sauvegardés avec succès",
  "t-partner-settings": "Paramètres du partenaire",
  "t-opt": "Authentification à deux facteurs",
  "t-signature": "Signature APK",
  "t-cloud-messaging": "Service de messagerie cloud",
  "t-detamper-auth": "de-de-detamper-auth",
  "t-enable-signature-error-partner-not-found": "Échec de l’activation de la signature secondaire, aucun partenaire associé",
  "t-enable-signature-error-2nd-cert-not-found": "Échec de l’activation de la signature secondaire, certificat secondaire introuvable",
  "t-partner-setting-updated-successfully": "Les paramètres du partenaire ont été mis à jour avec succès !",
  "t-error-updating-partner-setting": "Une erreur s’est produite lors de la mise à jour des paramètres du partenaire",
  "t-error-loading-partner-setting": "Une erreur s’est produite lors du chargement des paramètres du partenaire",
  "t-email-settings": "Paramètres de la boîte aux lettres",
  "t-email": "boîte aux lettres",
  "t-email-server": "serveur de messagerie",
  "t-email-account": "compte de messagerie",
  "t-port": "port",
  "t-ssl": "SSL",
  "t-starttls": "STARTTLS",
  "t-email-sender": "expéditeur de l’e-mail",
  "t-sms-settings": "Paramètres SMS",
  "t-sms": "SMS",
  "t-sms-gateway": "Passerelle SMS",
  "t-sms-settings-sms": "Fournisseur de services SMS",
  "t-sms-settings-signname": "Nom de la signature",
  "t-access": "ID de la clé d’accès",
  "t-access-key-id": "ID de la clé d’accès",
  "t-access-key-secret": "Clé d’accès secrète",
  "t-password-policy": "politique de mot de passe",
  "t-enable-password-policy": "Activer la politique de mot de passe",
  "t-enable-password-length-minimum": "Activer la longueur minimale du mot de passe",
  "t-password-length": "La longueur de mot de passe la plus courte varie de 4 à 32",
  "t-required-item": "Ceci est obligatoire",
  "t-password-length-minimum": "La valeur minimale est 4",
  "t-password-length-maximum": "La valeur maximale est de 32",
  "t-password-policy-pattern": "Cette valeur doit être un entier",
  "t-enable-password-part": "Activer la composition du mot de passe",
  "t-password-numbers-and-letters-combination": "Le mot de passe doit être une combinaison de chiffres et de lettres",
  "t-password-use-least-one-uppercase-letter": "Utilise au moins une lettre majuscule",
  "t-repeated-characters-not-allowed-to-use": "Interdiction de répéter des caractères",
  "t-allows-use-special-characters": "Les caractères spéciaux (sauf les espaces) sont autorisés",
  "t-use-least-one-special-character": "Utilise au moins un caractère spécial",
  "t-different-user-name-and-password": "Le nom d’utilisateur et le mot de passe doivent être différents",
  "t-w-to-enable-history-password": "si l’utilisation des mots de passe historiques est interdite",
  "t-use-history-password-number": "Le nombre de mots de passe historiques n’est pas autorisé",
  "t-use-history-password-number-minimum": "La valeur minimale est de 3",
  "t-use-history-password-number-maximum": "La valeur maximale est 6",
  "t-enable-password-change-frequency": "indique s’il faut activer la fréquence de changement de mot de passe",
  "t-password-change-frequency": "fréquence de changement de mot de passe (par jour/1 fois)",
  "t-password-change-frequency-minimum": "La valeur minimale est 1",
  "t-password-change-frequency-maximum": "La valeur maximale est 9",
  "t-change-the-password-regular-basis": "S’il faut changer le mot de passe régulièrement",
  "t-password-periodically-change": "Le nombre de jours pendant lesquels le mot de passe est changé périodiquement",
  "t-password-periodically-minimum": "minimum est de 90",
  "t-password-periodically-maximum": "La valeur maximale est 365",
  "t-password-configuration-updated-successfully": "La politique de mot de passe mise à jour avec succès!",
  "t-error-updated-password-configuration": "Échec de la mise à jour de la configuration du mot de passe",
  "t-times-task": "Réglage de la tâche planifiée",
  "t-execute-once": "Exécuter une fois",
  "t-task-group": "groupe de tâches",
  "t-method": "méthode",
  "t-log-information": "informations de journal",
  "t-cron-expression": "Expression Cron",
  "t-clean-condition": "état clair",
  "t-concurrent": "concurrence",
  "t-wrong-strategy": "mauvaise stratégie",
  "t-allow": "permettre",
  "t-prohibit": "interdit",
  "t-execute-immédiatement": "Exécuter-immédiatement",
  "t-next-execution-time": "Heure de la prochaine exécution",
  "t-execute": "exécuter",
  "t-cancel-execution": "Annuler-exécution",
  "t-task-scheduler": "Tâche planifiée par le système",
  "t-task-scheduler-logs": "Enregistrement de l’exécution des tâches planifiées par le système",
  "t-notice": "Paramètres de notification",
  "t-alarm-settings": "Paramètres d’alarme de notification",
  "t-alarm": "Paramètres",
  "t-alarm-mgmt": "Gestion d'alarmes",
  "t-already-used": "utilisé",
  "t-silence-time": "Le temps du silence",
  "t-alert-logs": "journal des alarmes",
  "t-logs": "Logs",
  "t-alert-status-info-untreated": "Non traité",
  "t-alert-status-info-processed": "traité",
  "t-alert-status-info-closed": "fermé",
  "t-alert-status-info-handle": "Processus",
  "t-alert-status-info-close": "Fermer",
  "t-rule": "règle",
  "t-alert-policies": "politique d’alerte",
  "t-policies": "politique",
  "t-alert-level": "niveau d’alerte",
  "t-level": "niveau",
  "t-alerts-cycles": "Cycle d’alerte",
  "t-alert-channel": "t-alert-channel",
  "t-contacts-group": "groupe de contact",
  "t-contacts-user": "contact",
  "t-alert-rule": "Règle d’alerte",
  "t-email-alert-template": "Modèle d’alerte par e-mail",
  "t-email-template": "Modèle de courriel",
  "t-alert-rule-template": "Modèle de règle",
  "t-template-title": "Titre-modèle",
  "t-template": "Titre",
  "t-from-name": "Nom de l’expéditeur",
  "t-email-alert-content": "Contenu du modèle d’e-mail",
  "t-search-alert": "Nom de la notification de recherche",
  "t-alert-notice": "Простовання",
  "t-alert-policy": "politique d’alerte",
  "t-policy": "politique",
  "t-alert-contacts": "Alerter les contacts",
  "t-alert-start-time": "Temps effectif",
  "t-alert-mechanism": "mécanisme d’alarme",
  "t-notice-channels": "canaux de notification",
  "t-channels": "Canal",
  "t-first-sequence-notifier": "notifier de première séquence",
  "t-second-sequence-notifier": "second-sequence-notifier",
  "t-third-sequence-notifier": "notifier de third-sequence",
  "t-notification-interval": "Intervalle de notification suivant",
  "t-error-sms-not-enable": "Il n’y a pas de configuration de passerelle SMS activée",
  "t-error-email-not-enable": "Il n’y a pas de configuration de boîte aux lettres activée",
  "t-enable-fence-alert": "Activer l’alerte de clôture",
  "t-policy-alert-rule-content": " Règle d’alerte",
  "t-alert-channel-template-configuration": "Configuration-de-modèle-de-canal-t-alerte",
  "t-available-merge-fields": "Fusionner les champs disponibles",
  "t-sunday": "Dimanche",
  "t-Monday": "Lundi",
  "t-Tuesday": "Mardi",
  "t-Wednesday": "Mercredi",
  "t-thursday": "Jeudi",
  "t-Friday": "Vendredi",
  "t-saturday": "samedi",
  "t-notifying-user": "Notifier l’utilisateur",
  "t-notifying-partner": "Partenaire-notifiant",
  "t-notifying-customer": "Простовання",
  "t-notifying-merchat": "notifier-merchat",
  "t-notifying-text-message": "SMS",
  "t-notifying-info": "informations de notification",
  "t-alert-status": "état de la notification",
  "t-alert-time": "heure de l’alarme",
  "t-ui": "UI",
  "t-wallpaper": "fond d’écran",
  "t-boot-picture": "cadre de démarrage d’abord",
  "t-boot-animation": "animation de démarrage",
  "t-log-report": "log et rapport",
  "t-entity-value": "valeur de l’entité",
  "t-system-health": "santé du système",
  "t-gateway": "passerelle",
  "t-configuration": "configuration",
  "t-health": "健康",
  "t-audit-logs": "journaux d’audit",
  "t-tickets": "billets",
  "t-disconnect": "déconnecter",
  "t-received": "reçu",
  "t-unreceived": "Non reçu",
  "t-subject": "sujet",
  "t-user-mgmt": "Gestion des utilisateurs",
  "t-user": "utilisateur",
  "t-authorities": "rôle",
  "t-reset-password": "réinitialiser le mot de passe",
  "t-activate-token": "Activer l'MFA",
  "t-replace-token": "Remplacer l'MFA",
  "t-activate-user": "Activer l’utilisateur",
  "t-activate": "Activer",
  "t-deactivate": "fermer",
  "t-reboot": "reboot",
  "t-warning-to-reboot": "Êtes-vous sûr de vouloir redémarrer votre appareil?",
  "t-warning-to-unbind": "Êtes-vous sûr de vouloir dissocier cet enregistrement?",
  "t-lock": "verrouiller",
  "t-lock-device": "dispositif de verrouillage",
  "t-warning-to-lock": "Êtes-vous sûr de vouloir verrouiller l’appareil?",
  "t-unlock": "déverrouiller",
  "t-warning-to-unlock": "Êtes-vous sûr de vouloir déverrouiller votre appareil?",
  "t-factory-settings": "réinitialisation d’usine",
  "t-warning-to-reset": "Êtes-vous sûr de vouloir restaurer les paramètres d’usine de votre appareil? Êtes-vous sûr que cette action entraînera une perte de données? ",
  "t-warning-to-shut-down": "Êtes-vous sûr de vouloir éteindre l’appareil?",
  "t-warning-to-disable-geo-tracking": "Êtes-vous sûr de vouloir désactiver la géolocalisation?",
  "t-shut-down-device": "arrêt",
  "t-enable-geo-tracking": "Activer la géolocalisation",
  "t-disable-geo-tracking": "Désactiver le géorepérage",
  "t-warning-to-geo-tracking": "Veuillez noter que l’activation de la géolocalisation entraînera l’épuisement de la batterie",
  "t-device-geo-tracking-not-enable": "La géolocalisation n’est pas activée sur l’appareil",
  "t-device-geo-tracking-has-enable": "Géolocalisation activée sur l’appareil",
  "t-enter-package-name": "Entrez le nom du paquet",
  "t-package-name-already-exists": "Ce nom de paquet existe déjà",
  "t-device-sn": "Numéro de série de l’appareil",
  "t-device-name": "Nom de l’appareil",
  "t-device-license-file-does-not-exist": "Le fichier de licence de l’appareil n’existe pas",
  "t-device-under-activation": "L’appareil est à l’état en attente ou inactif",
  "t-device-is-out-of-of-range-activation-failed": "L’appareil est hors de portée et l’activation a échoué",
  "t-sync": "Synchroniser",
  "t-cancel-geo-fencing": "Annuler le geofencing",
  "t-warning-to-cancel-geo-fencing": "Êtes-vous sûr de vouloir supprimer le geofence?",
  "t-device-not-support-pubkey-synchroninization": "L’appareil ne prend pas en charge la synchronisation par clé publique, veuillez vérifier l’appareil",
  "t-device-geo-location": "géolocalisation de l’appareil",
  "t-geo-location": "géolocalisation",
  "t-longitude": "longitude",
  "t-latitude": "latitude",
  "t-device-unbind-successful": "Le périphérique a été délié avec succès",
  "t-device-bind-successful": "Le périphérique est lié avec succès",
  "t-wait-pend": "En cours, veuillez attendre que l’appareil réponde",
  "t-warning-to-activate-kiosk": "Êtes-vous sûr de vouloir activer le mode de contrôle de l’écran",
  "t-setting-version-type-general": "Si cette version est définie sur la version générale, les applications suivantes seront modifiées sur la version en niveaux de gris",
  "t-error-application-not-function": "L’application système ne peut pas effectuer cette opération",
  "t-error-device-no-application": "Il n’y a pas d’application sur l’appareil",
  "t-warning-to-deactivate-kiosk": "Êtes-vous sûr de vouloir désactiver le mode dominant",
  "t-device-need-specified-area": "L’appareil doit retourner dans la zone spécifiée",
  "t-device-need-specified-fence": "L’appareil doit retourner la clôture spécifiée",
  "t-recover-key-success": "Demande de clé d’initialisation de l’appareil envoyée réussie",
  "t-error-domineering-state-already": "Il y a déjà d’autres applications dans l’état dominant",
  "t-app-has-dominated": "Cette application a été dominée, s’il vous plaît, n’envoyez plus de commandes",
  "t-error-app-not-domineering-state": "L’application n’est pas dans l’état dominant",
  "t-error-device-not-app-in-dominant-state": "Il n’y a pas d’applications sur l’appareil qui dominent l’écran",
  "t-error-current-domineering-state-already": "L’application actuelle est déjà dans l’état d’écran dominant",
  "t-warning-to-uninstall": "Êtes-vous sûr de vouloir désinstaller l’application",
  "t-warning-to-uninstall-block": "Êtes-vous sûr de vouloir supprimer l’application de désinstallation",
  "t-application-in-kiosk-mode": "L’application est en mode dominant, veuillez d’abord désactiver le mode dominant",
  "t-uninstall-application": "Désinstaller l’application",
  "t-device-not-activated": "L’appareil n’est pas activé",
  "t-device-not-online": "L’appareil n’est pas online",
  "t-request-sent-device": "La demande a été envoyée avec succès à l’appareil",
  "t-activate-request-sent": "Une demande d’activation a été envoyée avec succès à l’appareil",
  "t-error-updating-device": "Une erreur s’est produite lors de la mise à jour de l’appareil",
  "t-storm-restore-factory-settings": "STORM - Réinitialisation d’usine",
  "t-device-restore-factory-settings": "Appareil - Réinitialisation d’usine",
  "t-first-name": "nom",
  "t-last-name": "Nom",
  "t-deactivated": "désactivé",
  "t-activated": "activer",
  "t-role": "rôle",
  "t-permissions-name-connot-replace": "Le format du nom ne correspond pas, le nom ne peut pas être égal à “ROLE_ADMIN”,“ROLE_OPERATOR”,“ROLE_PARTNER”, ou “ROLE_USER.”",
  "t-auto-generate-password": "Mot de passe généré automatiquement",
  "t-deactivate-user": "Désactiver l’utilisateur",
  "t-role-permissions": "permissions de rôle",
  "t-permissions": "autorisations",
  "t-read": "lire",
  "t-write": "Écrire",
  "t-push": "pousser",
  "t-record": "enregistrer",
  "t-tid": "TID",
  "t-mid": "MID",
  "t-imei": "IMEI",
  "t-disable": "au-delà de la clôture de la zone nationale",
  "t-Tamper": "Démontage",
  "t-de-tamper": "démonter",
  "t-report": "rapport",
  "t-report-data": "Données du rapport",
  "t-report-settings": "paramètres du rapport",
  "t-report-download": "Téléchargement du rapport",
  "t-sort-digit": "numéro de tri",
  "t-universal": "universel",
  "t-widget": "contrôle",
  "t-conditions": "condition",
  "t-attribute-code": "code d’attribut",
  "t-attribute-name": "nom_attribut",
  "t-attribute": "nom_attribut",
  "t-data-type": "type-de-données",
  "t-attribute-type": "Type d'attribut",
  "t-language-type": "Type de langue",
  "t-enumerated-value": "valeur énumérée",
  "t-enumerated-name": "Nom énuméré",
  "t-association": "association",
  "t-sql": "SQL",
  "t-chart": "graphique",
  "t-pie-chart": "camembert",
  "t-bar-chart": "histogramme",
  "t-line-chart": "graphique linéaire",
  "t-time-frame": "cadre temporel",
  "t-enumeration": "énumération",
  "t-string": "chaîne",
  "t-internationalization": "internationalisation",
  "t-language": "langue",
  "t-charts": "charts",
  "t-fixed-report": "rapport statique",
  "t-dynamic-report": "rapport dynamique",
  "t-reason": "простовання",
  "t-numbers-letter": "composé de lettres majuscules et minuscules, de chiffres et de tirets",
  "t-input-invalid-pattern-default": "Se compose de chiffres, de lettres, de traits de soulignement, de points et d’espaces, prend en charge le chinois, l’anglais, le français, le russe et l’Espagne, ne peut pas commencer ou se terminer par des espaces",
  "t-input-invalid-pattern-default-arabic": "Se compose de chiffres, de lettres, de traits de soulignement, de points et d’espaces, prend en charge le chinois, l’anglais, le français, le russe, l’espagnol et l’arabe, ne peut pas commencer ou se terminer par des espaces",
  "t-input-invalid-pattern-user-name": "Se compose de chiffres, de lettres, de tirets et d’espaces, prend en charge le chinois, l’anglais, le français, le russe et l’espagnol, et ne peut pas commencer ou se terminer par un espace",
  "t-input-invalid-pattern-phone": "Se compose d’un nombre, d’un tiret, d’un + et d’un espace, et ne peut pas commencer et se terminer par un espace ou un tiret. Les espaces et les tirets ne peuvent pas être saisis consécutivement, et les numéros dont l’indicatif régional commence par + ou 00",
  "t-input-invalid-pattern-website": "au format URL",
  "t-input-invalid-pattern-host": "au format d’une adresse IP",
  "t-input-invalid-pattern-email": "Exemple de format de message :abc@ftsafe.com",
  "t-input-invalid-pattern-smtp": "composé au format de nom de domaine SMTP",
  "t-input-invalid-pattern-sn": "se compose de lettres majuscules et minuscules, de chiffres et de tirets",
  "t-input-invalid-pattern-imei": "composé de nombres purs",
  "t-input-invalid-pattern-device-imei": "Seuls les numéros peuvent être saisis dans l’IMEI",
  "t-input-invalid-pattern-tid": "se compose de lettres et de chiffres majuscules et minuscules",
  "t-input-invalid-pattern-key": "se compose de lettres majuscules et minuscules, de points et de chiffres",
  "t-input-invalid-pattern-key-number": "se compose de lettres majuscules et minuscules, de points et de chiffres",
  "t-input-invalid-pattern": "Entrez une valeur valide. Veuillez noter que les caractères de début et de fin ne peuvent pas être des espaces",
  "t-input-invalid-pattern-password": "Entrez une valeur valide. Contenir au moins un chiffre ou une lettre. Veuillez noter que les caractères de début et de fin ne peuvent pas être des espaces",
  "t-input-invalid-pattern-letters-numbers": "Seules les lettres et les chiffres sont autorisés.",
  "t-minlength-valid-pattern": "La limite minimale de caractères est",
  "t-maxlength-valid-pattern": "La limite maximale de caractères est ",
  "t-file-maximum-size": "La taille maximale du fichier est",
  "t-file-upload-right-spec": "Veuillez télécharger un fichier qui répond aux exigences",
  "t-model-name": "Nom du modèle",
  "t-log-info": "informations de journal",
  "t-clean-success": "clean-success",
  "t-push-event-id": "ID de l’événement push",
  "t-operation": "operation",
  "t-input-password-mismatch": "incompatibilité de mot de passe",
  "t-generated": "généré",
  "t-entity": "entité",
  "t-entity-name": "Nom de l’entité",
  "t-minutes": "minutes",
  "t-hours": "heure",
  "t-app-incremental-upgrade": "Mise à niveau_incrémentale de l’application",
  "t-restart": "redémarrer",
  "t-shutdown-device": "Arrêt de l’appareil",
  "t-system-parameter": "Paramètre système",
  "t-start": "début",
  "t-end": "fin",
  "t-stop": "stop",
  "t-time": "temps",
  "t-geo-fencing": "geofencing",
  "t-initialization": "initialisation",
  "t-erase": "ascenseur",
  "t-initial-key": "clé d’initialisation",
  "t-geo-tracking": "géolocalisation",
  "t-automatic": "automatique",
  "t-sma-data-synchronization": "Synchronisation des données SMA",
  "t-pubkey-synchronization": "synchronisation à clé publique",
  "t-push-select-device-group": "Veuillez sélectionner le périphérique ou le groupe à pousser",
  "t-m20-transaction-param": "Paramètres de transaction M20",
  "t-push-status-push-sent": "Push envoyé",
  "t-push-status-push-received": "Push reçu",
  "t-push-status-downloading": "Téléchargement",
  "t-push-status-installing": "Installation",
  "t-push-status-executing": "Exécution",
  "t-push-status-success": "succès",
  "t-push-status-fail": "failed",
  "t-push-status-app-not-signed": "Échec, application non signée",
  "t-push-status-install-later": "Installer plus tard",
  "t-push-status-higher-version-exist": "Échec, une version supérieure existe pour l’application",
  "t-push-status-app-not-installed": "Échec, application non installée",
  "t-push-status-broadcast-transmitted": "diffusion transmise",
  "t-push-status-increment-file-error": "Échec, erreur de fichier delta",
  "t-push-status-file-format-error": "Échec, erreur de format de fichier",
  "t-push-status-download-file-error": "Échec, téléchargement de fichier incorrect",
  "t-push-status-task-reached the-maximum": "échec, tâche atteinte maximum",
  "t-push-status-insufficient-electricity": "Echec, la batterie est insuffisante, veuillez réessayer plus tard",
  "t-push-status-app-patch-updating": "Mise à jour du correctif d’application",
  "t-push-status-app-patch-update-error": "Échec, erreur de mise à jour du correctif de l’application",
  "t-push-status-parameter-error": "Échec, erreur de paramètre",
  "t-push-status-download-completed": "Téléchargement terminé",
  "t-push-status-same-task-exist": "Echec, la même tâche existe",
  "t-push-status-push-uploading": "Pousser et télécharger",
  "t-push-status-push-ota-file-mismatch": "Échec, incompatibilité de fichier OTA push",
  "t-push-status-start-capture": "Démarrer la capture",
  "t-push-status-stop": "stop",
  "t-push-status-key-parameter-error": "échec, le paramètre clé est erroné",
  "t-push-status-already-activated": "activé",
  "t-push-status-no-space-left-on-device": "Échec, l’appareil n’a pas assez d’espace de stockage",
  "t-push-status-initkey-failed": "L’alarme de désassemblage du périphérique est ignorée avec succès, mais l’initialisation de la clé échoue.",
  "t-push-status-erase-tamper-failed": "Echec, n’a pas réussi à effacer l’alarme de démontage",
  "t-push-status-close-2nd-sig-failed": "échec, échec de la fermeture de la deuxième signature",
  "t-push-status-open-2nd-sig-failed": "échec, échec de l’ouverture de la deuxième signature",
  "t-push-status-verify-2nd-sig-cert-failed": "Echec,n’a pas réussi à vérifier le certificat de signature secondaire",
  "t-push-status-push-to-pulsar-failed": "échec, échec de la poussée vers Pulsar",
  "t-push-status-push-to-mpush-failed": "échec, échec de la transmission vers mpush",
  "t-push-status-status-push-sp-server-is-busy": "Serveur SP occupé",
  "t-push-status-reverted": "révoqué",
  "t-push-status-factory-setting-cause-no-log": "Échec, la réinitialisation d’usine n’entraîne aucune journalisation",
  "t-push-status-md5-verification-failed": "échec, échec de la vérification MD5",
  "t-push-status-device-offline": "Appareil hors ligne, veuillez réessayer plus tard",
  "t-push-status-mpush-push-to-device-fail": "Mpush n’a pas réussi à pousser vers l’appareil, veuillez réessayer plus tard",
  "t-push-status-download-completed-wait-for-upgrade": "Téléchargement terminé, attente de la mise à niveau",
  "t-push-status-push-event-has-been-fetched": "Événement push obtenu",
  "t-push-status-get-push-event-fail": "Echec, n’a pas réussi à obtenir l’événement push",
  "t-push-status-apk-install-failed-invalid": "échec, push APK invalide",
  "t-push-status-apk-install-failed-system-error": "échec, erreur système lors de l’installation de l’APK",
  "t-push-status-apk-install-failed": "Echec, le stockage de la carte SD est anormal ou insuffisant lors de l’installation de l’APK",
  "t-push-status-apk-install-failed-certificate-mistake": "échec, erreur de certificat lors de l’installation de l’APK",
  "t-push-status-apk-install-failed-other": "échec, échec de l’installation de l’APK, autres raisons",
  "t-push-status-init-key-failed": "échec, échec de l’initialisation de la clé",
  "t-push-status-kiosk-mode-in-progress": "échec, l’appareil domine",
  "t-push-status-network-issue": "Échec, problème de réseau, veuillez réessayer plus tard",
  "t-push-status-network-failed": "failed, l’état du réseau de l’appareil est anormal",
  "t-push-status-unsupported-action": "Échec, le service n’est pas pris en charge par l’appareil",
  "t-push-status-initialization-interupted": "échec, initialisation interrompue",
  "t-push-status-cert-install-failed": "Échec, échec de l’installation du certificat",
  "t-push-status-apk-install-failed-device-os-version-not-support": "a échoué, la version du système d’exploitation ne prend pas en charge la signature V2",
  "t-push-status-invalid-apk-file-caused-signature-failure": "Échec, la signature a échoué en raison d’un fichier APK invalide",
  "t-push-status-device-unusual-status-unactive": "Échec, appareil non activé",
  "t-push-status-device-unusual-status-geoFence": "échec, l’appareil a dépassé geofence",
  "t-push-status-device-unusual-status-regionOut": "Échec, le périphérique dépasse la clôture de la zone nationale",
  "t-push-status-device-unusual-status-tamper": "Échec, l’appareil est à l’état de démontage",
  "t-push-status-device-unusual-status-regionOut-tamper": "Échec, l’appareil est hors de la clôture de la zone nationale et est dans l’état de désassemblage",
  "t-push-status-device-unusual-status-region-geoFence": "Échec, le périphérique a dépassé la clôture de la zone nationale et la géofence",
  "t-push-status-device-unusual-status-under-activation": "Échec, l’appareil est à l’état d’activation en attente",
  "t-push-status-app-not-enable-kiosk-mode": "échec, le mode de domination d’écran n’est pas activé",
  "t-push-status-device-region-geoFence-tamper": "Echec, l’appareil a dépassé la barrière nationale, était dans un état anormal de démontage et a dépassé la géofence",
  "t-push-status-device-geoFence-tamper": "Échec, le périphérique a dépassé la limite géographique et est en état d’exception de démontage",
  "t-push-status-push-has-expired-please-try-again": "La tâche push a expiré, veuillez réessayer",
  "t-push-status-public_key_no_mismatch": "incompatibilité de clé publique de l’appareil",
  "t-push-status-device-upgrading": "ÉCHEC, LA TÂCHE A ÉCHOUÉ CAR L’APPAREIL EST EN COURS DE MISE À NIVEAU.",
  "t-push-status-sp-unavailable-state": "ÉCHEC, SP EN ÉTAT INDISPONIBLE.",
  "t-data-exception-sync-completed": "Les données sont anormales, la synchronisation est terminée",
  "t-data-is-normal-no-need-to-sync": "Les données sont normales, aucune synchronisation n’est requise",
  "t-pubkey-uploaded": "téléchargement de clé publique",
  "t-pubkey-exception-sync-completed": "La clé publique est anormale, la synchronisation est terminée",
  "t-system-param-version": "Version du paramètre système",
  "t-profile": "profil",
  "t-profile-details": "Détails du profil",
  "t-wallpaper-file": "fichier de fond d’écran",
  "t-picture-file": "Démarrer le premier fichier image",
  "t-animation-file": "fichier d’animation de démarrage",
  "t-server-mfm-picture-resolution-not-match": "La résolution de l’image dans l’archive ne correspond pas !",
  "t-server-mfm-picture-format-not-match": "Le téléchargement a échoué et le format de l’image dans l’archive ne correspond pas !",
  "t-server-mfm-boot-animatio-upload-failed": "Le téléchargement a échoué et le contenu du fichier zip ne répond pas aux règles de l’image animée de démarrage !",
  "t-server-mfm-resolution-and-model-version-not-match": "Le téléchargement a échoué, et la résolution et le format du fichier ne correspondent pas à la version du modèle !",
  "t-key-capture-records-status-hsm-error": "Erreur HSM",
  "t-key-capture-records-status-kcv-value-error": "Erreur clé-valeur KCV",
  "t-date-range-90-day": "La plage de dates sélectionnée ne peut pas dépasser 90 jours",
  "t-select-start-end-time": "Vous devez sélectionner une heure de début et une heure de fin",
  "t-In Progress": "中中中",
  "t-Approved": "Approuver",
  "t-action-type": "type d’action",
  "t-client": "Client",
  "t-client-ip": "adresse IP du client",
  "t-add.profile.check.application": "Assurez-vous que l’APK est signé avec succès",
  "t-select.identical.application": "Vous avez sélectionné une application en double",
  "t-log-details": "Description de l’opérande",
  "t-key-capture-records-status-public-key-not-exist": "La clé publique du périphérique n’existe pas",
  "t-log-capture-not-start": "Capture non démarrée",
  "t-log-capture-completed": "Capture terminée",
  "t-log-capture-failed": "Échec de la capture",
  "t-log-capture-capturer": "Saisir",
  "t-plaintext": "texte en clair",
  "t-cipher": "chiffrement",
  "t-bdk-lmk": "BDK / LMK",
  "t-error-match-password": "Le mot de passe est incohérent deux fois",
  "t-ui-settings": "Paramètres de l’interface utilisateur",
  "t-license-mgmt": "Gestion des licences",
  "t-license": "Autorisation",
  "t-license-settings": "Paramètres d’autorisation",
  "t-tamper-authorization-times": "nombre d’autorisations de démontage",
  "t-number-assignable-authorizations": "nombre d’autorisations transférables",
  "t-license-information": "Utilisateur Autorisé",
  "t-allocate-authorization": "Attribuer l’autorisation",
  "t-add-allocate-authorization": "Ajouter une autorisation d’affectation",
  "t-edit-allocate-authorization": "Modifier l’autorisation d’affectation",
  "t-authorization-times": "nombre d’autorisations",
  "t-remaining-times": "Простовання",
  "t-enter-authorization.times": "Entrez le nombre d’autorisations",
  "t-email-use-for-code": "adresse e-mail pour recevoir le code de vérification OTP",
  "t-allocate-authorization-created-successfully": "Autorisation d’affectation {param} créée avec succès !",
  "t-allocate-authorization-updated.successfully": "Mise à jour de l’autorisation d’affectation {param} réussie !",
  "t-allocate-authorization-updated-times-successfully": "Mise à jour réussie du nombre d’autorisations attribuées !",
  "t-error-allocate-authorization-created": "Une erreur s’est produite lors de la création d’une autorisation attribuée",
  "t-error-allocate-authorization-updated": "Une erreur s’est produite lors de la mise à jour de l’autorisation d’affectation",
  "t-error-allocate-authorization-updated.times": "Une erreur s’est produite lors de la mise à jour du nombre d’autorisations attribuées",
  "t-correct": "C’est juste",
  "t-check-kcv-values": "Entrez deux valeurs",
  "t-adb-enable": "ADB",
  "t-bluetooth-enable": "Bluetooth",
  "t-mobile-data-enable": "données mobiles",
  "t-nfc-enable": "NFC",
  "t-hot-spot-enable": "point d’accès",
  "t-on": "ON",
  "t-off": "OFF",
  "t-no-content-selected": "Rien de sélectionné",
  "t-m": "minute",
  "t-action-list": "liste d’actions",
  "t-key-capture-records-sn-repeatedly": "SN ne peut pas être importé de manière répétée",
  "t-key-capture-records-sn-empty": "Sn ne peut pas être vide, et le numéro de série ne peut entrer que des lettres, des chiffres et des barres horizontales",
  "t-key-capture-records-key-value-empty": "LA VALEUR DE LA CLÉ NE PEUT PAS ÊTRE VIDE",
  "t-key-capture-records-kcv-empty": "KCV ne peut pas être vide",
  "t-key-capture-records-device-not-exist": "APPAREIL NON DÉTECTÉ DANS LES CONDITIONS ACTUELLES",
  "t-key-capture-records-sn-not-bound-partner": "SN n’a pas été lié à un partenaire",
  "t-key-capture-records-device-not-belong-user": "L’appareil n’appartient pas à l’utilisateur actuel",
  "t-key-capture-records-device-not-activated": "L’appareil n’est pas activé",
  "t-key-capture-records-key-key-applied-device-model": "La clé ne peut pas être appliquée à ce modèle de périphérique",
  "t-key-capture-records-failed-verify-countries-currencies": "Échec de la vérification des pays et devises pertinents",
  "t-key-capture-records-tid-format-mismatch": "Incompatibilité de format TID",
  "t-key-capture-records-tid-repeated": "TID répété",
  "t-key-capture-records-tid-not-match-country-region": "Le nombre de TIDs et le nombre de devises ne correspondent pas",
  "t-key-capture-records-country-currency-not-empty": "Les pays et les devises ne peuvent pas être vides, car TID n’est pas vide",
  "t-key-capture-records-tid-not-empty": "le pays ou la devise n’est pas vide, le TID ne peut pas être vide",
  "t-key-capture-records-kcv-keyvalue-mismatch": "Erreur clé-valeur KCV",
  "t-expiry-date": "délai d’expiration",
  "t-papers-available": "Простовання",
  "t-out-of-papers": "Plus de papier ou non pris en charge",
  "t-lack-of-paper": "s’il y a pénurie de papier",
  "t-bind-device-information-details": "lier les informations sur l’appareil",
  "t-unbind-device-information-details": "Dissocier les informations de l’appareil",
  "t-device-has-been-bind-partner-file": "L’appareil a été lié à un fichier partenaire (cliquez pour télécharger)",
  "t-device-bind-confirm-info": "Cet appareil est lié à un partenaire. Êtes-vous sûr de vouloir le lier à",
  "t-role-type": "type de rôle",
  "t-user-type": "type d’utilisateur",
  "t-user-source": "source utilisateur",
  "t-json": "JSON",
  "t-excel": "Excel",
  "t-release-notes": "Notes de mise à jour",
  "t-cloud-message": "message cloud",
  "t-select-duration": "Sélectionner une plage d’expiration",
  "t-onboard-merchants": "Marchands enregistrés",
  "t-access-key": "touche d’accès",
  "t-notifications": "notifications",
  "t-signIn" : "Connexion",
  "t-email-userName" : "Courriel / Nom d'utilisateur",
  "t-forgot-password" : "Mot de passe oublié",
  "t-devices" : "appareils",
  "t-manufacturer-name" : "nom du fabricant",
  "t-manipulate" : "opérer",
  "t-firmwares" : "micrologiciels",
  "t-applications" : "applications",
  "t-group-management" : "Gestion de groupe",
  "t-key-capture-event-id" : "ID de l'événement de génération de clé",
  "t-key-capture-records" : "Enregistrements de génération de clé",
  "t-key-capture-records-details" : "Détails des enregistrements de génération de clé",
  "t-search-key-capture-records-details" : "Détails des enregistrements de recherche",
  "t-key-capture-records-status-success" : "succès",
  "t-file-management" : "gestion de fichier",
  "t-ads-reporter" : "Enregistrement des poussées publicitaires",
  "t-push-scheduler" : "Planificateur de poussée",
  "t-device-import" : "Importation d'appareil",
  "t-manufacturer-import" : "Importation du fabricant",
  "t-partner-import" : "Importation des partenaires",
  "t-customer-import" : "Importation de client",
  "t-merchant-import" : "Importation de marchand",
  "t-store-import" : "Importation de magasin",
  "t-key-import" : "Importation de clé",
  "t-device-upstream" : "téléversement d'appareil",
  "t-device-downstream" : "téléchargement d'appareil",
  "t-user-management" : "Gestion des utilisateurs",
  "t-roles-permissions" : "droits d'accès des rôles",
  "t-brands" : "HSM",
  "t-ui-management" : "Gestion de l'interface utilisateur",
  "t-system-params" : "Paramètres du système",
  "t-keys-management" : "Gestion des clés",
  "t-media" : "média",
  "t-import-mgmt" : "Gestion d'importation",
  "t-log-mgmt" : "Gestion des journaux",
  "t-system-mgmt" : "Gestion du système",
  "t-add-device" : "Ajouter un appareil",
  "t-edit-device" : "Éditer l'appareil",
  "t-placeholder-enter-sn" : "Entrez le numéro de série",
  "t-error-enter-sn" : "Le nom de la série est un champ obligatoire",
  "t-error-enter-valid-sn" : "La séquence numéro n'autorise que les lettres majuscules et minuscules, les chiffres et les tirets.",
  "t-error-enter-valid-tid" : "Le TID n'autorise que les lettres majuscules et minuscules, les chiffres et les tirets.",
  "t-error-enter-minlength-sn" : "La longueur de la série numéro ne peut pas être inférieure à 2",
  "t-error-enter-minlength-tid" : "La longueur du TID ne peut pas être inférieure à 2",
  "t-placeholder-enter-imei" : "Entrez l'IMEI",
  "t-update-imei-successfully" : "Mise à jour de l'IMEI réussie",
  "t-error-enter-imei" : "L'IMEI est un champ obligatoire",
  "t-error-enter-minlength-imei" : "La longueur de l'IMEI ne peut pas être inférieure à 2",
  "t-error-enter-valid-imei" : "L'IMEI ne peut contenir que des chiffres",
  "t-error-enter-valid-pusheventid" : "L'ID de l'événement de poussée ne peut contenir que des chiffres",
  "t-activer" : "activer",
  "t-placeholder-enter-tid-name" : "Entrez le nom du TID",
  "t-error-enter-tid-name" : "Le nom TID est obligatoire",
  "t-error-model-version-required" : "La version du modèle est un champ obligatoire",
  "t-save-changes" : "Enregistrer les modifications",
  "t-saving" : "sauvegarder...",
  "t-search-by-model-name" : "Recherche par nom de modèle",
  "t-search-device" : "appareil de recherche",
  "t-bind-devices" : "Appareils liés",
  "t-unbind-devices" : "Désassocier les appareils",
  "t-export-to-excel" : "Exporter vers Excel",
  "t-select-model-version" : "-Version du modèle -",
  "t-search-by-name" : "Recherche par nom",
  "t-all" : "tout",
  "t-search-selected-device" : "Appareil sélectionné de recherche",
  "t-search-available-device" : "recherche.dispositif.disponible",
  "t-required-partner" : "Le partenaire est un élément obligatoire",
  "t-enter-manufacturer" : "Entrez le nom du fabricant",
  "t-loading-dashboard" : "En train de charger le module du tableau de bord...",
  "t-signing-in" : "Connexion en cours...",
  "t-error-manufacturer-required" : "Le nom du fabricant est obligatoire",
  "t-enter-website" : "Entrez l'adresse du site Web",
  "t-error-url-required" : "Veuillez entrer une URL valide",
  "t-select-logo" : "Sélectionner le logo",
  "t-add-manufacturer" : "Ajouter le fabricant",
  "t-edit-manufacturer" : "Éditer le fabricant",
  "t-error-loading-category" : "Une erreur s'est produite lors du chargement de la catégorie",
  "t-error-loading-group" : "Une erreur s'est produite lors du chargement du groupe",
  "t-error-loading-production-batch" : "Une erreur s'est produite lors du chargement du lot de production",
  "t-error-loading-sales-batch" : "Une erreur s'est produite lors du chargement du lot de ventes",
  "t-error-loading-model-version" : "Une erreur s'est produite lors du chargement de la version du modèle",
  "t-error-loading" : "Erreur de chargement",
  "t-timeline-device-title" : "Cycle de vie de l'appareil",
  "t-device-created-successfully" : "L'appareil {sn} a été créé avec succès!",
  "t-error-created-device" : "Une erreur s'est produite lors de l'ajout de l'appareil",
  "t-device-updated-successfully" : "L'appareil {sn} a été mis à jour avec succès!",
  "t-error-updated-device" : "Une erreur s'est produite lors de la mise à jour de l'appareil",
  "t-package-name-required" : "Le nom du paquet est obligatoire",
  "t-submit-kiosk" : "soumettre",
  "t-uninstall-app" : "Désinstaller l'application",
  "t-uninstall-application-successfully" : "L'application a été désinstallée avec succès",
  "t-error-occurred" : "Une erreur s'est produite",
  "t-no-data-avaliable" : "Pas de données disponibles",
  "t-no-data" : "Pas de données",
  "t-no-data-selected" : "Aucune donnée sélectionnée",
  "t-no-firmware-version-in-folder" : "Pas de version de firmware disponible dans ce dossier de firmware",
  "t-lat" : "latitude",
  "t-lng" : "longitude",
  "t-device-out-of-region" : "Cet appareil est sorti de la région. Veuillez vérifier la région où se trouve l'appareil.",
  "t-technical-details" : "détails techniques",
  "t-android-security-level": "Niveau de sécurité Android",
  "t-system-type": "Type de système",
  "t-google-play-system-update": "Mise à jour du système Google Play",
  "t-en" : "EN",
  "t-android-version" : "Version Android",
  "t-base-band-version" : "Version de la bande de base",
  "t-battery-usage" : "Utilisation de la batterie",
  "t-cpu-usage" : "Taux d'utilisation du CPU",
  "t-emv-kernel-version" : "Version du noyau EMV",
  "t-express-pay-kernel-version" : "Version du noyau d'Express Pay",
  "t-ifm-module-name-version" : "Version de la bibliothèque de cartes de contact",
  "t-jspeedy-kernel-version" : "Version du noyau JSpeedy",
  "t-bootloader" : "programme d'amorçage",
  "t-kernel-version" : "Version du noyau",
  "t-pay-pass-kernel-version" : "Version du noyau Pay Pass",
  "t-pay-wave-kernel-version" : "Version du noyau Pay Wave",
  "t-pcd-module-name-version" : "Version de la bibliothèque du lecteur de cartes sans contact",
  "t-platform-type" : "Type de plateforme",
  "t-printer-density" : "Niveau de gris de l'imprimante",
  "t-quics-kernel-version" : "Version du noyau QUICS",
  "t-ram" : "mémoire vive",
  "t-ram-usage" : "Taux d'utilisation de la mémoire",
  "t-screen-density" : "densité d'écran",
  "t-storage" : "stockage",
  "t-storage-usage" : "Utilisation du stockage",
  "t-cortex-scanner-version" : "Version du scanner Cortex",
  "t-signal-type" : "type de signal",
  "t-telecom-operators" : "opérateurs",
  "t-tamper" : "Alerte de démontage de l'appareil",
  "t-tamper-operation" : "Double-cliquez pour désactiver l'opération d'alerte de démontage",
  "t-network-status" : "État du réseau",
  "t-system-status" : "État du système",
  "t-gb" : "GB)",
  "t-device-activated-successfully" : "L'appareil a été activé avec succès!",
  "t-check-device-status" : "Veuillez vérifier si l'appareil fonctionne correctement",
  "t-error-device-updated" : "La mise à jour de l'état de l'appareil a échoué",
  "t-device-status-updated-successfully" : "L'état de l'appareil a été mis à jour avec succès",
  "t-clear-tamper" : "Veuillez d'abord éliminer l'alerte de démontage de l'appareil",
  "t-model-created-successfully" : "Le modèle {sn} a été créé avec succès!",
  "t-model-updated-successfully" : "Le modèle {sn} a été mis à jour avec succès!",
  "t-model-deleted-successfully" : "Le modèle {param} a été supprimé avec succès!",
  "t-error-creating-model" : "Une erreur s'est produite lors de l'ajout du modèle",
  "t-error-loading-model" : "Une erreur s'est produite lors du chargement du modèle",
  "t-error-loading-manufacturers" : "Une erreur s'est produite lors du chargement des fabricants",
  "t-error-loading-manufacturer" : "Une erreur s'est produite lors du chargement du fabricant",
  "t-add-model" : "Ajouter le modèle",
  "t-collapse" : "replier",
  "t-restore" : "restaurer",
  "t-no-result-found" : "Aucun résultat trouvé",
  "t-search-model" : "modèle",
  "t-search-manufacturer" : "fabricant",
  "t-enter-model-name" : "Entrez le nom du modèle",
  "t-model-name-required" : "Le nom du modèle est obligatoire",
  "t-manufacturer-required" : "Le fabricant est un champ obligatoire",
  "t-model-deleted ": "Le modèle a été supprimé avec succès",
  "t-error-deleting-model" : "Une erreur s'est produite lors de la suppression du modèle",
  "t-add-model-version" : "Ajouter la version du modèle",
  "t-edit-model-version" : "édition de la version du modèle",
  "t-image-upload" : "Téléchargement d'image",
  "t-please-upload" : "Veuillez télécharger des images",
  "t-maximum-file-size" : "La taille du fichier ne doit pas dépasser 300 Ko",
  "t-maximum-file-size-6m" : "La taille du fichier ne doit pas dépasser 6 Mo",
  "t-please-upload-file-type" : "Veuillez télécharger des fichiers de type bin, zip",
  "t-please-upload-certificate-file" : "Veuillez télécharger le fichier du certificat",
  "t-please-upload-apk" : "Veuillez télécharger le fichier apk",
  "t-please-upload-dat-zip" : "Veuillez télécharger des fichiers dat ou zip",
  "t-device-binding" : "liaison d'appareil",
  "t-device-unbinding" : "Désassociation de l'appareil",
  "t-enter-version-name" : "Entrer le nom de la version",
  "t-version-name-required" : "Le nom de la version est obligatoire",
  "t-select-year" : "Sélectionner l'année",
  "t-year-required" : "L'année est un champ obligatoire",
  "t-enter-valid-year" : "Veuillez entrer une année valide",
  "t-select-icon" : "Icône de sélection",
  "t-resolution-required" : "La résolution est un champ obligatoire",
  "t-model-required" : "Le modèle est un champ obligatoire",
  "t-search-model-version" : "version du modèle",
  "t-delete-model-version-confirmation" : "Confirmation de suppression de la version du modèle",
  "t-delete-model-version" : "Êtes-vous sûr de vouloir supprimer la version du modèle - {param}?",
  "t-error-deleting-model-version" : "Une erreur s'est produite lors de la suppression de la version du modèle",
  "t-select-valid-model" : "Veuillez sélectionner un modèle valide",
  "t-confirm-delete-operation" : "Confirmer l'opération de suppression",
  "t-warning-to-delete" : "Êtes-vous sûr de vouloir supprimer - {param}? ",
  "t-manufacturer-deleted" : "Le fabricant {param} a été supprimé avec succès!",
  "t-model-version-deleted" : "La version du modèle {param} a été supprimée avec succès!",
  "t-mfa-configuration" : "Paramètres des partenaires",
  "t-error-fill-mandatory-fields" : "Veuillez remplir tous les champs obligatoires",
  "t-processing" : "En cours de traitement",
  "t-reset-email-sent" : "Un e-mail de réinitialisation du mot de passe a été envoyé",
  "t-delete-model-confirmation" : "Confirmation de suppression du modèle",
  "t-delete-confirmation-model" : "Êtes-vous sûr de vouloir supprimer le modèle - {param}?",
  "t-device-deleted-successfully" : "L'appareil {param} a été supprimé avec succès!",
  "t-error-deleted-device" : "Une erreur s'est produite lors de la suppression de l'appareil",
  "t-error-loading-devices" : "Une erreur s'est produite lors du chargement des appareils",
  "t-no-response-from-device" : "Aucune réponse de l'appareil",
  "t-installed-applications" : "Applications installées",
  "t-add-application" : "Ajouter une application",
  "t-edit-application" : "édition d'application",
  "t-add-application-version" : "Ajouter la version de l'application",
  "t-edit-application-version" : "Version de l'application d'édition",
  "t-application-version-saved-successfully" : "La version de l'application {param} a été enregistrée avec succès!",
  "t-application-version-updated-successfully" : "La version de l'application {param} a été mise à jour avec succès!",
  "t-search-application-version" : "Version de l'application",
  "t-application-device-name" : "nom de l'application",
  "t-version-name" : "nom de la version",
  "t-select-valid-application" : "Veuillez sélectionner une application valide",
  "t-delete-application-version-confirmation" : "Confirmation de suppression de la version de l'application",
  "t-warning-delete-application-version" : "Êtes-vous sûr de vouloir supprimer la version de l'application - {param}?",
  "t-application-version-deleted" : "La version de l'application {param} a été supprimée avec succès!",
  "t-error-deleting-application-version" : "Une erreur s'est produite lors de la suppression de la version de l'application",
  "t-error-application-name-required" : "Le nom de l'application est obligatoire",
  "t-error-application-pattern" : "Le nom de l'application est composé de lettres, de chiffres, de traits de soulignement, de points et d'espaces. Il ne peut pas commencer ou finir par un espace.",
  "t-placeholder-enter-application-name" : "Entrez le nom de l'application",
  "t-placeholder-enter-application-description" : "输入应用程序描述",
  "t-error-loading-application" : "Une erreur s'est produite lors du chargement de l'application",
  "t-application-created-successfully" : "L'application {param} a été créée avec succès!",
  "t-error-created-application" : "Une erreur s'est produite lors de la création de l'application",
  "t-application-updated-successfully" : "L'application {param} a été mise à jour avec succès!",
  "t-error-updated-application" : "Une erreur s'est produite lors de la mise à jour de l'application",
  "t-application-version-file" : "Fichier de version de l'application",
  "t-select-application-file" : "Sélectionner le fichier de l'application",
  "t-placeholder-enter-application-version-name" : "Entrez le nom de la version",
  "t-error-application-version-required" : "Le nom de la version de l'application est obligatoire",
  "t-error-application-version-pattern" : "Le nom de la version de l'application est composé de lettres, de chiffres, de soulignements, de points et d'espaces et ne peut pas commencer ou se terminer par un espace",
  "t-error-application-required" : "L'application est obligatoire",
  "t-error-loading-application-version" : "Une erreur s'est produite lors du chargement de la version de l'application",
  "t-error-created-application-version" : "Une erreur s'est produite lors de la création de la version de l'application",
  "t-error-updated-application-version" : "Une erreur s'est produite lors de la mise à jour de la version de l'application",
  "t-select-certificate" : "Sélectionner le certificat",
  "t-select-certificate-to-signed" : "Veuillez sélectionner le certificat à utiliser",
  "t-application-deleted-successfully" : "L'application {param} a été supprimée avec succès!",
  "t-error-deleting-application" : "Une erreur s'est produite lors de la suppression de l'application",
  "t-application-choose-type" : "Veuillez choisir le type de téléchargement de {param}",
  "t-cannot-submit-repeatedly" : "Ne peut pas soumettre à plusieurs reprises",
  "t-activate-kiosk" : "Activer l'écran de domination",
  "t-deactivate-kiosk" : "Fermer l'écran monopolisé",
  "t-activate-kiosk-mode" : "Activer le mode d'écran exclusif",
  "t-deactivate-kiosk-mode" : "Désactiver le mode kiosque",
  "t-device-is-out-of-range-activation-failed" : "L'appareil est hors de portée, l'activation a échoué",
  "t-actions" : "opérations",
  "t-device-bulk-upload" : "Importer en masse des appareils",
  "t-manufacturer-bulk-upload" : "Importer en masse les fabricants",
  "t-partner-bulk-upload" : "Importer en masse les partenaires",
  "t-customer-bulk-upload" : "Importer en masse les clients",
  "t-merchant-bulk-upload" : "Importer en masse les commerçants",
  "t-store-bulk-upload" : "Importer en masse le magasin",
  "t-cortex-scanner-bulk-upload" : "Importation en masse du Cortex Scanner",
  "t-import-devices" : "Importer des appareils",
  "t-from-date" : "date de début",
  "t-to-date" : "date de fin",
  "t-error-from-date-required" : "La date de début est obligatoire",
  "t-error-to-date-required" : "La date de fin est obligatoire",
  "t-state" : "état",
  "t-delete-device-confirmation" : "Confirmation de suppression d'appareil",
  "t-warning-to-delete-device" : "Êtes-vous sûr de vouloir supprimer l'appareil - {param}?",
  "t-warning-to-recover-device" : "Êtes-vous sûr de vouloir désactiver l'alerte de démontage de l'appareil?",
  "t-confirm-to-lock-device" : "Êtes-vous sûr de vouloir déverrouiller l'appareil?",
  "t-delete-activated-device" : "Impossible de supprimer l'appareil activé",
  "t-cannot-delete-device-has-tid" : "Impossible de supprimer l'appareil avec TID",
  "t-delete-device" : "Supprimer l'appareil",
  "t-add-transaction-param" : "Ajouter les paramètres de transaction",
  "t-add-transaction-param-version" : "Ajouter la version des paramètres de transaction",
  "t-search-transaction-param" : "paramètre de transaction",
  "t-search-transaction-param-version" : "Version des paramètres de transaction",
  "t-transaction-param-version" : "Version des paramètres de transaction",
  "t-total-version" : "version totale",
  "t-add-partner" : "Ajouter un partenaire",
  "t-search-push" : "Enregistrement de la poussée",
  "t-search-partner" : "partenaire",
  "t-add-customer" : "Ajouter un client",
  "t-search-customer" : "client",
  "t-edit-transaction-param" : "Modifier les paramètres de transaction",
  "t-error" : "erreur",
  "t-error-loading-template" : "Une erreur s'est produite lors du chargement du modèle",
  "t-error-creating-template" : "Une erreur s'est produite lors de la création du modèle",
  "t-error-update-template" : "Une erreur s'est produite lors de la mise à jour du modèle",
  "t-invalid-json" : "JSON invalide",
  "t-validate" : "vérifier",
  "t-template-updated-successfully" : "Les paramètres de transaction {param} ont été mis à jour avec succès!",
  "t-template-created-successfully" : "Les paramètres de transaction {param} ont été créés avec succès!",
  "t-enter-transaction-paramName" : "Entrez le nom du paramètre de transaction",
  "t-required-transaction-name" : "Le nom du paramètre de transaction est obligatoire",
  "t-transaction-name-criteria" : "Le nom des critères de transaction ne peut contenir que des lettres, des chiffres, des traits de soulignement, des points et des espaces, et ne peut pas commencer ou se terminer par un espace",
  "t-action-code" : "code d'opération",
  "t-required-transaction-action-code" : "Le code d'action des paramètres de transaction est obligatoire",
  "t-min-transaction-action-code" : "Le code d'action des paramètres de transaction doit être supérieur à 200",
  "t-max-transaction-action-code" : "Le code d'action des paramètres de transaction doit être inférieur à 299",
  "t-pattern-transaction-action-code" : "Le code d'action des paramètres de transaction ne peut être que numérique",
  "t-enter-action-code" : "Code d'action d'entrée",
  "t-transaction-deleted-successfully" : "Le paramètre de transaction {param} a été supprimé avec succès!",
  "t-error-deleting-transaction" : "Une erreur s'est produite lors de la suppression des paramètres de transaction",
  "t-error-deleting-transaction-child" : "Il existe des versions de paramètres de transaction sous les paramètres de transaction. Veuillez supprimer les versions de paramètres de transaction d'abord!",
  "t-edit-transaction-param-version" : "Modifier la version des paramètres de transaction",
  "t-enter-transaction-param-version-name" : "Entrer le nom de la version des paramètres de transaction",
  "t-error-transaction-param-version-required" : "La version du paramètre de transaction est obligatoire",
  "t-enter-intent-name" : "Entrez le nom de l'intention",
  "t-enter-file-name" : "Entrez le nom du fichier",
  "t-error-loading-template-param-version" : "Une erreur s'est produite lors du chargement de la version des paramètres de transaction",
  "t-template-version-updated-successfully" : "La version des paramètres de transaction {param} a été mise à jour avec succès!",
  "t-template-version-created-successfully" : "La version des paramètres de transaction {param} a été créée avec succès!",
  "t-error-creating-transaction-param-version" : "Une erreur s'est produite lors de la création de la version des paramètres de transaction",
  "t-error-updating-transaction-param-version" : "Une erreur s'est produite lors de la mise à jour de la version du paramètre de transaction",
  "t-groups" : "groupes",
  "t-search-group" : "groupe",
  "t-add-group" : "Ajouter un groupe",
  "t-edit-group" : "groupe d'édition",
  "t-search-group-device" : "Appareils au sein du groupe de recherche",
  "t-group-name-required" : "Le nom du groupe est obligatoire",
  "t-group-name-pattern" : "Le nom du groupe ne peut contenir que des lettres, des chiffres, des traits de soulignement, des points et des espaces, et ne peut pas commencer ou finir par un espace",
  "t-enter-group-name" : "Entrez le nom du groupe",
  "t-group-created-successfully" : "Le groupe {param} a été créé avec succès!",
  "t-error-group-created" : "Une erreur s'est produite lors de la création du groupe",
  "t-group-updated-successfully" : "Le groupe {param} a été mis à jour avec succès!",
  "t-error-group-updated" : "Une erreur s'est produite lors de la mise à jour du groupe",
  "t-drag-device-to-group" : "Faites glisser l'appareil de la liste disponible vers la liste sélectionnée",
  "t-to" : "à",
  "t-device-update" : "mise à jour de l'appareil",
  "t-updated-group-device-successfully" : "Le groupe {param} a été mis à jour avec succès!",
  "t-please-enter-name" : "Veuillez entrer le nom",
  "t-minimum-radius" : "Le rayon minimum doit être de 50",
  "t-maximum-radius" : "Le rayon maximal doit être de 9999",
  "t-duration-in-hours" : "Durée (en heures)",
  "t-please-enter-duration" : "Veuillez saisir la durée",
  "t-minimum-duration" : "La durée minimale doit être de 0",
  "t-maximum-duration" : "La durée maximale doit être de 72",
  "t-please-enter-action" : "Veuillez entrer l'action",
  "t-already-have-lock-action" : "Si une opération de verrouillage existe déjà, la durée de l'opération d'avertissement doit être inférieure à la durée de verrouillage, car l'appareil cessera d'effectuer toute opération supplémentaire après l'opération de verrouillage",
  "t-add-locak-action-info" : "Si vous ajoutez une action de verrouillage, la durée doit être supérieure à la durée la plus récente, car si vous choisissez l'action de verrouillage, l'appareil cessera d'effectuer toute opération supplémentaire après cette opération",
  "t-invalid-warning-message" : "Message d'avertissement invalide",
  "t-invalid-action" : "opération invalide",
  "t-invalid-duration" : "Durée invalide",
  "t-geo-fence-created-successfully" : "La clôture géographique {param} a été créée avec succès",
  "t-error-geo-fence-created" : "Une erreur s'est produite lors de la création de la clôture géographique",
  "t-geo-fence-updated-successfully" : "La clôture géographique {param} a été mise à jour avec succès",
  "t-error-geo-fence-updated" : "Une erreur s'est produite lors de la mise à jour de la clôture géographique",
  "t-category-name" : "nom de catégorie",
  "t-model-version-name" : "Nom de la version du modèle",
  "t-production-batch-name" : "nom du lot de production",
  "t-sales-batch-name" : "nom du lot de vente",
  "t-select-valid-transaction-param" : "Veuillez sélectionner des paramètres de transaction valides",
  "t-delete-transaction-param-version-confirmation" : "删除交易参数版本确认",
  "t-warning-delete-transaction-param-version" : "Êtes-vous sûr de vouloir supprimer la version du paramètre de transaction - {param}?",
  "t-transaction-param-version-deleted-successfully" : "La version du paramètre de transaction {param} a été supprimée avec succès! ",
  "t-error-deleting-transaction-param-version" : "Une erreur s'est produite lors de la suppression de la version du paramètre de transaction",
  "t-please-check-values" : "Veuillez entrer deux valeurs",
  "t-check-value" : "valeur de contrôle",
  "t-error-check-value" : "Une erreur s'est produite lors de la vérification de la valeur",
  "t-error-combine-keys" : "Une erreur s'est produite lors de la combinaison des clés",
  "t-error-invalid-key-check" : "La valeur KCV n'est pas correcte",
  "t-error-loading-checking-key" : "Une erreur s'est produite lors du chargement de la clé de vérification",
  "t-form-invalid-fill-mandatory" : "Le formulaire est invalide. Veuillez remplir les champs obligatoires",
  "t-create-key" : "créer la clé",
  "t-error-creating-key" : "Une erreur s'est produite lors de la création de la clé",
  "t-key-created-successfully" : "La clé {param} a été créée avec succès!",
  "t-error-key-created" : "Une erreur s'est produite lors de la création de la clé",
  "t-add-key" : "Ajouter la clé",
  "t-edit-key" : "clé d'édition",
  "t-error-loading-created" : "Une erreur s'est produite lors du chargement de la clé",
  "t-error-loading-algorithms" : "Une erreur s'est produite lors du chargement des algorithmes",
  "t-error-loading-partner" : "Une erreur s'est produite lors du chargement du partenaire",
  "t-error-loading-keys" : "Une erreur s'est produite lors du chargement des clés",
  "t-key-deleted-successfully" : "La clé {param} a été supprimée avec succès!",
  "t-error-deleting-key" : "Une erreur s'est produite lors de la suppression de la clé",
  "t-key-name-criteria" : "Le nom de la clé ne peut contenir que des lettres, des chiffres et des traits de soulignement et ne peut pas commencer ou se terminer par un espace.",
  "t-delete-key-confirmation" : "Supprimer la clé",
  "t-warning-delete-key" : "Êtes-vous sûr de vouloir supprimer la clé - {param}?",
  "t-zeros-not-allowed" : "Les zéros ne sont pas autorisés",
  "t-enter-key-name" : "Entrez le nom de la clé",
  "t-required-key-name" : "Le nom de la clé est obligatoire",
  "t-enter-index" : "Index d'entrée",
  "t-required-index" : "L'index est obligatoire",
  "t-only-allowed-positive-integer-index" : "Seuls les entiers positifs sont autorisés",
  "t-index-max" : "La valeur d'index ne peut pas dépasser 255",
  "t-select-date" : "Sélectionner la date",
  "t-select-customer" : "Sélectionner le client",
  "t-select-merchant" : "Sélectionner le marchand",
  "t-select-store" : "Choisir le magasin",
  "t-enter-key-group" : "Entrer le groupe de clés",
  "t-required-key-group" : "Le groupe de clés est un élément requis",
  "t-required-encrypted-key-under" : "La clé de chiffrement est obligatoire.",
  "t-enter-key-value" : "Entrer la valeur de la clé",
  "t-required-key-value-1" : "La valeur de la clé 1 est obligatoire",
  "t-key-kcv" : "KCV",
  "t-key-bdk-lmk" : "BDK / LMK",
  "t-key-zmk-lmk" : "ZMK / LMK",
  "t-key-lmk" : "Clé LMK",
  "t-required-key-kcv-1" : "KCV1 est un élément obligatoire",
  "t-expiry-date-greater-than-current-date" : "La date d'expiration doit être supérieure à la date actuelle",
  "t-error-loading-key" : "Une erreur s'est produite lors du chargement de la clé",
  "t-partners" : "partenaires",
  "t-keys" : "clés",
  "t-key-name" : "Nom de la clé",
  "t-is-required" : "Champ obligatoire",
  "t-enter-kcv" : "Entrée KCV",
  "t-final-key" : "clé finale",
  "t-full-apk" : "Paquet complet",
  "t-patch-file" : "Paquet de différences",
  "t-application-certificate-message" : "Selon le certificat d'approbation du client, la liste des équipements est affichée",
  "t-error-patch-file-fail" : "La génération du paquet de différences APK a échoué",
  "t-create-patch-file-success" : "Le paquet de différences APK a été généré avec succès et la poussée a commencé. Veuillez vous rendre au rapport de poussée pour obtenir l'état détaillé",
  "t-create-patch-file" : "Commencer à générer le paquet de différences",
  "t-required-type" : "Le type est obligatoire",
  "t-required-version" : "Le numéro de version est obligatoire",
  "t-list-group" : "Liste de groupes",
  "t-list-device" : "Liste des appareils",
  "t-list-" : "Liste",
  "t-search-by-serial-number" : "Rechercher l'appareil par numéro de série",
  "t-sort" : "Trier",
  "t-sort-asc" : "Croissant",
  "t-sort-desc" : "Décroissant",
  "t-sort-devices" : "Appareils de tri",
  "t-uploading" : "en cours de téléchargement",
  "t-please-select-group-devices" : "Veuillez sélectionner un groupe ou un appareil",
  "t-error-push-group-empty" : "Le groupe sélectionné ne contient aucun équipement!",
  "t-error-push-group-empty-by-model-version" : "Le groupe sélectionné ne contient pas d'équipement dont la version du modèle est {param}!",
  "t-error-push-group-store-empty" : "Les équipements du groupe sélectionné n'ont pas de magasin lié!",
  "t-error-key-formation" : "Erreur de format de la clé",
  "t-key-generation" : "Génération de clé",
  "t-error-push-operation" : "Certains équipements peuvent rencontrer des problèmes lors de l'opération de push.",
  "t-error-push-device-inactive" : "L'envoi a échoué. Il y a des appareils non activés parmi les appareils sélectionnés",
  "t-error-push-device-abnormal" : "L'envoi a échoué, il existe des appareils dans l'état anormal parmi les appareils sélectionnés",
  "t-push-completed-successfully" : "La poussée {param} a réussi",
  "t-push-batch-completed-successfully" : "Le message {param} a été poussé avec succès. Veuillez obtenir plus d'informations détaillées dans les enregistrements de poussée.",
  "t-push-device-certificate-unpush" : "{param} a été retiré du partenaire et ne sera plus poussé",
  "t-went-wrong" : "Erreur survenue",
  "t-add-folder" : "Ajouter un dossier",
  "t-edit-folder" : "Modifier le dossier",
  "t-required-file-name" : "Le nom du fichier est obligatoire",
  "t-file-name-pattern" : "Le nom du fichier n'est pris en charge que par les lettres, les chiffres, le trait de soulignement et le trait d'union",
  "t-select-file-type" : "Sélectionner le type de fichier",
  "t-select-file" : "Sélectionner le fichier",
  "t-maximum-folder-file-size" : "La taille du fichier ne doit pas dépasser 100 Mo",
  "t-error-loading-folder" : "Une erreur s'est produite lors du chargement du dossier",
  "t-error-creating-folder" : "Une erreur s'est produite lors de la création du dossier",
  "t-error-updating-folder" : "Une erreur s'est produite lors de la mise à jour du dossier",
  "t-folder-created-successfully" : "Le dossier {param} a été créé avec succès!",
  "t-folder-updated-successfully" : "Le dossier {param} a été mis à jour avec succès!",
  "t-folder-deleted-successfully" : "Le dossier {param} a été supprimé avec succès!",
  "t-required-folder-name" : "Le nom du dossier est obligatoire",
  "t-folder-name-pattern" : "Le nom du dossier ne prend en charge que les lettres, les chiffres, le trait de soulignement et le trait d'union",
  "t-select-partner" : "Choisir un partenaire",
  "t-warning-delete-folder" : "Êtes-vous sûr de vouloir supprimer {param}?",
  "t-enter-folder-name" : "Entrez le nom du dossier",
  "t-error-deleting-file" : "Une erreur s'est produite lors de la suppression du fichier",
  "t-file-deleted-successfully" : "Le fichier {param} a été supprimé avec succès!",
  "t-select-folder" : "Veuillez sélectionner un dossier valide",
  "t-error-select-file" : "Veuillez sélectionner une image conforme à l'un des formats {param}",
  "t-error-select-file-video" : "Veuillez sélectionner une vidéo conforme à l'un des formats {param}",
  "t-file-created-successfully" : "Le fichier {param} a été créé avec succès",
  "t-create-file" : "Ajouter un fichier",
  "t-create-folder" : "Ajouter un dossier",
  "t-file-creation-failed" : "Échec de la création du fichier",
  "t-file-updated-successfully" : "Le fichier a été mis à jour avec succès",
  "t-file-updated-failed" : "Une erreur s'est produite lors de la mise à jour du fichier",
  "t-warning-delete-file" : "Êtes-vous sûr de vouloir supprimer le fichier - {param}?",
  "t-add-file" : "Ajouter un fichier",
  "t-edit-file" : "Modifier le fichier",
  "t-search-file" : "fichier",
  "t-search-advertisement" : "publicité",
  "t-preview" : "aperçu",
  "t-file-uploaded-failed" : "Échec du téléchargement du fichier",
  "t-file-uploaded-successfully" : "Le fichier a été téléversé avec succès",
  "t-select-role" : "Choisir le rôle",
  "t-add-role" : "Ajouter un rôle",
  "t-edit-role" : "rôle d'édition",
  "t-delete-role" : "Supprimer le rôle",
  "t-delete-role-successfully" : "Le rôle - {param} a été supprimé avec succès!",
  "t-widget-settings" : "Paramètres du widget",
  "t-enter-role-name" : "Entrez le nom du rôle",
  "t-required-role-name" : "Le nom du rôle est obligatoire",
  "t-role-name-criteria" : "Le nom du rôle ne peut contenir que des lettres, des chiffres, des traits de soulignement, des points et des espaces, et ne peut pas commencer ou finir par un espace",
  "t-role-created-successfully" : "Le rôle {param} a été créé avec succès!",
  "t-error-creating-role" : "Une erreur s'est produite lors de la création du rôle",
  "t-role-updated-successfully" : "Le rôle {param} a été mis à jour avec succès!",
  "t-error-updating-role" : "Une erreur s'est produite lors de la mise à jour du rôle",
  "t-permissions-updated-successfully" : "Les autorisations ont été mises à jour avec succès",
  "t-permissions-error-updated" : "Une erreur s'est produite lors de la mise à jour des autorisations",
  "t-permissions-updated-error" : "Une erreur s'est produite lors de la mise à jour des autorisations",
  "t-permission" : "autorisation",
  "t-browser-local-time" : "heure locale du navigateur",
  "t-panel-name" : "Nom du panneau",
  "t-add-system-param" : "Ajouter les paramètres du système",
  "t-edit-system-param" : "Paramètres du système d'édition",
  "t-search-system-param" : "Paramètres du système de recherche",
  "t-enter-system-param-name" : "Entrer le nom du paramètre du système",
  "t-required-system-param" : "Le nom du paramètre du système est obligatoire",
  "t-error-loading-system-param" : "Une erreur s'est produite lors du chargement des paramètres du système",
  "t-system-param-created-successfully" : "Le paramètre du système {param} a été créé avec succès! ",
  "t-error-creating-system-param" : "Une erreur s'est produite lors de la création des paramètres du système",
  "t-system-param-updated-successfully" : "Le paramètre du système {param} a été mis à jour avec succès! ",
  "t-error-updating-system-param" : "Une erreur s'est produite lors de la mise à jour des paramètres du système",
  "t-system-param-deleted-successfully" : "Le paramètre du système {param} a été supprimé avec succès! ",
  "t-error-deleting-system-param" : "Une erreur s'est produite lors de la suppression du paramètre du système",
  "t-enter-system-param-version-name" : "Entrer le nom de la version des paramètres du système",
  "t-required-system-param-verion" : "La version du paramètre du système est obligatoire",
  "t-system-param-name-criteria" : "Le nom de la version du paramètre du système ne peut contenir que des lettres, des chiffres, des traits de soulignement, des points et des espaces, et ne peut pas commencer ou finir par un espace",
  "t-add-system-param-version" : "Ajouter la version des paramètres du système",
  "t-edit-system-param-version" : "Modifier la version des paramètres du système",
  "t-error-loading-system-param-version" : "Erreur lors du chargement de la version des paramètres du système",
  "t-system-param-version-created-successfully" : "La version du paramètre du système {param} a été créée avec succès! ",
  "t-error-creating-system-param-version" : "Une erreur s'est produite lors de la création de la version des paramètres du système",
  "t-search-system-param-version" : "Version des paramètres du système de recherche",
  "t-select-valid-system-param-version" : "Veuillez sélectionner un paramètre système valide",
  "t-delete-system-param-version-confirmation" : "Confirmation de suppression de la version des paramètres du système",
  "t-warning-delete-system-param-version" : "Êtes-vous sûr de vouloir supprimer la version du paramètre système - {param}?",
  "t-system-param-version-deleted-successfully" : "La version du paramètre du système {param} a été supprimée avec succès!",
  "t-error-deleting-system-param-version" : "Une erreur s'est produite lors de la suppression de la version du paramètre système",
  "t-add-ui-settings" : "Ajouter les paramètres de l'interface utilisateur",
  "t-edit-ui-settings" : "Paramètres de l'interface utilisateur d'édition",
  "t-error-loading-ui-settings" : "Une erreur s'est produite lors du chargement des paramètres de l'interface utilisateur",
  "t-error-creating-ui-settings" : "Une erreur s'est produite lors de la création des paramètres de l'interface utilisateur",
  "t-error-updating-ui-settings" : "Une erreur s'est produite lors de la mise à jour des paramètres de l'interface utilisateur",
  "t-ui-settings-created" : "Les paramètres de l'interface utilisateur {param} ont été créés avec succès!",
  "t-ui-settings-updated" : "Les paramètres de l'interface utilisateur {param} ont été mis à jour avec succès!",
  "t-enter-ui-settings-name" : "Entrer le nom des paramètres de l'interface utilisateur",
  "t-required-ui-settings" : "Le nom des paramètres d'interface utilisateur est obligatoire",
  "t-error-description-pattern" : "La description ne peut contenir que des lettres, des chiffres, des traits de soulignement, des points et des espaces, et ne peut pas commencer ou se terminer par un espace",
  "t-enter-ui-settings-description" : "Description des paramètres de l'interface utilisateur d'entrée",
  "t-required-ui-settings-action" : "L'opération de configuration de l'interface utilisateur est obligatoire",
  "t-file-type" : "type de fichier",
  "t-search-ui-settings" : "Paramètres de l'interface utilisateur de recherche",
  "t-error-deleting-ui-settings" : "Une erreur s'est produite lors de la suppression des paramètres de l'interface utilisateur",
  "t-ui-settings-deleted-successfully" : "Les paramètres de l'interface utilisateur {param} ont été supprimés avec succès!",
  "t-no-preview-available-zip" : "Le fichier ZIP n'est pas disponible en prévisualisation",
  "t-no-preview-available-file" : "Le format de ce fichier n'est pas pris en charge pour l'aperçu",
  "t-no-preview-available-video" : "Le fichier vidéo n'est pas disponible en prévisualisation",
  "t-browser-not-support-video-tags" : "Votre navigateur ne prend pas en charge les balises vidéo",
  "t-preview-ui-settings" : "Paramètres de l'interface utilisateur de prévisualisation",
  "t-download-failed" : "Échec du téléchargement",
  "t-add-ui-settings-version" : "Ajouter la version des paramètres de l'interface utilisateur",
  "t-pushable" : "poussable",
  "t-ui-settings-version" : "Version des paramètres de l'interface utilisateur",
  "t-please-select-valid-setting" : "Veuillez sélectionner un paramètre valide",
  "t-warning-delete-ui-setting-version" : "Êtes-vous sûr de vouloir supprimer la version des paramètres d'interface utilisateur - {param}?",
  "t-confirmation-delete-ui-settings-version" : "Confirmation de la suppression de la version des paramètres de l'interface utilisateur",
  "t-ui-settings-version-deleted-successfully" : "La version des paramètres de l'interface utilisateur {param} a été supprimée avec succès!",
  "t-error-deleting-ui-settings-version" : "Une erreur s'est produite lors de la suppression de la version des paramètres de l'interface utilisateur",
  "t-enter-description" : "description d'entrée",
  "t-required-ui-setting" : "Le paramètre d'interface utilisateur est obligatoire",
  "t-ui-setting-version-file" : "Fichier de version des paramètres de l'interface utilisateur",
  "t-select-setting-file" : "Sélectionner le fichier de paramètres",
  "t-ui-setting-version" : "Version des paramètres de l'interface utilisateur",
  "t-add-ui-setting-version" : "Ajouter la version des paramètres de l'interface utilisateur",
  "t-edit-ui-setting-version" : "Éditer la version des paramètres de l'interface utilisateur",
  "t-file-resolution-does-not-match" : "La résolution du fichier ne correspond pas à la résolution du modèle",
  "t-file-type-does-not-match": "Veuillez télécharger le bon fichier",
  "t-file-read-failed": "La lecture du fichier a échoué, veuillez le télécharger à nouveau",
  "t-ui-setting-version-file-type" : "Veuillez télécharger un fichier {param}",
  "t-error-loading-setting-version" : "Une erreur s'est produite lors du chargement de la version des paramètres de l'interface utilisateur",
  "t-ui-setting-version-saved-successfully" : "La version de configuration de l'interface utilisateur {param} a été enregistrée avec succès!",
  "t-ui-setting-version-updated-successfully" : "La version des paramètres de l'interface utilisateur {param} a été mise à jour avec succès!",
  "t-error-creating-ui-settings-version" : "Une erreur s'est produite lors de la création de la version des paramètres de l'interface utilisateur",
  "t-error-updating-ui-settings-version" : "Une erreur s'est produite lors de la mise à jour de la version des paramètres de l'interface utilisateur",
  "t-delete-brand" : "Supprimer les paramètres HSM",
  "t-marque" : "HSM paramètres",
  "t-search-brand" : "Rechercher les paramètres HSM",
  "t-add-brand" : "Ajouter les paramètres HSM",
  "t-edit-brand" : "Modifier les paramètres HSM",
  "t-warning-delete-model" : "Êtes-vous sûr de vouloir supprimer le modèle - {param}?",
  "t-error-loading-brands" : "Une erreur s'est produite lors du chargement des paramètres HSM",
  "t-brand-created-successfully" : "HSM {param} créé avec succès!",
  "t-error-creating-brand" : "Une erreur s'est produite lors de la création des paramètres HSM",
  "t-brand-updated-successfully" : "HSM {param} mis à jour avec succès!",
  "t-error-updating-brand" : "Une erreur s'est produite lors de la mise à jour des paramètres HSM",
  "t-brand-deleted-successfully" : "HSM {param} a été supprimé avec succès!",
  "t-error-deleting-brand" : "Une erreur s'est produite lors de la suppression des paramètres HSM",
  "t-enter-brand-name" : "Entrez le nom de la configuration HSM",
  "t-required-brand-name" : "Le nom de configuration HSM est obligatoire",
  "t-edit-model" : "modèle d'édition",
  "t-error-updating-model" : "Une erreur s'est produite lors de la mise à jour du modèle",
  "t-spec-url" : "Url de spécification",
  "t-enter-spec-url" : "Url de spécification d'entrée",
  "t-required-spec-url" : "Veuillez entrer une URL de spécification valide",
  "t-hsm-brand" : "Marque Hsm",
  "t-add-interface" : "Ajouter l'interface",
  "t-edit-interface" : "interface d'édition",
  "t-error-loading-interfaces" : "Une erreur s'est produite lors du chargement des interfaces",
  "t-interface-created-successfully" : "L'interface {param} a été créée avec succès!",
  "t-error-creating-interface" : "Une erreur s'est produite lors de la création de l'interface",
  "t-interface-updated-successfully" : "L'interface {param} a été mise à jour avec succès!",
  "t-error-updating-interface" : "Une erreur s'est produite lors de la mise à jour de l'interface",
  "t-search-interface" : "interface de recherche",
  "t-enter-interface-name" : "Entrez le nom de l'interface d'entrée",
  "t-required-interface-name" : "Le nom de l'interface est obligatoire",
  "t-enter-user-name" : "Entrez le nom d'utilisateur",
  "t-required-user-name" : "Veuillez entrer un nom d'utilisateur valide",
  "t-required-password" : "Veuillez entrer un mot de passe valide",
  "t-enter-primary-host" : "Entrez l'adresse de l'hôte principal",
  "t-required-primary-host" : "Veuillez saisir une adresse d'hôte valide",
  "t-enter-primary-port" : "Entrer le port principal",
  "t-required-primary-port" : "Veuillez saisir un numéro de port hôte valide",
  "t-enter-secondary-host" : "Entrez l'adresse de l'hôte secondaire",
  "t-required-secondary-host" : "Veuillez saisir une adresse de serveur secondaire valide",
  "t-enter-secondary-port" : "Entrée du port secondaire",
  "t-required-secondary-port" : "Veuillez saisir un numéro de port d'hôte secondaire valide",
  "t-is-enable" : "Est-ce activé",
  "t-select-valid-interface" : "Veuillez sélectionner une interface valide",
  "t-delete-interface-confirmation" : "Confirmation de suppression d'interface",
  "t-warning-delete-interface" : "Êtes-vous sûr de vouloir supprimer l'interface - {param}?",
  "t-delete-interface" : "Supprimer l'interface",
  "t-interface-deleted-successfully" : "L'interface {param} a été supprimée avec succès!",
  "t-error-deleting-interface" : "Une erreur s'est produite lors de la suppression de l'interface",
  "t-partner-name" : "Nom du partenaire",
  "t-enable-2FA" : "Activer l'OTP",
  "t-enable-signature" : "Activer la signature",
  "t-enable-remote-control" : "le contrôle à distance",
  "t-partner-setting" : "Paramètres du partenaire",
  "t-search-user" : "utilisateur",
  "t-add-user" : "Ajouter un utilisateur",
  "t-edit-user" : "Modifier l'utilisateur",
  "t-error-creating-user" : "Une erreur s'est produite lors de la création de l'utilisateur",
  "t-user-created-successfully" : "L'utilisateur {param} a été créé avec succès!",
  "t-error-updating-user" : "Une erreur s'est produite lors de la mise à jour de l'utilisateur",
  "t-required-email" : "L'adresse e-mail est obligatoire",
  "t-enter-correct-email" : "Veuillez entrer un format d'e-mail correct",
  "t-enter-email" : "Entrez l'adresse e-mail",
  "t-enter-first-name" : "Entrez le prénom",
  "t-required-first-name" : "Le nom est obligatoire",
  "t-enter-last-name" : "Entrer le nom de famille",
  "t-current-password" : "Mot de passe actuel",
  "t-new-password" : "nouveau mot de passe",
  "t-please-fill-all-mandatory-fields" : "Veuillez remplir tous les champs obligatoires",
  "t-user-password-changed-successfully" : "Le mot de passe de l'utilisateur a été modifié avec succès. Veuillez vous reconnecter!",
  "t-error-changing-user-password" : "Le mot de passe actuel est incorrect ou une erreur s'est produite lors du changement du mot de passe de l'utilisateur",
  "t-user-profile" : "profil d'utilisateur",
  "t-user-avatar-modified-successfully" : "L'avatar de l'utilisateur a été modifié avec succès!",
  "t-user-avatar-modified-failed" : "La modification de l'avatar de l'utilisateur a échoué!",
  "t-user-avatar-deletion-successfully" : "La suppression de l'avatar de l'utilisateur a réussi!",
  "t-user-avatar-deletion-failed" : "La suppression de l'avatar de l'utilisateur a échoué!",
  "t-user-avatar-not-exist" : "L'avatar de l'utilisateur n'existe pas!",
  "t-user-avatar-select-failed" : "Veuillez sélectionner l'avatar de l'utilisateur!",
  "t-roles" : "rôle",
  "t-error-length-password" : "La longueur du mot de passe doit être d'au moins ",
  "t-error-minimum-length-password" : "La longueur du mot de passe doit être d'au moins 6 caractères",
  "t-error-maximum-length-password" : "La longueur du mot de passe ne peut pas dépasser 32 caractères",
  "t-error-password-criteria" : "Le format du mot de passe doit être une combinaison de chiffres et de lettres",
  "t-enter-confirm-password" : "Saisir le mot de passe de confirmation",
  "t-warning-reset-password" : "Êtes-vous sûr de vouloir réinitialiser le mot de passe?",
  "t-sent-reset-password": "Réinitialiser le mot de passe Email envoyé avec succès.",
  "t-resend-token-email" : "Envoyer le code QR d'activation",
  "t-resend-email-successfully" : "L'utilisateur a envoyé l'e-mail avec succès!",
  "t-error-resend-email" : "L'utilisateur n'a pas réussi à envoyer l'e-mail!",
  "t-delete-user" : "Supprimer l'utilisateur",
  "t-cannot-delete-activated-user" : "Impossible de supprimer un utilisateur activé",
  "t-user-deactivated-successfully" : "L'utilisateur a été désactivé avec succès",
  "t-user-permission-update-successfully" : "La permission de l'utilisateur a été mise à jour avec succès.",
  "t-user-activated-successfully" : "L'utilisateur a été activé avec succès",
  "t-reset-password-sent-successfully" : "L'e-mail de réinitialisation du mot de passe a été envoyé avec succès",
  "t-user-activated-token-successfully" : "L'utilisateur a activé le jeton de téléphone portable avec succès!",
  "t-user-updated-successfully" : "L'utilisateur {param} a été mis à jour avec succès!",
  "t-warning-delete-user" : "Êtes-vous sûr de vouloir supprimer l'utilisateur - {param1} {param2}?",
  "t-delete-user-confirmation" : "Confirmation de suppression d'utilisateur",
  "t-token-replaced-successfully" : "L'utilisateur a remplacé le jeton de téléphone portable avec succès!",
  "t-error-token-replace" : "L'utilisateur a échoué à remplacer le jeton de téléphone portable!",
  "t-error-token-activation" : "L'utilisateur n'a pas réussi à activer le jeton de téléphone portable!",
  "t-group-deleted-successfully" : "Le groupe {param} a été supprimé avec succès!",
  "t-error-deleting-group" : "Une erreur s'est produite lors de la suppression du groupe",
  "t-delete-partner" : "Supprimer le partenaire",
  "t-partner-deleted-successfully" : "Le partenaire {param} a été supprimé avec succès!",
  "t-error-deleted-partner" : "Une erreur s'est produite lors de la suppression du partenaire",
  "t-edit-partner" : "Modifier le partenaire",
  "t-error-loading-partners" : "Une erreur s'est produite lors du chargement des partenaires",
  "t-partner-created-successfully" : "Le partenaire {param} a été créé avec succès!",
  "t-error-created-partner" : "Une erreur s'est produite lors de la création du partenaire",
  "t-partner-updated-successfully" : "Le partenaire {param} a été mis à jour avec succès!",
  "t-error-updated-partner" : "Erreur lors de la mise à jour du partenaire",
  "t-required-continent-name" : "Le nom du continent est obligatoire",
  "t-required-region-name" : "Le nom de la région est obligatoire",
  "t-required-country-name" : "Le nom du pays est obligatoire",
  "t-select-continent" : "Choisir le continent",
  "t-select-region" : "Sélectionner la région",
  "t-error-loading-countries" : "Erreur lors du chargement des pays",
  "t-enter-partner-name" : "Entrez le nom du partenaire",
  "t-required-partner-name" : "Le nom du partenaire est un champ obligatoire",
  "t-partner-name-criteria" : "Le nom du partenaire ne peut contenir que des lettres, des chiffres, des traits de soulignement, des points et des espaces, et ne peut pas commencer ou se terminer par un espace",
  "t-enter-phone-no" : "Entrez le numéro de téléphone",
  "t-required-valid-phone-no" : "Entrez un numéro de téléphone valide",
  "t-enter-email-address" : "Entrez l'adresse e-mail",
  "t-required-valid-email-address" : "Veuillez entrer une adresse e-mail valide",
  "t-enter-address" : "Entrer l'adresse",
  "t-error-enter-valid-address" : "L'adresse ne permet que les lettres majuscules et minuscules, les chiffres et les tirets.",
  "t-required-parent-partner" : "Veuillez saisir le partenaire parent",
  "t-edit-customer" : "Modifier le client",
  "t-enter-customer-name" : "Entrer le nom du client",
  "t-required-customer-name" : "Le nom du client est obligatoire",
  "t-required-customer" : "Le client est un élément obligatoire",
  "t-customer-name-criteria" : "Le nom du client ne peut contenir que des lettres, des chiffres, des traits de soulignement, des points et des espaces, et ne peut pas commencer ou se terminer par un espace",
  "t-error-loading-customers" : "Une erreur s'est produite lors du chargement des clients",
  "t-customer-created-successfully" : "Le client {param} a été créé avec succès!",
  "t-error-created-customer" : "Une erreur s'est produite lors de la création du client",
  "t-customer-updated-successfully" : "Le client {param} a été mis à jour avec succès!",
  "t-error-updated-customer" : "Une erreur s'est produite lors de la mise à jour du client",
  "t-warning-delete-customer" : "Êtes-vous sûr de vouloir supprimer le client - {param}?",
  "t-warning-delete-merchant" : "Êtes-vous sûr de vouloir supprimer le commerçant - {param}?",
  "t-warning-delete-store" : "Êtes-vous sûr de vouloir supprimer le magasin - {param}?",
  "t-delete-customer" : "Supprimer le client",
  "t-customer-deleted-successfully" : "Le client {param} a été supprimé avec succès!",
  "t-error-deleted-customer" : "Une erreur s'est produite lors de la suppression du client",
  "t-add-merchant" : "Ajouter un commerçant",
  "t-edit-merchant" : "Modifier le commerçant",
  "t-enter-mid" : "Entrée MID",
  "t-error-loading-merchant" : "Une erreur s'est produite lors du chargement du marchand",
  "t-merchant-created-successfully" : "Le marchand {param} a été créé avec succès!",
  "t-error-created-merchant" : "Une erreur s'est produite lors de la création du marchand",
  "t-merchant-updated-successfully" : "Le commerçant {param} a été mis à jour avec succès!",
  "t-error-updated-merchant" : "Une erreur s'est produite lors de la mise à jour du marchand",
  "t-enter-merchant-name" : "Entrez le nom du marchand",
  "t-required-merchant-name" : "Le nom du marchand est un élément requis.",
  "t-required-merchant" : "Le marchand est un élément obligatoire",
  "t-merchant-name-criteria" : "Le nom du marchand ne peut contenir que des lettres, des chiffres, des traits de soulignement, des points et des espaces, et ne peut pas commencer ou se terminer par un espace",
  "t-merchant-deleted-successfully" : "Le marchand {param} a été supprimé avec succès!",
  "t-error-deleted-merchant" : "Une erreur s'est produite lors de la suppression du marchand",
  "t-delete-merchant" : "Supprimer le marchand",
  "t-search-merchant" : "marchand",
  "t-merchant-name" : "nom du marchand",
  "t-error-loading-store" : "Une erreur s'est produite lors du chargement du magasin",
  "t-store-created-successfully" : "Le magasin {param} a été créé avec succès!",
  "t-error-created-store" : "Une erreur s'est produite lors de la création du magasin",
  "t-store-updated-successfully" : "Le magasin {param} a été mis à jour avec succès!",
  "t-error-updated-store" : "Une erreur s'est produite lors de la mise à jour du magasin",
  "t-enter-store-name" : "Entrez le nom du magasin",
  "t-required-valid-customer" : "Veuillez sélectionner un client valide",
  "t-required-valid-merchant" : "Veuillez sélectionner un marchand valide",
  "t-required-store-name" : "Le nom du magasin est obligatoire",
  "t-store-name-criteria" : "Le nom du magasin ne peut contenir que des lettres, des chiffres, des traits de soulignement, des points et des espaces, et ne peut pas commencer ou se terminer par un espace",
  "t-search-store" : "magasin",
  "t-add-store" : "Ajouter un magasin",
  "t-edit-store" : "Boutique d'édition",
  "t-required-valid-store" : "Veuillez sélectionner un magasin valide",
  "t-deleting-store" : "Supprimer le magasin",
  "t-store-deleted-successfully" : "Le magasin {param} a été supprimé avec succès!",
  "t-error-store-deleted" : "Une erreur s'est produite lors de la suppression du magasin",
  "t-manufacturer-created-successfully" : "Le fabricant {param} a été créé avec succès! ",
  "t-error-manufacturer-created" : "Une erreur s'est produite lors de la création du fabricant",
  "t-manufacturer-updated-successfully" : "Le fabricant {param} a été mis à jour avec succès!",
  "t-error-manufacturer-updated" : "Une erreur s'est produite lors de la mise à jour du fabricant",
  "t-manufacturer-deleted-successfully" : "Le fabricant {param} a été supprimé avec succès! ",
  "t-error-manufacturer-deleted" : "Une erreur s'est produite lors de la suppression du fabricant",
  "t-error-model-pattern" : "Le nom du modèle doit être composé de lettres, de chiffres, de traits de soulignement, de points et d'espaces et ne doit pas commencer ou se terminer par un espace",
  "t-error-model-version-pattern" : "Le nom de la version du modèle doit être composé de lettres, de chiffres, de traits de soulignement, de points et d'espaces et ne doit pas commencer ou se terminer par un espace",
  "t-error-format-required" : "Le format est obligatoire",
  "t-model-version-created-successfully" : "La version du modèle {param} a été créée avec succès!",
  "t-model-version-updated-successfully" : "La version du modèle {param} a été mise à jour avec succès!",
  "t-error-creating-model-version" : "Une erreur s'est produite lors de la création de la version du modèle",
  "t-error-updated-model-version" : "Une erreur s'est produite lors de la mise à jour de la version du modèle",
  "t-error-deleted-model" : "Une erreur s'est produite lors de la suppression du modèle",
  "t-error-deleted-model-version" : "Une erreur s'est produite lors de la suppression de la version du modèle",
  "t-error-deleting-transaction-param" : "Une erreur s'est produite lors de la suppression des paramètres de transaction",
  "t-transaction-param-deleted-successfully" : "Le paramètre de transaction {param} a été supprimé avec succès! ",
  "t-required-valid-group" : "Veuillez choisir un groupe valide",
  "t-firmware-deleted-successfully" : "Le firmware {param} a été supprimé avec succès!",
  "t-error-deleting-firmware" : "Une erreur s'est produite lors de la suppression du micrologiciel",
  "t-required-valid-firmware" : "Veuillez sélectionner un firmware valide",
  "t-firmware-version-deleted-successfully" : "La version du firmware {param} a été supprimée avec succès!",
  "t-error-deleting-firmwareversion" : "Une erreur s'est produite lors de la suppression du firmware",
  "t-download-firmware" : "télécharger le micrologiciel",
  "t-add-firmware-version" : "Ajouter la version du firmware",
  "t-edit-firmware-version" : "Modifier la version du firmware",
  "t-firmware-name" : "nom du micrologiciel",
  "t-search-firmware" : "firmware",
  "t-add-firmware" : "Ajouter le firmware",
  "t-edit-firmware" : "édition du micrologiciel",
  "t-enter-firmware-name" : "Entrez le nom du firmware",
  "t-required-firmware-name" : "Le nom du micrologiciel est obligatoire",
  "t-firmware-name-criteria" : "Le nom du micrologiciel doit être composé de lettres, de chiffres, de traits de soulignement, de points et d'espaces et ne doit pas commencer ou se terminer par un espace",
  "t-error-loading-firmware" : "Erreur lors du chargement du micrologiciel",
  "t-firmware-created-successfully" : "Le firmware {param} a été créé avec succès!",
  "t-error-creating-firmware" : "Erreur lors de la création du micrologiciel",
  "t-firmware-updated-successfully" : "Le firmware {param} a été mis à jour avec succès!",
  "t-error-updating-firmware" : "Erreur lors de la mise à jour du micrologiciel",
  "t-firmware-file" : "fichier de micrologiciel",
  "t-select-firmware-file" : "Sélectionner le fichier de firmware",
  "t-firmware-version-name" : "nom de la version du micrologiciel",
  "t-required-version-name" : "Le nom de la version est obligatoire",
  "t-required-firmware" : "Le firmware est obligatoire",
  "t-error-firmware-version-pattern" : "Le nom de la version du firmware doit être composé de lettres, de chiffres, de traits de soulignement, de points, de traits d'union et d'espaces, et ne doit pas commencer ou se terminer par un espace",
  "t-error-loading-firmware-version" : "Une erreur s'est produite lors du chargement de la version du micrologiciel",
  "t-firmware-version-created-successfully" : "La version du firmware {param} a été créée avec succès!",
  "t-error-creating-firmware-version" : "Une erreur s'est produite lors de la création de la version du micrologiciel",
  "t-firmware-version-updated-successfully" : "La version du micrologiciel {param} a été mise à jour avec succès!",
  "t-error-updating-firmware-version" : "Une erreur s'est produite lors de la mise à jour de la version du micrologiciel",
  "t-manufacturer-consists" : "Le nom du fabricant doit être composé de lettres, de chiffres, de traits de soulignement, de points et d'espaces et ne doit pas commencer ou se terminer par un espace",
  "t-ui-settings-consists" : "Le nom des paramètres d'interface utilisateur doit être composé de lettres, de chiffres, de soulignements, de points et d'espaces. Il ne doit pas commencer ou se terminer par un espace.",
  "t-log-capture-title-types" : "Types de journaux",
  "t-log-capture-title-logs" : "journaux",
  "t-log-capture-title-main" : "Journal principal",
  "t-log-capture-title-kernel" : "Journal du noyau",
  "t-btn-stop" : "Arrêter",
  "t-btn-capture" : "Capturer",
  "t-log-type" : "Type de journal",
  "t-log-type-main" : "Journal principal",
  "t-log-type-kernel" : "Journal du noyau",
  "t-create-log-capture-event" : "La tâche de capture de journal a été créée avec succès!",
  "t-search-logs" : "journaux",
  "t-error-creating-log-capture" : "Une erreur s'est produite lors de la capture du journal",
  "t-log-capture-process" : "En train de capturer les journaux",
  "t-stop-log-capture-event" : "Arrêter la capture du journal!",
  "t-error-stop-log-capture-event" : "Une erreur s'est produite lors de l'arrêt de la capture du journal!",
  "t-stop-log-capture-info" : "La tâche de capture du journal est terminée!",
  "t-error-enter-log-capture" : "Veuillez vérifier si le numéro de série de l'appareil ou le type de journal a été rempli!",
  "t-time-limit" : "limite de temps",
  "t-download-log" : "journal de téléchargement",
  "t-file-download-failed" : "Échec du téléchargement du fichier!",
  "t-error-log-forbidden" : "La capture du journal n'est pas encore terminée. Veuillez patienter! ",
  "t-error-deleting-log-file" : "Une erreur s'est produite lors de la suppression du fichier journal!",
  "t-error-show-detail-log" : "Une erreur s'est produite lors de la consultation des détails!",
  "t-delete-log-file" : "Le fichier journal {param} a été supprimé avec succès!",
  "t-detail-log-title" : "Fichier journal : {param} {date}",
  "t-add-log-capture-event" : "Ajouter l'événement de capture de journal",
  "t-ap" : "AP",
  "t-sp" : "SP",
  "t-apFirmware" : "AP",
  "t-spFirmware" : "SP",
  "t-general-all" : "tous",
  "t-to-include" : "inclure",
  "t-otp-password" : "Mot de passe OTP",
  "t-select-entity" : "Sélectionner l'entité",
  "t-other-settings" : "Autres paramètres",
  "t-metadata" : "métadonnées",
  "t-available-servers" : "serveurs disponibles",
  "t-service" : "service",
  "t-url" : "URL",
  "t-download-progress" : "Téléchargement en cours",
  "t-send" : "envoyer",
  "t-enter-email-instructions-to-tou": "Entrez votre email et les instructions vous seront envoyées!",
  "t-search-message" : "message",
  "t-enter-message" : "entrer le message",
  "t-send-message" : "envoyer un message",
  "t-message-mgmt" : "Gestion des messages",
  "t-required-duration" : "La durée est un champ obligatoire",
  "t-required-message" : "Le message est obligatoire",
  "t-message-sent" : "Le message a été envoyé avec succès",
  "t-ad-planner" : "planificateur de publicité",
  "t-add-ad-planner" : "Ajouter le planificateur de publicité",
  "t-search-ad-planner" : "Planificateur de publicité",
  "t-enter-planner-name" : "Entrez le nom du plan publicitaire",
  "t-required-planner-name" : "Le nom du planificateur publicitaire est un élément obligatoire",
  "t-add-advertisement" : "Ajouter une publicité",
  "t-edit-advertisement" : "Modifier la publicité",
  "t-error-end-time-greater-than-start" : "Le temps de fin doit être supérieur au temps de début",
  "t-advertisement-updated-successfully" : "L'annonce {param} a été mise à jour avec succès!",
  "t-error-updating-advertisement" : "Une erreur s'est produite lors de la mise à jour de l'annonce",
  "t-advertisement-created-successfully" : "La publicité {param} a été créée avec succès!",
  "t-error-creating-advertisement" : "Une erreur s'est produite lors de la création de l'annonce",
  "t-error-loading-advertisement" : "Une erreur s'est produite lors du chargement de l'annonce",
  "t-add-planner" : "Ajouter un plan publicitaire",
  "t-edit-planner" : "Modifier le plan publicitaire",
  "t-select-planner" : "Veuillez choisir un plan publicitaire valide",
  "t-error-loading-planner" : "Une erreur s'est produite lors du chargement du plan publicitaire",
  "t-planner-created-successfully" : "Le plan publicitaire {param} a été créé avec succès!",
  "t-error-created-planner" : "Une erreur s'est produite lors de la création du plan publicitaire",
  "t-planner-updated-successfully" : "Le plan publicitaire {param} a été mis à jour avec succès!",
  "t-error-updated-planner" : "Une erreur s'est produite lors de la mise à jour du plan publicitaire",
  "t-delete-advertisement" : "Supprimer la publicité",
  "t-advertisement-deleted-successfully" : "L'annonce {param} a été supprimée avec succès!",
  "t-error-deleting-advertisement" : "Une erreur s'est produite lors de la suppression de l'annonce",
  "t-advertisement-expired" : "L'annonce est expirée",
  "t-advertisement-end-time" : "L'heure de fin doit être postérieure à l'heure actuelle",
  "t-planner-deleted-successfully" : "Le plan publicitaire {param} a été supprimé avec succès!",
  "t-error-deleting-planner" : "Une erreur s'est produite lors de la suppression du plan publicitaire",
  "t-warning-delete-advertisement" : "Êtes-vous sûr de vouloir supprimer la publicité - {param}?",
  "t-warning-delete-planner" : "Êtes-vous sûr de vouloir supprimer le plan publicitaire - {param}?",
  "t-select-ads-start-date" : "Sélectionner la date de début de l'annonce",
  "t-select-ads-end-date" : "Sélectionner la date de fin des annonces",
  "t-ads-name" : "Nom de l'annonce",
  "t-ads-name-required" : "Le nom de l'annonce est obligatoire",
  "t-enter-ad-name" : "Entrez le nom de la publicité",
  "t-ads-start-required" : "La date de début de la publicité est un champ obligatoire",
  "t-ads-end-required" : "La date de fin de l'annonce est un champ obligatoire",
  "t-enter-detail-url" : "Entrer l'URL des détails",
  "t-detail-url-required" : "L'URL des détails est obligatoire",
  "t-start-date" : "Date et heure de début",
  "t-end-date" : "date et heure de fin",
  "t-message-name-required" : "Le nom du message est obligatoire",
  "t-required-message-type" : "Le type de message est une rubrique obligatoire",
  "t-message-content-required" : "Le contenu du message est obligatoire",
  "t-placeholder-message-text" : "Écrivez le message texte ici...",
  "t-select-execute-date" : "Choisir la date d'exécution",
  "t-select-expired-date" : "Sélectionner la date d'expiration",
  "t-select-executed-date" : "Date d'exécution sélectionnée",
  "t-expiration-time-greater-than-execution-time" : "Le temps d'expiration doit être supérieur au temps d'exécution",
  "t-execution-time-less-than-current-time" : "Le temps d'exécution doit être supérieur au temps actuel",
  "t-expiration-time-less-than-current-time" : "Le temps d'expiration doit être supérieur au temps actuel",
  "t-message-created-successfully" : "Le message {param} a été créé avec succès!",
  "t-error-creating-message" : "Une erreur s'est produite lors de la création du message",
  "t-message-updated-successfully" : "Le message {param} a été mis à jour avec succès!",
  "t-error-updated-message" : "Une erreur s'est produite lors de la mise à jour du message",
  "t-folders" : "dossiers",
  "t-available-files" : "Fichiers disponibles",
  "t-selected-files" : "Fichiers sélectionnés",
  "t-start-remote-control" : "Démarrer le contrôle à distance",
  "t-stop-remote-control" : "Arrêter le contrôle à distance",
  "t-account-not-exist" : "Le compte de connexion n'existe pas. Veuillez vérifier attentivement",
  "t-search-Keys" : "recherche",
  "t-details" : "détails",
  "t-transaction-id" : "Identifiant de transaction",
  "t-certificates" : "certificats",
  "t-payment-certificates" : "Certificats TLS",
  "t-payment-application-certificates" : "Certificats TLS",
  "t-add-payment-application-certificate" : "Ajouter le certificat TLS",
  "t-search-certificate" : "certificat",
  "t-add-certificate" : "Ajouter un certificat",
  "t-edit-certificate" : "Modifier le certificat",
  "t-enter-name" : "Entrer le nom",
  "t-set-password" : "Configurer le mot de passe",
  "t-enter-password" : "Entrer le mot de passe",
  "t-enter-new-password" : "Entrez le nouveau mot de passe",
  "t-confirm-new-password" : "Confirmer le nouveau mot de passe",
  "t-private-key-password" : "Mot de passe de la clé privée",
  "t-certificateLevel-1" : "Certificat de niveau 1",
  "t-certificateLevel-2" : "Certificat de niveau 2",
  "t-level1-certificates" : "Certificats de niveau 1",
  "t-please-select-customer" : "Veuillez sélectionner le client",
  "t-please-select-certificate" : "Veuillez sélectionner le certificat",
  "t-please-select-common-name" : "Veuillez saisir le nom commun",
  "t-please-select-org-unit" : "Veuillez saisir l'unité d'organisation",
  "t-please-select-org-name" : "Veuillez saisir le nom de l'organisation",
  "t-please-select-city" : "Veuillez saisir la ville",
  "t-please-select-state" : "Veuillez saisir l'État / la province",
  "t-please-select-country" : "Veuillez saisir le pays",
  "t-please-select-rsa-key" : "Veuillez sélectionner la clé RSA",
  "t-please-enter-password" : "Veuillez entrer le mot de passe",
  "t-prohibit-enter-space": "Interdiction de saisir des espaces.",
  "t-error-maximum-length-key-password" : "La longueur du mot de passe est au maximum de 10 caractères",
  "t-error-confirm-password-equal-new-password" : "La confirmation du mot de passe doit être identique au nouveau mot de passe",
  "t-signed-l2-certificate" : "Certificat de signature de niveau 2",
  "t-cert-name" : "Nom du certificat",
  "t-enter-common-name" : "Entrer le nom commun",
  "t-enter-org-unit" : "Entrer l'unité d'organisation",
  "t-enter-org" : "Entrer l'organisation",
  "t-enter-city" : "Entrer la ville",
  "t-enter-state" : "Entrer l'État / la province",
  "t-enter-country" : "Entrer le pays",
  "t-certificate-updated-successfully" : "Le certificat {param} a été mis à jour avec succès",
  "t-certificate-created-successfully" : "Le certificat {param} a été créé avec succès",
  "t-reover-tamper-status" : "Êtes-vous sûr de lever l'alerte de démontage de l'équipement?",
  "t-recover-tamper-success" : "L'alerte de démontage de l'équipement a été envoyée avec succès à l'équipement",
  "t-recover-tamper-error" : "La demande d'alerte de désactivation de l'ouverture du périphérique a échoué",
  "t-recover-key-error" : "La demande d'initialisation de la clé de l'appareil d'envoi a échoué",
  "t-add-message" : "Ajouter un message",
  "t-select-message" : "Veuillez sélectionner un partenaire valide",
  "t-enter-message-name" : "Entrez le nom du message",
  "t-warning-delete-messageList" : "Êtes-vous sûr de vouloir supprimer le message - {param}? ",
  "t-messageList-deleted-successfully" : "Le message {param} a été supprimé avec succès!",
  "t-error-deleting-messagelist" : "Échec de la suppression des messages",
  "t-error-loading-message" : "Une erreur s'est produite lors du chargement du message",
  "t-create-message" : "Ajouter un message",
  "t-edit-message" : "Modifier le message",
  "t-key-bulk-upload" : "Téléchargement en masse de clés",
  "t-import-key" : "Importer la clé",
  "t-update-type" : "type de mise à jour",
  "t-full" : "tout le paquet",
  "t-patch" : "paquet de différences",
  "t-warning-delete-certificate" : "Êtes-vous sûr de vouloir supprimer le certificat - {param}?",
  "t-cert-mgmt" : "Gestion des certificats",
  "t-upload-certificate" : "Télécharger le certificat",
  "t-create-certificate" : "créer un certificat",
  "t-error-deleting-certificate" : "Une erreur s'est produite lors de la suppression du certificat",
  "t-certificate-deleted-successfully" : "Le certificat {param} a été supprimé avec succès!",
  "t-upload-successfully" : "Le fichier a été téléchargé avec succès!",
  "t-upload-failed" : "Échec du téléchargement du fichier!",
  "t-delete-sub-ca-confirm-tip": "La suppression de ce Sub CA supprimera également le Server Cert et la clé privée du même partenaire ; les appareils concernés doivent être reliés à nouveau.",
  "t-delete-server-cert-confirm-tip": "Après la suppression de ce Server Cert, les appareils liés du même partenaire doivent être reliés à nouveau.",
  "t-certificateLevel" : "niveau de certificat",
  "t-signature-success" : "Le certificat a été généré avec succès",
  "t-error-creating-certificate" : "Une erreur s'est produite lors de la création du certificat",
  "t-error-updating-certificate" : "Une erreur s'est produite lors de la mise à jour du certificat",
  "t-import-customer" : "Importer des clients",
  "t-import-manufacturer" : "fabricant d'importation",
  "t-import-partner" : "Importer le partenaire",
  "t-import-merchant" : "Importer le marchand",
  "t-import-store" : "Boutique d'importation",
  "t-search-folder" : "dossier",
  "t-timeline-device" : "cycle de vie",
  "t-login-confirm-partner" : "Un login d'un partenaire a été détecté. Voulez-vous vous déconnecter du partenaire ou continuer?",
  "t-created-date" : "date de création",
  "t-created-by" : "créateur",
  "t-created-time" : "temps de création",
  "t-partner-open-2nd-signature" : "Le partenaire a activé la deuxième signature",
  "t-signed-by-feitian" : "Signé par Feitian ",
  "t-add-profile" : "Ajouter le fichier d'initialisation du terminal",
  "t-edit-profile" : "Modifier le fichier d'initialisation du terminal",
  "t-delete-profile" : "Supprimer le fichier d'initialisation du terminal",
  "t-profile-name" : "Nom du fichier d'initialisation du terminal",
  "t-partnerName" : "Nom du partenaire",
  "t-modelVersionName" : "Nom de la version du modèle",
  "t-profile-name-required" : "Le nom du fichier d'initialisation du terminal est obligatoire",
  "t-profile-created" : "Le fichier d'initialisation du terminal {param} a été créé avec succès!",
  "t-profile-updated" : "Le fichier d'initialisation du terminal {param} a été mis à jour avec succès!",
  "t-error-creating-profile" : "Une erreur s'est produite lors de la création du fichier d'initialisation du terminal",
  "t-error-updating-profile" : "Une erreur s'est produite lors de la mise à jour du fichier d'initialisation du terminal",
  "t-enable-profile-success" : "Le fichier d'initialisation du terminal a été activé avec succès",
  "t-enable-profile-close" : "Le fichier d'initialisation du terminal a été fermé avec succès",
  "t-select-least-operation" : "Veuillez sélectionner au moins une opération",
  "t-select-identical-application" : "Vous avez sélectionné une application identique",
  "t-enable-profile-fail" : "L'initialisation du fichier de profil du terminal a échoué",
  "t-delete-profile-error" : "Le fichier d'initialisation du terminal est activé et ne peut pas être supprimé!",
  "t-search-profile" : "Fichier d'initialisation du terminal",
  "t-warning-delete-profile" : "Êtes-vous sûr de vouloir supprimer le fichier d'initialisation du terminal - {param}?",
  "t-delete-profile-confirmation" : "Confirmation de la suppression du fichier d'initialisation du terminal",
  "t-profile-deleted" : "Le fichier d'initialisation du terminal {param} a été supprimé avec succès!",
  "t-cancel-push" : "Annulation de la poussée",
  "t-abort" : "annuler",
  "t-warning-delete-geo-fence" : "Êtes-vous sûr de vouloir supprimer la clôture géographique - {param}?",
  "t-geoFence-deleted-successfully" : "La géofence a été supprimée avec succès!",
  "t-error-deleting-geoFence-version" : "Une erreur s'est produite lors de la suppression de la géofence",
  "t-add-geo-fencing" : "Ajouter une clôture géographique",
  "t-edit-geo-fencing" : "Modifier la clôture géographique",
  "t-search-geo-fencing" : "clôture géographique",
  "t-save" : "sauvegarder",
  "t-delete-file" : "Supprimer le fichier",
  "t-warning-message" : "message d'avertissement",
  "t-warning-add-block-device" : "Si vous choisissez l'opération de verrouillage, l'appareil n'effectuera aucune opération supplémentaire après cette opération",
  "t-confirm-block-device" : "Confirmer le verrouillage de l'appareil",
  "t-proceed": "continuer",
  "t-fix-report" : "rapport statique",
  "t-start-time" : "heure de début",
  "t-end-time" : "heure de fin",
  "t-select-start-time" : "Sélectionner la date de début",
  "t-select-end-time" : "Choisir la date de fin",
  "t-error-exporting-report" : "Échec de l'exportation du rapport",
  "t-report-mgmt" : "Gestion des rapports",
  "t-select-all" : "Tout sélectionner",
  "t-select-current-page" : "Sélectionner la page actuelle",
  "t-deselect-all" : "Désélectionner tout",
  "t-transaction-version-information" : "STORM a automatiquement intégré TID et MID dans Json en fonction du numéro de série, vous n'avez donc pas besoin de définir TID et MID dans Json. Si vous définissez toujours TID et MID, nous utiliserons votre version",
  "t-support-mgmt" : "soutien de la gestion",
  "t-tickets-updated-successfully" : "Le ticket a été mis à jour avec succès!",
  "t-error-push-ui-group-empty" : "Les équipements de différentes versions de modèles existent dans le groupe sélectionné!",
  "t-warning-to-delete-push-event" : "Êtes-vous sûr de vouloir supprimer l'événement de push?",
  "t-push-event-deleted-successfully" : "L'événement de poussée a été supprimé avec succès!",
  "t-application-push-by-group-error" : "{param} n'est pas encore lié au niveau client. Veuillez effectuer la liaison d'abord! ",
  "t-merchant-redirect-confirm" : "Voulez-vous être redirigé vers le portail marchand? Ou continuez-vous à utiliser STORM? ",
  "t-merchant-redirect-title" : "Rediriger vers le portail marchand",
  "t-merchant-redirect" : "redirection",
  "t-abnormal-device" : "dispositif anormal",
  "t-abnormal-device-status" : "État de l'appareil anormal",
  "t-log-download-failed" : "Échec lors de l'obtention du journal, impossible de télécharger",
  "t-log-deleting-error" : "Lorsque l'obtention du journal échoue, il devrait être indiqué que l'obtention du journal a échoué et qu'il n'est pas possible de le supprimer",
  "t-account-exception" : "Votre compte est dans un état anormal. Veuillez contacter l'administrateur!",
  "t-account-permission-exception" : "La permission de l'utilisateur a été mise à jour. Veuillez contacter l'administrateur!",
  "t-signed" : "signature",
  "t-unsigned" : "non signé",
  "t-select-valid-partner" : "Veuillez sélectionner un partenaire valide",
  "t-password-mismatch" : "Mot de passe non correspondant",
  "t-support-gms" : "Prise en charge de Gms",
  "t-search-repository" : "dépôt",
  "t-repository" : "dépôt",
  "t-add-repository" : "Ajouter le référentiel",
  "t-edit-repository" : "Modifier le référentiel",
  "t-error-loading-repository" : "Une erreur s'est produite lors du chargement du référentiel",
  "t-repository-updated-successfully" : "Le dépôt {param} a été mis à jour avec succès!",
  "t-error-updating-repository" : "Une erreur s'est produite lors de la mise à jour du référentiel",
  "t-repository-created-successfully" : "Le dépôt {param} a été créé avec succès!",
  "t-error-creating-repository" : "Une erreur s'est produite lors de la création du référentiel",
  "t-error-deleting-repository" : "Une erreur s'est produite lors de la suppression du référentiel",
  "t-repository-name-criteria" : "Le nom du référentiel ne peut contenir que des lettres, des chiffres, des traits de soulignement, des points et des espaces, et ne peut pas commencer ou se terminer par un espace",
  "t-required-repository-name" : "Le nom du référentiel est obligatoire",
  "t-enter-repository-name" : "Entrez le nom du référentiel",
  "t-add-cloud-message" : "Ajouter un message dans le cloud",
  "t-required-valid-cloud-message" : "Veuillez sélectionner un message cloud valide",
  "t-required-cloud-name" : "Le nom est obligatoire",
  "t-token" : "jeton",
  "t-repository-deleted-successfully" : "Le dépôt {param} a été supprimé avec succès!",
  "t-cloud-message-deleted-successfully" : "Le message en nuage {param} a été supprimé avec succès!",
  "t-search-cloud-message" : "Message en nuage",
  "t-cloud-name-criteria" : "Le nom du message cloud ne peut contenir que des lettres, des chiffres, des traits de soulignement, des points et des espaces, et ne peut pas commencer ou se terminer par un espace",
  "t-enter-token" : "jeton d'entrée",
  "t-edit-cloud-message" : "Modifier le message du cloud",
  "t-error-loading-cloud-message" : "Une erreur s'est produite lors du chargement des messages du cloud",
  "t-cloud-message-updated-successfully" : "Le message en nuage {param} a été mis à jour avec succès!",
  "t-error-loading-updating-cloud-message" : "Une erreur s'est produite lors de la mise à jour du message du cloud",
  "t-cloud-message-created-successfully" : "Le message en nuage {param} a été créé avec succès!",
  "t-error-loading-creating-cloud-message" : "Une erreur s'est produite lors de la création du message cloud",
  "t-error-deleting-cloud-message" : "Une erreur s'est produite lors de la suppression du message cloud",
  "t-push-setting" : "Paramètres de poussée",
  "t-error-deleting-folder" : "Une erreur s'est produite lors de la suppression du dossier",
  "t-cortex-scanner-import" : "Importation du scanner Cortex",
  "t-import-cortex-scanner" : "Importer le scanner Cortex",
  "t-import-cortex-scanner-success" : "L'importation du fichier a réussi!",
  "t-system-info" : "Informations système",
  "t-payment-kernel" : "noyau de paiement",
  "t-device-configuration" : "Configuration de l'appareil",
  "t-functional-info" : "information fonctionnelle",
  "t-push-install-type" : "Type d'installation",
  "t-automatic-upgrade" : "mise à niveau automatique",
  "t-push-transaction-detail" : "pousser",
  "t-push-is-mobile-traffic" : "Utilise-t-on les données mobiles?",
  "t-push-start-time" : "heure de début",
  "t-push-end-time" : "heure de fin",
  "t-push-details" : "Détails de la poussée",
  "t-activated-kiosk-mode" : "Mode d'écran exclusif activé",
  "t-unActivated-kiosk-mode" : "Mode d'écran dominant désactivé",
  "t-push-abort-successfully" : "L'annulation de la poussée a réussi!",
  "t-error-push-abort" : "Une erreur s'est produite lors de l'annulation de la poussée",
  "t-push-event" : "Tâche planifiée",
  "t-add-push-event" : "Ajouter une tâche planifiée",
  "t-edit-push-event" : "Planification de tâche d'édition",
  "t-required-event-name" : "Le nom de la tâche planifiée est obligatoire",
  "t-event-name-pattern" : "Le nom de la tâche planifiée ne peut contenir que des lettres, des chiffres, des traits de soulignement, des points et des espaces, et ne peut pas commencer ou se terminer par un espace",
  "t-event-is-planned" : "planifié",
  "t-required-action" : "L'opération est obligatoire",
  "t-search-group-by-name" : "Rechercher le groupe par nom",
  "t-search-device-by-sn" : "Rechercher l'appareil par numéro de série",
  "t-push-event-application-version" : "Application et version",
  "t-old" : "vieux",
  "t-is-planned" : "planifié",
  "t-inStalled-application" : "Application installée",
  "t-push-event-firmware-version" : "Firmware et version",
  "t-new-version" : "nouvelle version",
  "t-old-version" : "ancienne version",
  "t-enable-disable" : "Activer/désactiver",
  "t-ui-setting-list" : "Liste des paramètres d'interface utilisateur",
  "t-select-group-or-device" : "Veuillez sélectionner le groupe ou l'appareil contenant l'appareil",
  "t-select-application-to-install" : "Veuillez sélectionner la version de l'application à pousser",
  "t-select-fireware-to-install" : "Veuillez sélectionner la version du micrologiciel à installer",
  "t-select-application-to-uninstall" : "Sélectionnez l'application à désinstaller",
  "t-select-ui-setting" : "Veuillez sélectionner les paramètres d'interface utilisateur",
  "t-push-event-created-successfully" : "L'événement de poussée {param} a été créé avec succès",
  "t-error-created-push-event" : "Une erreur s'est produite lors de la création de l'événement de push",
  "t-execution-time-greater-than-current-time" : "Le temps d'exécution doit être supérieur au temps actuel",
  "t-push-event-updated-successfully" : "L'événement de poussée {param} a été mis à jour avec succès",
  "t-import-device-information-details" : "Détails des informations sur l'appareil importé",
  "t-import-customer-information-details" : "Importer les détails des informations des clients",
  "t-import-partner-information-details" : "Détails d'information sur l'importation du partenaire",
  "t-import-manufacturer-information-details" : "Détails d'information sur le fabricant importé",
  "t-import-merchant-information-details" : "Importer les détails des informations du marchand",
  "t-import-store-information-details" : "Importer les détails d'information du magasin",
  "t-import-key-information-details" : "Détails d'information sur la clé d'importation",
  "t-import-cortex-scanner-information-details" : "Importer les détails d'information du scanner Cortex",
  "t-push-key-empty-error" : "Il n'y a pas d'appareil correspondant à cette clé dans le groupe",
  "t-total-number" : "nombre total",
  "t-select-tid-to-use" : "Veuillez sélectionner le TID à utiliser",
  "t-import-failed" : "Échec de l'importation",
  "t-network-gateway-timeout" : "Le délai de la demande réseau a expiré. Veuillez réessayer!",
  "t-network-service-unavailable" : "En maintenance. Veuillez réessayer plus tard!",
  "t-network-bad-gateway" : "Requête invalide. Veuillez réessayer!",
  "t-network-not-found" : "La ressource n'existe pas. Veuillez contacter l'administrateur!",
  "t-network-forbidden" : "Vous n'avez pas l'autorisation et ne pouvez pas accéder!",
  "t-network-bad-request" : "Erreur du corps de la demande. Veuillez réessayer! ",
  "t-network-method-not-allowed" : "La méthode n'est pas autorisée. Veuillez réessayer! ",
  "t-spring-configuration" : "Configuration Spring",
  "t-prefix" : "préfixe",
  "propriétés": "attributs",
  "t-done" : "terminé",
  "t-property" : "propriété",
  "t-git-branch" : "branche git",
  "t-git-version" : "version de git",
  "t-zone" : "fuseau horaire",
  "t-management-port" : "port de gestion",
  "t-git-commit" : "soumission git",
  "t-health-checks" : "contrôles de santé",
  "t-service-name" : "nom du service",
  "t-otp-mobile-installation-manual" : "Manuel d'installation du jeton mobile",
  "t-otp-mobile-installation-manual-android" : "Manuel d'installation du jeton mobile (Android)",
  "t-installation-manual-android-1" : "1. Entrez sur le marché Google, recherchez 'OTP Mobile', téléchargez et installez-le sur votre téléphone portable",
  "t-installation-manual-android-2" : "2. Lors de la première ouverture de l'application mobile otp, vous devez activer une série de permissions pour éviter des problèmes lors de l'utilisation. Il est recommandé aux utilisateurs d'activer ces permissions",
  "t-installation-manual-android-3" : "3. Utilisez la fonction « Scanner » pour scanner les informations du code QR dans l'e-mail afin d'activer le jeton",
  "t-installation-manual-android-4" : "4. Une fois l'activation réussie, la valeur OTP sera affichée sur l'interface de l'application",
  "t-installation-manual-android-5" : "5. Lorsque l'utilisateur ordinaire se connecte, s'il appartient à un partenaire pour lequel l'authentification à deux facteurs est activée, il doit saisir un mot de passe pour se connecter.",
  "t-otp-mobile-installation-manual-ios" : "Manuel d'installation du jeton mobile (IOS)",
  "t-installation-manual-ios-1" : "1. Entrez dans l'App Store, recherchez 'otp mobile token', téléchargez et installez-le sur votre téléphone portable",
  "t-installation-manual-ios-2" : "2. Ouvrez l'application mobile otp",
  "t-installation-manual-ios-3" : "3. Utilisez la fonction « Scanner » pour scanner les informations du code QR dans l'e-mail afin d'activer le jeton",
  "t-installation-manual-ios-4" : "4. Une fois l'activation réussie, la valeur OTP sera affichée sur l'interface de l'application.",
  "t-installation-manual-ios-5" : "5. Lorsque l'utilisateur ordinaire se connecte, s'il appartient à un partenaire pour lequel l'authentification à deux facteurs est activée, il doit saisir son mot de passe pour se connecter.",
  "t-password-configuration" : "Configuration du mot de passe",
  "t-passeord-use-least-one-uppercase-letter" : "Utilisez au moins une lettre majuscule",
  "t-not-allows-use-special-characters" : "L'utilisation de caractères spéciaux n'est pas autorisée",
  "t-not-allows-use-chinese-special-characters": "Ne permet pas l'utilisation de caractères spéciaux chinois",
  "t-whether-to-enable-history-password" : "Interdire l'utilisation du mot de passe historique ou non",
  "t-default-template" : "modèle par défaut",
  "t-user-changed-to-partner" : "Le rôle a été modifié en partenaire : {param}",
  "t-smart-terminal-operations-remote-manager" : "Gestionnaire distant des opérations de terminaux intelligents",
  "t-abnormal-devices" : "appareils anormaux",
  "t-account-profile" : "profil",
  "t-sign-out" : "Se déconnecter",
  "t-merchant-portal" : "Portail du marchand",
  "t-storm" : "TEMPÊTE",
  "t-init-key" : "clé d'initialisation",
  "t-password-does-not-match" : "Le mot de passe ne correspond pas",
  "t-password-changed" : "Le mot de passe a été modifié. Veuillez vous connecter",
  "t-selectd-devices" : "Appareils sélectionnés",
  "t-store-not-associated" : "Le magasin n'est pas associé",
  "t-push-group" : "groupe",
  "t-error-loading-group-device" : "Une erreur s'est produite lors du chargement des appareils du groupe",
  "t-reset-password-link-invalid" : "Échec de la modification du mot de passe : ce lien est invalide",
  "t-changed-password" : "Modifier le mot de passe",
  "t-continue" : "continuer",
  "t-invalid-credentials" : "Les justificatifs sont invalides",
  "t-storm-version-release-notes" : "Notes de publication de STORMV1.3.3",
  "t-version-notes-content" : "Dans cette version publiée, nous nous concentrons sur le module de rapport. Le rapport fixe vous fournira une vue d'ensemble des données provenant de différents modules",
  "t-version-notes-one-title" : "--Gestion des rapports : Rapports statiques",
  "t-version-notes-one-content" : "STORM vous offre désormais cette fonction de génération de rapports. STORM peut générer plusieurs formats de rapports sous différents angles : équipements, applications, firmware, push et cycle de vie. Il prend également en charge les formats de rapports PDF et Excel",
  "t-version-notes-two-title" : "--État du réseau de l'appareil",
  "t-version-notes-two-content" : "Nous offrons maintenant toutes sortes de couleurs pour représenter l'état de différents équipements, afin que les utilisateurs puissent comprendre plus rapidement l'état actuel du réseau de l'équipement.",
  "t-version-notes-two-content-green" : "Vert : En ligne",
  "t-version-notes-two-content-red" : "Rouge : hors ligne",
  "t-version-notes-two-content-orange" : "Orange : au-delà de la clôture géographique",
  "t-version-notes-two-content-blue" : "Bleu : à activer",
  "t-version-notes-two-content-grey" : "Gris : non activé",
  "t-version-notes-three-title" : "-- Rapport de diffusion",
  "t-version-notes-three-content" : "STORM fournit un moyen évident d'indiquer l'état de la poussée, que ce soit réussi, échoué ou en cours. Les utilisateurs peuvent voir l'état au premier coup d'œil en fonction d'une couleur spécifique et d'un numéro. De plus, les utilisateurs peuvent annuler la poussée dans des circonstances antérieures, ce qui signifie que la demande n'a pas encore été poussée vers l'appareil.",
  "t-version-optimisaziton-points" : "Points d'optimisation : ",
  "t-version-optimisaziton-points-one-title" : "--Choix des partenaires mis à jour",
  "t-version-optimisaziton-points-one-content" : "Auparavant, nous n'offrions qu'un seul moyen de rechercher le nom d'un partenaire de recherche. Maintenant, nous offrons deux méthodes, le choix et la zone de recherche, pour s'adapter aux différentes perspectives des utilisateurs.",
  "t-version-optimisaziton-points-two-title" : "-- Rapport d'exportation Excel de l'équipement",
  "t-version-optimisaziton-points-two-content" : "Dans Excel, il y a des informations plus détaillées sur les équipements spécifiques, donc les utilisateurs peuvent obtenir plus d'informations dans un seul Excel",
  "t-version-optimisaziton-points-three-title" : "--Notifications push de l'application",
  "t-version-optimisaziton-points-three-content" : "Lorsque l'application est poussée vers un groupe d'appareils, si un ou plusieurs appareils ne sont pas liés au niveau client, une notification s'affichera.",
  "t-certificate-file" : "fichier de certificat",
  "t-select-certificate-file" : "Sélectionner le fichier de certificat",
  "t-cannot-empty-existing-imei" : "Impossible de vider l'IMEI existant",
  "t-required-payment-certificate-name" : "Le nom du certificat TLS est obligatoire",
  "t-payment-certificate-saved-successfully" : "Le certificat TLS a été enregistré avec succès",
  "t-payment-certificate-deleted-successfully" : "Le certificat TLS {param} a été supprimé avec succès!",
  "t-error-deleting-payment-certificate" : "Une erreur s'est produite lors de la suppression du certificat TLS",
  "t-select-start-end-time-limit" : "La durée de vérification ne doit pas dépasser trois mois",
  "t-select-multiple-options" : "Veuillez sélectionner au moins une condition de filtrage",
  "t-warning-to-delete-payments" : "Êtes-vous sûr de vouloir supprimer le certificat TLS - {param}?",
  "t-delete-device-payments" : "Supprimer la confirmation du certificat TLS",
  "t-enable_tid": "Modifier le TID",
  "t-key-expired" : "La clé a expiré. Veuillez créer une nouvelle clé pour éviter la répétition de l'index de la clé",
  "t-sub-partner" : "partenaire secondaire",
  "t-open-enable-otp" : "L'administrateur active l'OTP",
  "t-otp-identification-code" : "Code d'identification de jeton",
  "t-token-identification-code-setting" : "(Application de jeton de téléphone portable -> Paramètres -> À propos)",
  "t-required-identification-code" : "Le code d'identification du jeton est requis.",
  "t-enter-otp-code" : "Entrez le code d'identification du jeton",
  "t-generate-qr-code" : "Générer un code QR",
  "t-otp-code-to-active" : "Entrez le code OTP pour activer : ",
  "t-enter-otp-code-to-active" : "Entrez le code OTP",
  "t-generated-code": "Générer le Code",
  "t-enter-generated-code-to-active": "Entrez le code d'activation",
  "t-required-otp-code" : "Le code OTP est requis.",
  "t-identification-code-criteria" : "Le code d'identification OTP est composé de chiffres",
  "t-otp-code-criteria" : "Le code OTP est composé de chiffres",
  "t-please-generate-qr-code" : "Veuillez obtenir d'abord le code QR",
  "t-enable-update-token" : "jeton de remplacement",
  "t-active-otp-success" : "L'activation de l'OTP a réussi!",
  "t-error-enter-minlength-identification-code" : "La longueur du code d'identification du jeton ne peut pas être inférieure à 20",
  "t-bind-token-sn" : "L'utilisateur a lié le jeton (numéro de jeton : ",
  "t-activation-otp" : "Activer l'OTP",
  "t-activation-otp-link-invalid" : "L'activation OTP a échoué : ce lien est invalide",
  "t-generate-qr-code-failed" : "La génération du code QR a échoué",
  "t-activation-otp-failed" : "Échec de l'activation de l'OTP",
  "t-error-reset-password" : "Échec de la réinitialisation du mot de passe",
  "t-error-download-repeat" : "Le fichier a déjà été téléchargé. Veuillez ne pas télécharger à nouveau.",
  "t-profile-application-layout" : "Si vous avez activé la fonction de signature d'application (ce qui signifie que vous avez téléchargé le certificat d'application), assurez-vous que votre appareil est lié à un client spécifique!",
  "t-export-to-json" : "Exporter en fichier JSON",
  "t-device-status" : "État de l'appareil",
  "t-versions" : "versions",
  "t-search-application" : "application",
  "t-tls-certificate-import" : "Importation du certificat TLS",
  "t-tls-certificate-bulk-upload" : "Téléchargement en masse des certificats TLS",
  "t-import-tls-certificate" : "Importer le certificat TLS",
  "t-import-tls-certificate-information-details" : "Détails d'information sur le certificat TLS importé",
  "t-tls-file-name" : "Nom du fichier : {param}",
  "t-push-confirm" : "Confirmation de la poussée",
  "t-install-cer" : "installer.cer",
  "t-push-confirm-desc" : "Veuillez confirmer que vous voulez pousser tous les certificats vers les appareils inclus dans le fichier compressé",
  "t-tls-certificate" : "Certificat TLS",
  "t-add-event" : "Ajouter un événement",
  "t-modified-date" : "date de modification",
  "t-main-log" : "journal principal",
  "t-bluetooth" : "Bluetooth",
  "t-kernel-log" : "Journal du noyau",
  "t-security-processor-log" : "Journal du processeur de sécurité",
  "t-pos-server-log" : "Journal du serveur POS",
  "t-log-seconds" : "secondes",
  "t-log-mins" : "minutes",
  "t-log-hour" : "heure",
  "t-log-hours" : "heures",
  "t-previous" : "Page précédente",
  "t-today" : "aujourd'hui",
  "t-month-view" : "Vue mensuelle",
  "t-week-view" : "Vue de la semaine",
  "t-day-view" : "Vue journalière",
  "t-message-version" : "Version du message",
  "t-search-firmware-version" : "Version du firmware",
  "t-capturen-not-start" : "La capture n'a pas commencé",
  "t-capture-completed" : "Capture terminée",
  "t-capture-failed" : "Échec de la capture",
  "t-capturing" : "en cours de capture",
  "t-modelversion" : "version de modèle",
  "t-firmwareversion" : "version du micrologiciel",
  "t-applicationversion" : "version d'application",
  "t-keymanagement" : "gestion des clés",
  "t-message-management" : "Gestion des messages",
  "t-pushmanagement" : "Gestion de la poussée",
  "t-importmanagement" : "gestion d'importation",
  "t-logmanagement" : "Gestion des journaux",
  "t-ui-mgmt" : "Gestion de l'interface utilisateur",
  "roles.-.permissions": "droits et autorisations des rôles",
  "t-certificate-mgmt" : "Gestion des certificats",
  "t-rki-certificate": "Certificat RKI",
  "t-application-certificate" : "Certificat d'application",
  "under_activation": "À activer",
  "block~disable": "BLOCK~DISABLE",
  "disable~block": "DISABLE~BLOCK",
  "t-kiosk-mode-activated" : "Le mode d'occupation de l'écran est activé",
  "t-install-app" : "Installer l'application",
  "t-firmware-incremental-upgrade" : "mise à niveau incrémentielle du micrologiciel",
  "t-firmware-full-package" : "Mise à niveau du micrologiciel",
  "t-restart-device" : "Redémarrer l'appareil",
  "t-storm-factory-reset-device" : "Réinitialisation aux paramètres d'usine - STORM",
  "t-device-factory-reset-device" : "Réinitialisation d'usine de l'appareil - Device",
  "t-unlock-device" : "déverrouiller l'appareil",
  "t-device-initialization" : "Initialisation de l'appareil",
  "t-start-log-capture" : "Commencer la capture du journal",
  "t-stop-log-capture" : "Arrêter la capture du journal",
  "t-erase-tamper" : "Supprimer le démontage",
  "t-payment-application-certificate" : "Certificat d'application de paiement",
  "t-automatic-active" : "activation automatique",
  "t-device-automatic-initialization" : "Initialisation automatique de l'appareil",
  "t-transaction-parameter" : "paramètre de transaction",
  "t-not-yet-executed" : "Pas encore exécuté",
  "t-push-status-task-reached-the-maximum" : "Échec, la tâche a atteint le maximum",
  "t-push-status-apk-install-failed-system-mistake" : "Échec, erreur du système lors de l'installation de l'APK",
  "t-application-full-package": "Application - Paquet complet",
  "t-application-batch-update": "Application - Paquet de différences",
  "t-factory-reset-device-storm": "Réinitialisation d'usine de l'appareil - STORM",
  "t-factory-reset-device-device": "Rétablir les paramètres d'usine - DISPOSITIF",
  "t-please-improve-tid" : "Veuillez améliorer le tid",
  "t-please-clear-tid-bind" : "Veuillez effacer toutes les TID associées au numéro de série",
  "t-profile-application-fail-cause" : "Statut de traitement de l'application",
  "t-profile-uisettings-fail-cause" : "Statut de traitement des thèmes",
  "t-profile-systemparam-fail-cause" : "Statut de traitement des paramètres du système",
  "t-profile-application-name" : "Nom de l'application",
  "t-profile-application-version-name" : "Nom de la version de l'application",
  "t-profile-firmware-fail-cause": "Cause d'Échec du Firmware",
  "t-profile-firmware-processing-status": "Statut de traitement du firmware",
  "t-profile-firmware-name": "Nom du Firmware",
  "t-profile-firmware-version-name": "Nom de la Version du Firmware",
  "t-profile-fail-cause" : "Cause d'échec",
  "t-profile-uisettings-name" : "Nom des paramètres d'interface utilisateur",
  "t-profile-uisettings-version-name" : "Nom de la version des paramètres d'interface utilisateur",
  "t-profile-systemparam-name" : "Nom du paramètre du système",
  "t-profile-systemparam-version-name" : "Nom de la version des paramètres du système",
  "t-profile-systemparam-version" : "Version des paramètres du système",
  "t-error-geo-fence-action-list" : "La liste d'opérations ne peut pas être vide",
  "t-error-geo-fence-region-list": "La liste des régions ne peut pas être vide",
  "t-error-geo-fence-action" : "L'action ne peut pas être vide",
  "t-maximize" : "maximiser",
  "t-dashboard-widget-selection" : "Sélection de widget du tableau de bord",
  "t-ui-management-version" : "Version de gestion de l'interface utilisateur",
  "t-system-params-version" : "Version des paramètres du système",
  "t-action-create" : "créer",
  "t-action-update" : "mise à jour",
  "t-action-delete" : "supprimer",
  "t-add-region" : "Ajouter une région",
  "t-password-configuration-select" : "Sélectionnez au moins une politique de mot de passe",
  "t-network-try-again" : "Erreur réseau, veuillez réessayer",
  "t-connection-time-out" : "La connexion a expiré. Veuillez réessayer.",
  "t-test-connection" : "Tester la connexion",
  "t-connection-test-success" : "Test de connexion réussi",
  "t-connection-test-failed" : "Échec du test de connexion",
  "t-application-signed-failed" : "Échec de la signature de l'application",
  "t-add-profile-check-application" : "Assurez-vous que l'APK signé est détecté avec succès",
  "t-tid-require-valid" : "Si le TID est rempli, le pays et la région doivent être remplis",
  "t-file-upload" : "téléchargement de fichier",
  "t-application-control" : "contrôle d'application",
  "t-remove-uninstall-block" : "Supprimer, désinstaller, bloquer",
  "t-remove-password" : "Supprimer le mot de passe",
  "t-app-set-uninstall-block" : "Paramètres de l'application, interdiction de désinstallation",
  "t-app-remove-uninstall-block" : "Application de suppression interdiction de désinstallation",
  "t-app-set-password" : "Mot de passe de configuration de l'application",
  "t-app-remove-password" : "Mot de passe de suppression de l'application",
  "t-configuration-success" : "Les paramètres de l'application ont été envoyés à l'appareil",
  "t-error-enter-minlength-password" : "La longueur du mot de passe ne peut pas être inférieure à 6",
  "t-error-enter-password" : "Le mot de passe est obligatoire",
  "t-warning-to-remove-uninstall-block" : "Êtes-vous sûr de vouloir supprimer le blocage de la désinstallation de l'application?",
  "t-warning-to-logout" : "Êtes - vous sûr de vouloir vous déconnecter？",
  "t-email-name-required" : "Le nom de configuration de l'e-mail est obligatoire",
  "t-email-created-successfully" : "La configuration de l'e-mail {param} a été créée avec succès!",
  "t-email-updated-successfully" : "La configuration de l'e-mail {param} a été mise à jour avec succès!",
  "t-error-creating-email" : "Une erreur s'est produite lors de la création de la configuration de l'e-mail",
  "t-error-updating-email" : "Une erreur s'est produite lors de la mise à jour de la configuration de l'e-mail",
  "t-enable-email-success" : "La configuration de l'e-mail a été activée avec succès",
  "t-enable-email-close" : "La configuration de la messagerie électronique a été fermée avec succès",
  "t-enable-email-fail" : "Échec de l'activation de la configuration de la boîte aux lettres ",
  "t-delete-email-error" : "La configuration de l'e-mail est activée et ne peut pas être supprimée!",
  "t-search-email" : "courrier électronique",
  "t-warning-delete-email" : "Êtes-vous sûr de vouloir supprimer la configuration de l'e-mail - {param}?",
  "t-delete-email-confirmation" : "Confirmation de suppression de la configuration de l'e-mail",
  "t-email-deleted" : "La configuration de la boîte aux lettres a été supprimée avec succès!",
  "t-add-email" : "Ajouter un e-mail",
  "t-edit-email" : "Modifier l'e-mail",
  "t-enter-email-name" : "Entrez le nom de l'e-mail",
  "t-enter-email-server" : "Entrez le serveur de messagerie électronique",
  "t-enter-port" : "port d'entrée",
  "t-enter-email-account" : "Entrez le compte e-mail",
  "t-enter-email-sender" : "Entrez l'expéditeur de l'e-mail",
  "t-required-email-sender" : "L'expéditeur de l'e-mail est obligatoire",
  "t-error-email-name-pattern" : "Le nom de l'e-mail est composé de lettres, de chiffres, de traits de soulignement, de points et d'espaces et ne peut pas commencer ou se terminer par un espace",
  "t-error-email-server-required" : "Le serveur de messagerie électronique est obligatoire",
  "t-error-email-account-required" : "Le compte e-mail est requis",
  "t-error-email-port-required" : "Le port est obligatoire",
  "t-error-email-port-pattern" : "Le port doit être compris entre 1 et 65535",
  "t-error-email-host-pattern" : "Veuillez saisir un serveur de messagerie légal",
  "t-search-key" : "clé secrète",
  "t-search-push-detail" : "Détails de la poussée de recherche",
  "t-search-push-event" : "Événement de poussée de recherche",
  "t-search-log-capture-event" : "Journal de recherche",
  "t-search-partner-setting" : "partenaire",
  "t-search-ui-settings-version" : "Version des paramètres de l'interface utilisateur de recherche",
  "t-search-payment-application-certificate" : "Certificat TLS",
  "t-search-message-sidebar" : "Rechercher des partenaires",
  "t-email-setting-connection-success" : "Connexion réussie pour les paramètres de l'e-mail",
  "t-email-setting-connection-failed" : "Échec de la connexion des paramètres de l'e-mail",
  "t-lat-and-lng" : "Longitude et latitude",
  "t-version-low-to-upgrade" : "La version actuelle est trop basse pour prendre en charge cette fonction. Veuillez mettre à niveau la version.",
  "t-email-settings-enable-ssl" : "Activer SSL",
  "t-email-settings-enable-starttls" : "Activer STARTTLS",
  "t-email-settings-meanwhile-enbale" : "Il n'est pas possible d'activer simultanément le protocole SSL et le protocole TLS",
  "t-error-update-application" : "Échec de la mise à jour de l'application",
  "t-file-size-bigger" : "La taille du fichier est trop grande",
  "t-error-bind-device" : "Échec de la liaison de l'appareil",
  "t-error-unbind-device" : "L'opération de désassociation de l'appareil a échoué",
  "t-required-transaction-param-version-name" : "Le nom de la version du paramètre de transaction est requis",
  "t-required-package-name" : "Le nom du paquet est requis.",
  "t-required-intent-name" : "Le nom de l'intention est un élément requis",
  "t-upload-file" : "Télécharger un fichier",
  "t-deleted" : "supprimé",
  "t-customer-name" : "nom du client",
  "t-store-name" : "nom de magasin",
  "t-expired-at" : "heure d'expiration",
  "t-hsm-model-name" : "Nom du modèle Hsm",
  "t-contenu" : "contenu",
  "t-pushes" : "diffusions",
  "t-is-batch-upload" : "Téléchargement en lot",
  "t-system-param-name" : "Nom du paramètre du système",
  "t-model-type" : "Type de modèle",
  "t-model-type-required" : "Le type d'équipement est une rubrique obligatoire",
  "t-smart-pos" : "POS intelligent",
  "t-id-pos" : "ID POS",
  "t-mpos" : "MPOS",
  "t-folder-name" : "nom du dossier",
  "t-batch-devices-details" : "Informations détaillées sur le lien / déliement en masse d'appareils",
  "t-execute-date" : "Date d'exécution",
  "t-expired-date" : "date d'expiration",
  "t-empty-device-password" : "Le verrouillage par mot de passe n'a pas été configuré pour l'appareil actuel",
  "t-pubkey-is-normal-no-need-to-sync" : "La clé publique est normale, pas besoin de synchronisation",
  "t-device-not-support-pubkey-synchronization" : "L'appareil ne prend pas en charge la synchronisation de la clé publique. Veuillez vérifier l'appareil.",
  "t-task-scheduler-name" : "Nom de la tâche planifiée du système",
  "t-add-task-scheduler" : "Ajouter une tâche planifiée du système",
  "t-edit-task-scheduler" : "Modifier les tâches planifiées du système",
  "t-concurrence" : "concurrence",
  "t-execute-immediately" : "exécuter immédiatement",
  "t-delete-task-scheduler" : "Supprimer les tâches planifiées du système",
  "t-warning-delete-task-scheduler" : "Êtes-vous sûr de vouloir supprimer la tâche planifiée du système - {param}?",
  "t-task-scheduler-deleted" : "La tâche planifiée {param} du système a été supprimée avec succès!",
  "t-error-deleting-task-scheduler" : "Une erreur s'est produite lors de la suppression de la tâche planifiée du système",
  "t-second" : "seconde",
  "t-cycle-by" : "période",
  "t-not-specified" : "non spécifié",
  "t-follow" : "suivre",
  "t-this-month" : "ce mois-ci",
  "t-this-week" : "cette semaine",
  "t-specified" : "spécifié",
  "t-last-five-runs" : "Les cinq dernières exécutions",
  "t-permissible-wildcards" : "wildcards autorisés",
  "t-last" : "dernier",
  "t-monthly" : "mensuel",
  "t-most-recent-working-day" : "jour de travail le plus récent",
  "t-warning-execute-task-scheduler" : "Confirmez-vous l'exécution immédiate de la tâche '{param}'?",
  "t-error-execute-task-scheduler" : "Une erreur s'est produite lors de l'exécution de la tâche planifiée du système",
  "t-enable-task-scheduler-success" : "La tâche planifiée du système a été activée avec succès",
  "t-enable-task-scheduler-close" : "La tâche planifiée du système a été fermée avec succès",
  "t-enable-task-scheduler-fail" : "L'activation de la tâche planifiée du système a échoué",
  "t-please-select-model-version" : "Veuillez sélectionner la version du modèle!",
  "t-path" : "chemin",
  "t-rom-version" : "Version de ROM",
  "t-k21-version" : "Version K21",
  "t-memory-total" : "Mémoire totale",
  "t-memory-available" : "mémoire disponible",
  "t-flash-total" : "Flash total",
  "t-flash-available" : "Mémoire flash disponible",
  "t-battery" : "pile",
  "t-model-type-exist" : "Le type de modèle existe déjà. Veuillez supprimer les données existantes et les ajouter à nouveau.",
  "t-model-functions" : "Modèle. Fonctions",
  "t-error-enter-valid-cleancondition" : "La condition de nettoyage ne peut contenir que des chiffres",
  "t-cleancondition" : "condition de nettoyage",
  "t-set-version-type" : "Type de version de configuration",
  "t-not-support-log-capture" : "Le terminal traditionnel ne prend pas en charge la capture manuelle des journaux",
  "t-example" : "exemple",
  "t-type-of-30-second" : "Le type 1 indique 30 secondes",
  "t-type-of-60-second" : "Le type 2 indique 60 secondes",
  "t-example-of-capture" : "{\"fileName\": \"11.txt\",\"path\": \"\", \"type\": \"\"}",
  "t-push-scheduled-tasks" : "Enregistrements des tâches planifiées de poussée",
  "t-executing" : "en cours d'exécution",
  "t-task-created" : "La tâche a été créée",
  "t-search-push-scheduled-tasks" : "Enregistrements des tâches planifiées de poussée de recherche",
  "res[i].name": "Êtes-vous sûr de vouloir annuler la tâche de planification de la poussée?",
  "t-push-scheduled-tasks-abort-successfully" : "L'abandon de la tâche planifiée de poussée a réussi!",
  "t-error-push-scheduled-tasks-abort" : "Une erreur s'est produite lors de l'annulation des tâches planifiées de push",
  "t-error-version-type-required" : "Le type de version est obligatoire",
  "t-not-support-log-capture-if-id" : "Le type de protocole de ce terminal d'authentification ne prend pas en charge la capture de journaux",
  "t-cancel-push-success" : "Annulation de la poussée réussie",
  "t-error-enter-maxlength-password" : "La longueur du mot de passe doit être de 6 caractères",
  "t-not-allow-same-duration" : "La même durée n'est pas autorisée",
  "t-signature-file-currently-creating" : "Le fichier de signature est actuellement en cours de création...",
  "t-differential-package-creating" : "En train de créer le paquet différentiel...",
  "t-connection-type-required" : "Le type de connexion est obligatoire",
  "t-message-protocol-required" : "Le protocole de message est obligatoire",
  "t-apk" : "APK",
  "t-zip-dat" : "ZIP|DAT",
  "t-file-type-required" : "Le type de fichier est obligatoire",
  "t-no-preview-available-tiff" : "Le fichier TIFF n'est pas disponible en prévisualisation",
  "t-inconsistent-apk-signatures-unable-push-patch-file" : "La signature de l'application n'est pas cohérente et le fichier de différence ne peut pas être poussé",
  "t-enter-push-event-name" : "Entrez le nom de la tâche planifiée de poussée d'entrée",
  "t-downloading" : "en cours de téléchargement",
  "t-batch-delete" : "Supprimer en masse",
  "t-confirm-batch-delete" : "Êtes-vous sûr de vouloir supprimer {count} éléments ?",
  "t-batch-delete-devices" : "Supprimer en masse les équipements",
  "t-batch-delete-select-at-least-one" : "Veuillez sélectionner au moins un élément",
  "t-batch-delete-invalid-id-format" : "Format d'ID invalide",
  "t-batch-delete-some-items-not-exist" : "Certains éléments n'existent pas",
  "t-batch-delete-request-failed" : "La demande de suppression en masse a échoué",
  "t-batch-delete-no-permission" : "Pas d'autorisation pour la suppression en masse",
  "t-batch-delete-success-count" : "{count} éléments supprimés avec succès",
  "t-search-by-group-name" : "Rechercher par nom de groupe",
  "t-search-device-by-sn-tid-mid" : "Rechercher l'appareil par numéro de série, TID, MID",
  "t-batch-delete-device" : "Supprimer l'appareil",
  "t-batch-delete-devices-details" : "Suppression en masse des informations sur les appareils",
  "t-input-invalid-apk-password" : "Le mot de passe ne peut contenir que des chiffres.",
  "t-batch-enable-disable-device" : "Activer et désactiver en masse les équipements",
  "t-search-by-firmware" : "Recherche par nom de firmware",
  "t-search-by-firmware-version" : "Recherche par nom de version du micrologiciel",
  "t-batch-disable-device" : "Désactiver en masse les appareils",
  "t-search-by-application" : "Recherche par nom d'application",
  "t-search-by-application-version" : "Recherche par nom de version d'application",
  "t-partner-mgmt" : "Gestion des partenaires",
  "t-customer-mgmt": "Gestion des Clients",
  "t-merchant-mgmt": "Gestion des Commerçants",
  "t-system-general-parameter" : "paramètre général",
  "t-add-wallpaper" : "Ajouter un papier peint",
  "t-enter-wallpaper-name" : "Entrez le nom du papier peint",
  "t-wallpaper-name-required" : "Le nom du papier peint est une information obligatoire.",
  "t-add-boot-picture" : "Ajouter la première image de démarrage",
  "t-enter-boot-picture-name" : "Entrez le nom de la première image de démarrage",
  "t-boot-picture-name-required" : "Le nom de la première image de démarrage est obligatoire.",
  "t-add-boot-animation" : "Ajouter l'animation de démarrage",
  "t-enter-boot-animation-name" : "Entrez le nom de l'animation de démarrage",
  "t-boot-animation-name-required" : "Le nom de l'animation de démarrage est un champ obligatoire.",
  "t-boot-picture-file" : "Fichier de la première image de démarrage",
  "t-boot-animation-file" : "Fichier d'animation de démarrage",
  "t-preview-wallpaper" : "aperçu du papier peint",
  "t-preview-boot-picture" : "Aperçu de la première image de démarrage",
  "t-preview-boot-animation" : "Prévisualiser l'animation de démarrage",
  "t-retract" : "rétracter",
  "t-expand" : "déployer",
  "t-app-mgmt" : "Gestion des applications",
  "t-install-immediately-after-downloading" : "Installer immédiatement après le téléchargement",
  "t-install-immediately-for-tips" : "Indication : Cela peut affecter les opérations en cours du client",
  "t-select-installation-period" : "Sélectionner la période d'installation",
  "t-automatic-upgrade-after-startup" : "Mise à niveau automatique après le démarrage",
  "t-specify-the-first-time-after-downloading" : "Spécifiez le moment à partir de la première fois après le téléchargement du fichier",
  "t-support-upgrade-strategy-for-version-code" : "La stratégie de mise à niveau est prise en charge pour la version XXX de SMA et les versions supérieures.",
  "t-installation-time-greater-than-current-time" : "Le temps d'installation doit être supérieur au temps actuel",
  "t-installation-time" : "temps d'installation",
  "t-please-select-installation-time" : "Veuillez sélectionner le premier moment après le téléchargement du fichier.",
  "t-key-mgmt" : "Gestion des clés",
  "t-firmware-mgmt" : "Gestion du micrologiciel",
  "t-system-settings" : "Paramètres du système",
  "t-search-sn-tid-mid" : "SN、TID、MID、IMEI",
  "t-search-sn-mid" : "SN、MID、IMEI",
  "t-search-sn-tid" : "SN、TID",
  "t-search-name-mid": "NAME、MID",
  "t-search-wallpaper" : "papier peint",
  "t-search-boot-picture" : "Première image au démarrage",
  "t-search-boot-animation" : "Animation de démarrage",
  "t-search-hardware-parameter" : "paramètre matériel",
  "t-batch-operate-device" : "Opération en lot d'appareils",
  "t-import-device" : "Appareil d'importation",
  "t-apps-list" : "application",
  "t-app-certificates" : "Certificats d'application",
  "on-board.merchants": "Marchands inscrits",
  "t-device-status-tampered" : "Démontage de l'appareil",
  "t-device-status-out-of-country" : "Hors de la zone géographique du pays",
  "t-device-status-out-of-fence" : "Hors de la clôture géographique",
  "t-device-status-online" : "en ligne",
  "t-device-status-offline" : "hors ligne",
  "t-device-status-disabled" : "désactivé",
  "t-edit-wallpaper" : "Modifier le fond d'écran",
  "t-edit-boot-picture" : "Modifier la première image de démarrage",
  "t-edit-boot-animation" : "Modifier l'animation de démarrage",
  "t-action-name" : "Nom de l'action",
  "t-currencyName" : "Monnaie",
  "t-add-hardware-parameter" : "Ajouter les paramètres matériels",
  "t-edit-hardware-parameter" : "Modifier les paramètres matériels",
  "t-add-system-general-parameter" : "Ajouter un paramètre général ",
  "t-edit-system-general-parameter" : "Modifier les paramètres généraux",
  "t-error-push-search" : "Recherche de poussée",
  "t-boot-picture-version-saved-successfully" : "Le fichier de la première image de démarrage a été téléversé avec succès",
  "t-warning-unbind-device-for-group" : "Voulez-vous vraiment désactiver l'appareil - {param}?",
  "t-unbind-device-confirmation" : "Confirmation de désassociation de l'appareil",
  "t-enable-device" : "Activer l'appareil",
  "t-warning-delete-role" : "Êtes-vous sûr de vouloir supprimer le rôle - {param}?",
  "t-confirmation-delete-role" : "Confirmation de suppression du rôle",
  "t-select-valid-manufacturer" : "Veuillez sélectionner un fabricant valide",
  "t-add-delete-device" : "Ajouter / supprimer l'appareil",
  "t-add-tls-certificate" : "Ajouter le certificat TLS",
  "t-delete-device-information-details" : "Supprimer les détails d'information sur l'appareil",
  "t-enable-device-information-details" : "Activer les détails d'information sur l'appareil",
  "t-disable-device-information-details" : "Désactiver les détails d'information sur l'appareil",
  "t-add-search-device" : "Ajouter un appareil au groupe",
  "t-error-enable-device" : "Une erreur s'est produite lors de l'activation du périphérique",
  "t-error-disable-device" : "Une erreur s'est produite lors de la désactivation de l'appareil",
  "t-user-sourse" : "Source d'utilisateur",
  "t-start-time-than-end-time-one-hour" : "Le temps de début prévu et le temps de fin prévu doivent être supérieurs à trente minutes",
  "t-enter-tid" : "Entrer le TID",
  "t-enter-hardware-param-version-name" : "Entrez le nom du paramètre matériel",
  "t-required-hardware-param-version-name" : "Le nom du paramètre matériel est obligatoire.",
  "t-enter-system-general-param-version-name" : "Entrer le nom du paramètre général du système",
  "t-required-system-general-param-version-name" : "Le nom du paramètre général du système est requis. ",
  "t-import-failed-info" : "Échec de l'importation : ",
  "t-import-file-not-allow-special-characters" : "Le nom du fichier téléversé n'est pas autorisé à contenir des caractères spéciaux.",
  "t-dateYear" : "année",
  "t-num" : "quantité",
  "t-placeholder-enter-device-secret" : "Veuillez saisir la clé de l'appareil",
  "t-placeholder-enter-product-key" : "Veuillez saisir la clé du produit",
  "t-error-enter-device-secret" : "La clé de l'appareil est un champ obligatoire.",
  "t-error-enter-product-key" : "La clé du produit est obligatoire.",
  "t-error-product-key-pattern" : "La clé de l'appareil n'autorise que les lettres majuscules et les chiffres.",
  "t-warning-delete-boot-animation" : "Êtes-vous sûr de vouloir supprimer l'animation de démarrage - {param}?",
  "t-confirmation-delete-boot-animation" : "Confirmation de la suppression de l'animation de démarrage",
  "t-warning-delete-boot-picture" : "Êtes-vous sûr de vouloir supprimer le premier cadre de démarrage - {param}?",
  "t-confirmation-delete-boot-picture" : "Confirmation de la suppression de la première image de démarrage",
  "t-warning-delete-wallpaper" : "Êtes-vous sûr de vouloir supprimer le fond d'écran - {param}?",
  "t-confirmation-delete-wallpaper" : "Confirmation de suppression du fond d'écran",
  "t-delete-system-general-parameter-version-confirmation" : "Suppression de la confirmation de la version du paramètre général ",
  "t-warning-delete-system-general-parameter-version" : "Êtes-vous sûr de vouloir supprimer la version du paramètre général - {param}?",
  "t-system-general-parameter-version-deleted-successfully" : "La version du paramètre général {param} a été supprimée avec succès!",
  "t-error-deleting-system-general-parameter-version" : "Une erreur s'est produite lors de la suppression de la version du paramètre général du système",
  "t-system-general-parameter-version" : "Version du paramètre général",
  "t-delete-hardware-parameter-version-confirmation" : "Confirmation de suppression de la version du paramètre matériel",
  "t-warning-delete-hardware-parameter-version" : "Êtes-vous sûr de vouloir supprimer la version des paramètres matériels - {param}?",
  "t-hardware-parameter-version-deleted-successfully" : "La version du paramètre matériel {param} a été supprimée avec succès!",
  "t-error-deleting-hardware-parameter-version" : "Une erreur s'est produite lors de la suppression de la version du paramètre matériel",
  "t-hardware-parameter-version" : "Version des paramètres matériels",
  "t-system-general-parameter-version-created-successfully" : "La version du paramètre général {param} a été créée avec succès!",
  "t-error-creating-system-general-parameter-version" : "Une erreur s'est produite lors de la création de la version du paramètre général du système",
  "t-error-loading-system-general-parameter-version" : "La version du paramètre général du matériel {param} a été créée avec succès!",
  "t-hardware-parameter-version-created-successfully" : "La version du paramètre matériel {param} a été créée avec succès!",
  "t-error-creating-hardware-parameter-version" : "Une erreur s'est produite lors de la création de la version du paramètre général du matériel.",
  "t-error-loading-hardware-parameter-version" : "Une erreur s'est produite lors de la création de la version des paramètres matériels.",
  "t-boot-animation-saved-successfully" : "L'animation de démarrage {param} a été enregistrée avec succès!",
  "t-boot-picture-saved-successfully" : "La première image de démarrage {param} a été enregistrée avec succès!",
  "t-wallpaper-saved-successfully" : "Le papier peint {param} a été enregistré avec succès!",
  "t-boot-animation-updated-successfully" : "L'animation de démarrage {param} a été mise à jour avec succès!",
  "t-boot-picture-updated-successfully" : "La première image de démarrage {param} a été mise à jour avec succès!",
  "t-wallpaper-updated-successfully" : "Le fond d'écran {param} a été mis à jour avec succès!",
  "t-error-updating-boot-animation" : "Erreur lors de la mise à jour de l'animation de démarrage",
  "t-error-updating-boot-picture" : "Une erreur s'est produite lors de la mise à jour de la première image de démarrage",
  "t-error-updating-wallpaper" : "Une erreur s'est produite lors de la mise à jour du fond d'écran",
  "t-error-creating-boot-animation" : "Une erreur s'est produite lors de la création de l'animation de démarrage",
  "t-error-creating-boot-picture" : "Une erreur s'est produite lors de la création de la première image de démarrage",
  "t-error-creating-wallpaper" : "Une erreur s'est produite lors de la création du fond d'écran",
  "t-error-loading-boot-animation" : "Une erreur s'est produite lors du chargement de l'animation de démarrage",
  "t-error-loading-boot-picture" : "Une erreur s'est produite lors du chargement du premier cadre de démarrage",
  "t-error-loading-wallpaper" : "Une erreur s'est produite lors du chargement du fond d'écran",
  "t-load-more" : "Charger plus",
  "t-load-earlier-records" : "Voir plus anciens",
  "t-timeline-hint" : "Affichage actuel des tâches push de l'année écoulée uniquement",
  "t-boot-animation-deleted-successfully" : "L'animation de démarrage {param} a été supprimée avec succès!",
  "t-boot-picture-deleted-successfully" : "La première image de démarrage {param} a été supprimée avec succès!",
  "t-wallpaper-deleted-successfully" : "Le papier peint {param} a été supprimé avec succès!",
  "t-error-deleting-boot-animation" : "Erreur lors de la suppression de l'animation de démarrage",
  "t-error-deleting-boot-picture" : "Une erreur s'est produite lors de la suppression de la première image de démarrage",
  "t-error-deleting-wallpaper" : "Une erreur s'est produite lors de la suppression du fond d'écran",
  "t-recover-tamper-from-device" : "Êtes-vous sûr de vouloir lever l'état de démontage de l'appareil?",
  "t-enter-otp-from-email" : "Veuillez entrer l'OTP de l'e-mail",
  "t-enter-authorization-times" : "Nombre de fois d'entrée d'autorisation",
  "t-allocate-authorization-updated-successfully" : "L'autorisation d'allocation {param} a été mise à jour avec succès!",
  "t-error-allocate-authorization-updated-times" : "Une erreur s'est produite lors de la mise à jour du nombre de fois d'autorisation d'allocation",
  "t-entrer" : "saisie",
  "t-list-header-updated-successfully" : "Le titre de la liste a été mis à jour avec succès!",
  "t-list-header" : "Titre de la liste",
  "t-push-record" : "Enregistrement de poussée",
  "t-devices-report" : "rapport d'équipements",
  "t-dynamic-report-new": "Rapport dynamique - Nouveau",
  "t-fixed-report-new": "Rapport statique - Nouveau",
  "t-functional-module" : "Module fonctionnel",
  "t-updated-successfully" : "Mise à jour réussie!",
  "t-required-report-name" : "Le nom du rapport est un champ obligatoire.",
  "t-required-report-attribute-name" : "Le nom de l'attribut du rapport est requis.",
  "t-required-report-language" : "Le type de langue est un champ obligatoire.",
  "t-deleted-successfully" : "Supprimé avec succès!",
  "t-push-name" : "Nom de la poussée",
  "t-reduce" : "réduire",
  "t-increase" : "augmenter",
  "t-enable-tamper-auth" : "Activer la vérification d'authentification de démontage",
  "t-otp" : "OTP",
  "t-mfa": "Activer l'MFA",
  "t-otp-password-sent-successfully" : "L'ordre de passe otp a été envoyé avec succès!",
  "t-authorization-times-required" : "Le nombre de fois d'autorisation est un champ obligatoire",
  "t-resend-in" : "réenvoyer",
  "t-status-indicates-scheduled-task" : "Ce statut indique seulement que cette tâche planifiée a été créée.",
  "t-update-authorization-times" : "Nombre de mises à jour de l'autorisation",
  "t-warning-delete-allocate-authorization" : "Êtes-vous sûr de vouloir supprimer l'autorisation d'allocation - {param}?",
  "t-allocate-authorization-deleted-successfully" : "L'autorisation d'allocation {param} a été supprimée avec succès!",
  "t-error-deleting-allocate-authorization" : "Une erreur s'est produite lors de la suppression de l'autorisation d'allocation!",
  "t-please-enter-authorization-times" : "Veuillez entrer le nombre d'autorisations",
  "t-minimum-authorization-times" : "Le nombre minimum d'autorisations est 1",
  "t-maximum-authorization-times" : "Le nombre maximum d'autorisations est 10 000",
  "t-detamper" : "Désactiver le démontage de l'appareil",
  "t-error-loading-allocate-authorization" : "Une erreur s'est produite lors du chargement de l'autorisation d'allocation",
  "t-async-download" : "Téléchargement asynchrone",
  "t-background-audio" : "audio d'arrière-plan",
  "t-upload-folder" : "Dossier de téléchargement",
  "t-upload-folder-is-empty" : "Le dossier de téléchargement est vide",
  "t-upload-folder-maximum-length" : "La longueur maximale du fichier téléchargé ne dépasse pas 100",
  "t-upload-folder-minimum-length" : "La longueur minimale du fichier téléchargé n'est pas inférieure à 1",
  "t-number-of-cycles" : "nombre de cycles",
  "t-number-of-images-play-second" : "Nombre d'images par seconde",
  "t-number-of-images-limited-sheets" : "Le nombre d'images est limité à 1 - 100 feuilles",
  "t-wav" : "Wav",
  "t-sheets" : "Zhang",
  "t-number-of-5" : "1-5",
  "t-customize" : "personnaliser",
  "t-license-information-name-required" : "Le nom des informations sur la licence est obligatoire.",
  "t-upload-license-information-file" : "Télécharger le fichier d'information de licence",
  "t-edit-license-information" : "Modifier l'adresse e-mail de notification",
  "t-error-license-information-created" : "Une erreur s'est produite lors de la création des informations de licence",
  "t-server-info" : "Informations du serveur d'autorisation",
  "t-enable-server-authorization" : "Activer l'autorisation du serveur",
  "t-specified-deployment-server-info" : "Informations sur le serveur de déploiement spécifié",
  "t-ip-address" : "Adresse IP autorisée",
  "t-mac-address" : "Adresse Mac autorisée",
  "t-authorization-period" : "Période de Validité",
  "t-expiration-time-authorization" : "Date d'expiration de l'autorisation",
  "t-buffer-after-expiration" : "Période de grâce après l'expiration de l'autorisation",
  "t-server-utc" : "Fuseau horaire où se trouve le serveur",
  "enable.pre-expiration.alarms": "Activer les alarmes avant expiration",
  "t-time-to-send-alarm-emails" : "Combien de jours avant la date limite pour envoyer des e-mails d'alerte",
  "t-reminder-interval" : "Période d'alerte",
  "t-licensed-nums" : "Quantité de Licences",
  "t-num-of-devices": "Appareils",
  "t-num-of-keys": "Clés",
  "t-device-tamper-times": "Nombre de tentatives de sabotage de l'appareil",
  "t-num-of-partners": "Partenaires",
  "t-num-of-apps-installed": "Applications installées",
  "t-num-of-firmwares": "Firmwares",
  "t-num-of-users": "Utilisateurs",
  "t-num-of-merchants": "Commerçants",
  "t-num-of-transaction-params": "Paramètres de transaction",
  "t-send-email-notifications" : "Envoyer des notifications par e-mail",
  "t-others" : "autres",
  "t-enable-ads" : "la publicité",
  "t-enable-open-api" : "l'API OPEN",
  "t-remaining" : "restant",
  "t-jours" : "jours",
  "t-authorization-expiration-date" : "Date d'expiration de l'autorisation",
  "t-please-charge-in-time" : "Veuillez mettre à jour en temps voulu",
  "t-the-authorization-file-has-expired" :"le fichier d'autorisation a expiré",
  "t-upload-authorization-file" : "Veuillez télécharger le fichier d'autorisation",
  "t-alarm-email" : "Courriel de notification",
  "t-enable-key-push" : "Key",
  "t-created-successfully" : "Sauvegardé avec succès",
  "t-auth-file-parsing-failed" : "Échec de l'analyse du fichier d'autorisation",
  "t-planned-push-after-auth-period" : "Le temps d'exécution de la tâche planifiée ne peut pas être supérieur à la période de validité de l'autorisation",
  "t-expired-by" : "Expiré",
  "t-task-created-successfully" : "La tâche planifiée du système a été créée avec succès!",
  "t-error-creating-task" : "Une erreur s'est produite lors de la création de la tâche planifiée du système",
  "t-task-updated-successfully" : "La tâche système programmée a été mise à jour avec succès!",
  "t-error-updating-task" : "Une erreur s'est produite lors de la mise à jour de la tâche planifiée du système",
  "t-player-second-cannot-exceed-total" : "Le nombre de lectures par seconde d'un joueur ne peut pas dépasser le total",
  "t-function-name" : "Nom du type d'activité",
  "t-key-block-value" : "valeur de bloc de clé",
  "t-enter-key-block-value" : "Entrer la valeur du bloc de clé",
  "t-required-key-block-value" : "La valeur du bloc de clé est requise",
  "t-enter-lmk-index" : "Entrer l'index LMK",
  "t-required-lmk-index" : "L'index LMK est obligatoire",
  "t-required-currency-code" : "La devise est un champ obligatoire",
  "t-required-country-code" : "Le pays est un champ obligatoire",
  "t-terminal-action-analysis" : "Générer le code terminal",
  "t-copy-close" : "Copier et fermer",
  "t-add-tid" : "Ajouter TID",
  "t-update-tid" : "mise à jour TID",
  "t-delete-tid" : "Supprimer le TID",
  "t-server-mdm-delete-profile-error" : "Le fichier d'initialisation du terminal est activé et ne peut pas être supprimé!",
  "t-required-tid" : "Le Tid est un élément requis",
  "t-device-to-swap" : "Appareil à échanger",
  "t-swap" : "échanger",
  "t-swap-tid" : "Échange de TID",
  "t-menu-start-color" : "Couleur de début du menu",
  "t-menu-end-color" : "Couleur de fin du menu",
  "t-menu-text-color" : "Couleur du texte du menu",
  "t-partner-icon" : "Logo du portail des partenaires",
  "t-cloud-message-push-history" : "Historique de la poussée des messages en nuage",
  "t-push-history" : "Historique des poussées",
  "t-expiry-unlimited" : "Illimité",
  "t-enable-cloud-messaging" : "la messagerie cloud",
  "t-receipt-layout-details" : "Détails de la disposition du reçu",
  "t-receipt-type" : "type de reçu",
  "t-layout-name" : "Nom de la disposition",
  "t-receipt-layout" : "mise en page du reçu",
  "t-receipt-created" : "création de reçu",
  "t-receipt-updated" : "Reçu mis à jour",
  "t-default-layout" : "disposition par défaut",
  "t-add-new-row" : "Ajouter une nouvelle ligne",
  "t-add-new-column" : "Ajouter une nouvelle colonne",
  "t-create-row" : "créer une ligne",
  "t-update-row" : "mise à jour de ligne",
  "t-other" : "autre",
  "t-full-screen" : "plein écran",
  "t-display" : "afficher",
  "t-row-number" : "numéro de ligne",
  "t-text-style" : "Style de texte",
  "t-text-align" : "Alignement du texte",
  "t-receipt-rows" : "lignes de reçu",
  "t-label" : "étiquette",
  "t-onboard-merchant" : "Marchand inscrit",
  "t-feitian-iam": "plateforme d'authentification Feitian",
  "t-feitian-partner": "plateforme partenaires de Feitian",
  "t-user-activated" : "L'utilisateur marchand a été activé",
  "t-error-user-activation" : "Une erreur s'est produite lors de l'activation de l'utilisateur marchand",
  "t-mobile-activated" : "Le téléphone portable a été activé",
  "t-kyc-completed" : "KYC terminé",
  "t-onboard-application" : "Marchand enregistré",
  "t-personnel" : "Données personnelles",
  "t-mobile-number" : "numéro de téléphone portable",
  "t-date-of-birth" : "date de naissance",
  "enter.date.of birth": "Veuillez entrer la date de naissance",
  "t-citizenship" : "nationalité",
  "t-company" : "Informations sur la société",
  "t-country-of-registration" : "pays d'enregistrement",
  "t-legal-form" : "forme juridique",
  "t-company-name" : "nom de la société",
  "t-contact-number" : "numéro de contact",
  "t-contact-person" : "Contact",
  "t-business-sector" : "secteur d'affaires",
  "t-business-activity" : "activité commerciale",
  "t-registered-company-street" : "rue de la société enregistrée",
  "t-registered-company-house-number" : "numéro de maison de l'entreprise enregistrée",
  "t-registered-company-city" : "Ville de la société enregistrée",
  "t-registered-company-zip" : "Code postal de la société enregistrée",
  "t-registered-company-country" : "Pays de l'entreprise enregistrée",
  "t-tax-country" : "Pays de taxation",
  "t-tax-id" : "Numéro d'enregistrement fiscal",
  "t-bank" : "Informations sur la banque",
  "t-account-holder-name" : "nom du titulaire du compte",
  "t-account-type" : "type de compte",
  "t-account-currency" : "Devise du compte",
  "t-bank-name" : "nom de la banque",
  "t-account-number" : "compte",
  "t-additional" : "informations supplémentaires",
  "t-intent-of-use" : "intention d'utilisation",
  "t-source-of-use" : "Source de revenu",
  "t-annual-turnover-foresee" : "Chiffre d'affaires annuel prévu",
  "t-expected-average-transaction-amount" : "Montant moyen de transaction attendu",
  "t-online-channel" : "canal en ligne",
  "t-documents" : "fichiers",
  "t-bank-statement" : "relevé bancaire",
  "t-id-proof" : "pièce d'identité",
  "t-address-proof" : "Preuve d'adresse",
  "t-address-proof1" : "Preuve d'adresse 1",
  "t-alert-mgmt" : "Gestion des alertes",
  "t-alert-settings" : "Paramètres d'alerte",
  "t-add-alert" : "Ajouter les paramètres d'alerte",
  "t-edit-alert" : "Modifier les paramètres d'alerte",
  "t-notice-name" : "Nom de l'avis",
  "t-notice-start-time" : "Temps de début de l'avis",
  "t-alert-level-info" : "Général",
  "t-alert-level-warn" : "Avertissement",
  "t-alert-level-critical" : "critique",
  "t-day-and-time" : "semaine",
  "t-notifying-email" : "courrier électronique",
  "t-add-alert-contacts-group" : "Ajouter un groupe de contacts",
  "t-edit-contacts-group" : "Modifier le groupe de contacts",
  "t-search-alert-contacts-group" : "Rechercher le nom du groupe de contacts",
  "t-contacts-group-name" : "nom",
  "t-enter-contacts-group-name" : "Veuillez entrer le nom du groupe de contacts",
  "t-error-contacts-group-name-required" : "Le nom du groupe de contacts est obligatoire",
  "t-warning-delete-contactGroup" : "Êtes-vous sûr de vouloir supprimer le groupe de contacts - {param}?",
  "t-add-alert-policy" : "Ajouter la politique",
  "t-edit-alert-policy" : "édition de la politique",
  "t-search-alert-policy" : "Nom de la stratégie de recherche",
  "t-warning-delete-policy" : "Êtes-vous sûr de vouloir supprimer la politique - {param}?",
  "t-policy-name" : "nom de la politique",
  "t-enter-policy-name" : "Veuillez entrer le nom de la politique",
  "t-error-policy-name-required" : "Le nom de la politique est obligatoire",
  "t-error-policy-rule-template-required" : "Le modèle de règle est un élément requis",
  "t-add-alert-contacts-user" : "Ajouter des contacts",
  "t-edit-contacts-user" : "Modifier les contacts",
  "t-search-alert-contacts-user" : "Rechercher le nom",
  "t-attestation" : "certification",
  "t-add-attestation" : "Ajouter l'attestation",
  "t-error-attestation-created" : "Une erreur s'est produite lors de la création de l'attestation",
  "t-error-attestation-updated" : "Une erreur s'est produite lors de la mise à jour de l'attestation",
  "t-attestation-updated-successfully" : "La certification a été mise à jour avec succès",
  "t-attestation-created-successfully" : "La création de l'attestation a réussi",
  "t-attestation-deleted-successfully" : "L'attestation a été supprimée avec succès!",
  "t-error-deleting-attestation" : "Une erreur s'est produite lors de la suppression de l'attestation",
  "t-search-attestation" : "Recherche d'attestation",
  "t-warning-delete-attestation" : "Êtes-vous sûr de vouloir supprimer l'attestation - {param}?",
  "t-error-deleting-attestation-version" : "Une erreur s'est produite lors de la suppression de la version d'attestation",
  "t-attestation-history" : "Histoire de l'attestation",
  "t-old-rule" : "ancienne règle",
  "t-new-rule" : "nouvelle règle",
  "t-view" : "consulter",
  "t-attestation-monitor" : "Moniteur d'attestation",
  "t-alert-status-info-unread" : "non lu",
  "t-notice-default-rule" : "règle",
  "t-add-rule" : "Ajouter un modèle de règle",
  "t-edit-rule" : "Modèle de règle d'édition",
  "t-search-rule" : "Modèle de règle de recherche",
  "t-enter-alert-rule-name" : "Veuillez entrer le nom de la règle",
  "t-error-alert-rule-name-required" : "Le nom de la règle est obligatoire",
  "t-error-alert-name-required" : "Le nom de l'alerte est un champ obligatoire",
  "t-rule-template-fence-template-name" : "Alerte de clôture électronique",
  "t-alert-rule-updated-successfully" : "Le modèle de règle {param} a été mis à jour avec succès!",
  "t-rule-template-tampered-template-name" : "Alerte de démontage d'équipement",
  "t-enable-tampered-alert" : "Activer l'alerte de démontage",
  "t-enable-out-of-country" : "Activer l'alerte de clôture du pays",
  "t-email-message" : "message électronique",
  "t-error-delay-time-required" : "L'intervalle de notification suivant est obligatoire",
  "t-error-delay-time-max" : "La valeur maximale de l'intervalle de la prochaine notification : ",
  "t-error-delay-time-min" : "La valeur minimale de l'intervalle de la prochaine notification : 1",
  "t-error-alert-channel-required" : "Le canal de notification est obligatoire",
  "t-error-alert-weeks-required" : "La semaine de notification est obligatoire",
  "t-add-email-alert-template" : "Ajouter un modèle d'alerte par e-mail",
  "t-add-alert-alarm-template" : "Ajouter un modèle d'alerte par e-mail",
  "t-update-alert-template" : "Modifier le modèle d'alerte par e-mail",
  "t-search-alert-alarm-template" : "Titre du modèle",
  "t-please-select-the-person-to-alert" : "Veuillez sélectionner la personne à alerter",
  "t-alert-settings-created-successfully" : "Les paramètres d'alerte {param} ont été créés avec succès!",
  "t-error-created-alert-settings" : "Une erreur s'est produite lors de la création des paramètres d'alerte",
  "t-alert-settings-updated-successfully" : "Les paramètres d'alerte {param} ont été modifiés avec succès!",
  "t-error-update-alert-settings" : "Une erreur s'est produite lors de la modification des paramètres d'alerte",
  "t-alert-settings-deleted-successfully" : "L'installation d'alerte {param} a été supprimée avec succès!",
  "t-error-deleting-alert-settings" : "Une erreur s'est produite lors de la suppression des paramètres d'alerte!",
  "t-contacts-user-created-successfully" : "L'utilisateur de contact a été créé avec succès!",
  "t-error-created-contacts-user" : "Une erreur s'est produite lors de la création de l'utilisateur de contacts",
  "t-contacts-user-updated-successfully" : "L'utilisateur du contact {param} a été modifié avec succès!",
  "t-error-update-contacts-user" : "Une erreur s'est produite lors de la modification de l'utilisateur des contacts",
  "t-contacts-user-deleted-successfully" : "L'utilisateur du contact {param} a été supprimé avec succès!",
  "t-error-deleting-contacts-user" : "Une erreur s'est produite lors de la suppression de l'utilisateur des contacts!",
  "t-contacts-group-created-successfully" : "Le groupe de contacts {param} a été créé avec succès!",
  "t-error-created-contacts-group" : "Une erreur s'est produite lors de la création du groupe de contacts",
  "t-contacts-group-updated-successfully" : "Le groupe de contacts {param} a été modifié avec succès!",
  "t-error-update-contacts-group" : "Une erreur s'est produite lors de la modification du groupe de contacts",
  "t-contacts-group-deleted-successfully" : "Le groupe de contacts {param} a été supprimé avec succès!",
  "t-error-deleting-contacts-group" : "Une erreur s'est produite lors de la suppression du groupe de contacts!",
  "t-alerts-policy-created-successfully" : "La stratégie d'alerte {param} a été créée avec succès!",
  "t-error-created-alerts-policy" : "Une erreur s'est produite lors de la création de la politique d'alertes",
  "t-alerts-policy-updated-successfully" : "La politique d'alerte {param} a été modifiée avec succès!",
  "t-error-update-alerts-policy" : "Une erreur s'est produite lors de la modification de la politique d'alerte",
  "t-alerts-policy-deleted-successfully" : "La stratégie d'alerte {param} a été supprimée avec succès!",
  "t-error-deleting-alerts-policy" : "Une erreur s'est produite lors de la suppression de la politique d'alertes!",
  "t-alert-template-created-successfully" : "Le modèle d'e-mail d'alerte {param} a été créé avec succès!",
  "t-alert-template-updated-successfully" : "Le modèle d'e-mail d'alerte {param} a été modifié avec succès!",
  "t-error-updated-email-alert-template" : "Une erreur s'est produite lors de la modification du modèle d'e-mail d'alerte",
  "t-error-created-email-alert-template" : "Une erreur s'est produite lors de la modification du modèle d'e-mail d'alerte",
  "t-error-alert-email-template-title-required" : "Le titre du modèle d'e-mail d'alerte est obligatoire",
  "t-error-alert-email-template-subject-required" : "Le sujet du modèle d'e-mail d'alerte est obligatoire",
  "t-error-update-alert-logs" : "Une erreur s'est produite lors de la modification de l'état des journaux d'alerte",
  "t-alert-logs-updated-successfully" : "La modification de l'état des journaux d'alerte a réussi",
  "t-notifier" : "Personne notifiant",
  "t-minimum-mobile-phone-number" : "Le numéro de téléphone portable doit comporter au moins 8 chiffres",
  "t-maximum-mobile-phone-number" : "Le numéro de téléphone portable ne doit pas dépasser 50 chiffres",
  "t-phone-duplicate":"Copier le téléphone",
  "t-email-duplicate":"Emails répétés",
  "t-select-valid-user-or-partner" : "Veuillez sélectionner les contacts nécessaires",
  "t-add-sms-gateway" : "Ajouter une passerelle SMS",
  "t-edit-sms-gateway" : "Modifier la passerelle SMS",
  "t-enable-sms-success" : "Configuration SMS activée avec succès",
  "t-enable-sms-close" : "La configuration SMS a été fermée avec succès",
  "t-enable-sms-fail" : "L'opération sur l'état du SMS a échoué",
  "t-sms-deleted" : "La configuration de SMS a été supprimée avec succès!",
  "t-error-deleting-sms-settings" : "Une erreur s'est produite lors de la suppression des paramètres des SMS!",
  "t-delete-sms-error" : "Les paramètres SMS sont activés et ne peuvent pas être supprimés!",
  "t-sms-settings-created-successfully" : "La configuration des SMS a été créée avec succès!",
  "t-error-create-sms-settings" : "Une erreur s'est produite lors de la création des paramètres SMS!",
  "t-sms-settings-updated-successfully" : "Les paramètres des SMS ont été mis à jour avec succès!",
  "t-error-updated-sms-settings" : "Une erreur s'est produite lors de la modification des paramètres des SMS",
  "t-sms-settings-accessKeySecret" : "Secret de clé d'accès",
  "t-error-sms-settings-accessKeyId-required" : "L'ID de clé d'accès dans les paramètres SMS est un champ obligatoire",
  "t-error-sms-settings-accessKeySecret-required" : "L'access Key Secret dans les paramètres SMS est un champ obligatoire",
  "t-error-sms-settings-signName-required" : "Le nom de signature dans les paramètres SMS est un champ obligatoire",
  "t-error-silence-time-required" : "Le temps de silence est un champ obligatoire",
  "t-error-silence-time-min" : "Le temps de silence minimum est de 5 minutes",
  "t-error-silence-time-max" : "Le temps de silence maximal est de 1440 minutes",
  "t-enable-manufacturer" : "le fabricant",
  "t-enable-tls-certificate" : "le certificat TLS",
  "t-enable-ticket" : "le ticket de travail",
  "t-enable-merchant-user" : "l'utilisateur marchand inscrit",
  "t-enable-attestation" : "l'attestation",
  "t-enable-sms" : "les paramètres SMS",
  "t-enable-hsm" : "HSM",
  "t-enable-geo-fence" : "la clôture géographique",
  "t-enable-messages" : "les messages",
  "t-enable-report" : "le rapport",
  "t-enable-transaction-param": "le Paramètre de Transaction",
  "t-enable-cortex-scanner": "le Scanner Cortex",
  "t-enable-system-health": "la Santé du Système",
  "t-enable-task-scheduler": "le Planificateur de Tâches",
  "t-enable-feitian-partner": "le Partenaire FeiTian",
  "t-enable-feitian-iam": "IAM de FeiTian",
  "t-enable-static-report": "le rapport statique",
  "t-enable-customize-report": "le rapport de composants",
  "t-enable-widget-report": "le rapport dynamique",
  "t-enable-report-setting" : "les paramètres des rapports",
  "t-enable-otp" : "l'MFA",
  "t-enable-notice" : "la gestion des alertes",
  "t-enable-tamper" : "l'autorisation de désassemblage ",
  "t-public-platform-type" : "Plateforme de cloud public",
  "t-use-password-length" : "La plage de longueur du mot de passe est de 4 à 32",
  "t-license-id" : "Identifiant d'autorisation",
  "t-user-deleted-successfully" : "L'utilisateur {param} a été supprimé avec succès!",
  "t-error-deleting-user" : "Une erreur s'est produite lors de la suppression de l'utilisateur!",
  "t-bind-unbind" : "lier/délier",
  "t-device-has-been-bind-other-partner" : "La liste des appareils contient des appareils liés à d'autres partenaires (cliquez pour télécharger)",
  "t-device-has-been-bind-other" : "Dans la liste des appareils, il y a des appareils liés à d'autres partenaires/clients/commerçants/magasins",
  "tool": {
    "routerTitle": "Paramètres des rapports",
    "addbtn": "Ajouter une catégorie",
    "reportName": "Nom du rapport",
    "createTime": "heure de création",
    "createBy": "Créateur",
    "updateTime": "heure de mise à jour",
    "updateBy": "Personne de mise à jour",
    "reportType": "Type de rapport",
    "universal": "général",
    "custom": "contrôle",
    "popUp": "Êtes-vous sûr de vouloir supprimer le rapport - {param}? ",
    "delectTool": "Supprimer le rapport",
    "sortAllocation": "Configuration de classification",
    "conditions": "conditions",
    "attributeCode": "code d'attribut",
    "attributeName": "nom d'attribut",
    "dataType": "type de données",
    "enumeratedValue": "valeur énumérée",
    "enumerationName": "Nom d'énumération",
    "sortDigit": "Nombre trié",
    "associatedPath": "chemin associé",
    "associationSQL": "association SQL",
    "chartType": "Type de graphique",
    "chartSQL": "SQL de graphique",
    "internationalization": "internationalisation",
    "languageType": "Type de langue",
    "remark": "remarque",
    "pleaseEnter": "Veuillez entrer",
    "pieChart": "graphique en camembert",
    "barChart": "Graphique en colonnes",
    "lineChart": "Graphique en ligne brisée",
    "string": "chaîne de caractères",
    "time": "temps",
    "timeFrame": "plage de temps",
    "enumeration": "énumération",
    "year": "année",
    "month": "mois",
    "report": "rapport"
  },
  "charts": {
    "fixedReport": "Rapport statique",
    "dynamicReport": "rapport dynamique",
    "search": "recherche",
    "export": "exporter",
    "editHeader": "Modifier le titre de la liste",
    "log": {
      "routerTitle": "Enregistrements de poussée",
      "partner": "partenaire de coopération",
      "customer": "client",
      "merchant": "commerçant",
      "store": "magasin",
      "modelCode": "Version du modèle",
      "perform": "exécuter une action",
      "execution": "temps d'exécution",
      "result": "état",
      "resultCause": "cause",
      "push.name": "nom"
    },
    "device": {
      "routerTitle": "Équipement",
      "sn": "Numéro de série",
      "imei": "IMEI",
      "tid": "TID",
      "signalStrength": "réseau",
      "status": "activé",
      "activateTime": "temps d'activation",
      "tamper": "démonter l'appareil",
      "modelVersionName": "Version du modèle",
      "buildNum": "Numéro de version",
      "spBootloader": "Programme d'amorçage SP",
      "spFirmware": "Firmware SP",
      "smaVersionCode": "Code de version SMA",
      "longitude": "longitude et latitude",
      "keyName": "clé",
      "partnerName": "Partenaire",
      "customerName": "client",
      "merchantName": "Commerçant",
      "storeName": "magasin",
      "merchantEmail": "Courriel du marchand",
      "storeEmail": "Courrier électronique du magasin",
      "merchantPhone": "Téléphone du commerçant",
      "storePhone": "Téléphone du magasin",
      "merchantAddress": "Adresse du marchand",
      "storeAddress": "Adresse du magasin",
      "merchantWebsite": "Site Web du marchand",
      "storeWebsite": "Site Web du magasin",
      "currency": "monnaie",
      "groupName": "groupe",
      "countryName": "région",
      "lastOnlineTime": "Dernière fois en ligne",
      "lastDataUpdatedTime": "Heure de la dernière mise à jour des données",
      "lastFactorySettingTime": "Heure de la dernière restauration des paramètres d'usine",
      "mid": "mid"
    },
    "model": {
      "head": "En-tête de liste",
      "applications": "Applications (au maximum 3)"
    }
  },
  "t-api-key": "API Key",
  "t-api-secret": "API Secret",
  "t-online-status": "Statut en ligne",
  "t-api-logs": "Journaux d’appels API",
  "t-api-parameters": "Request parameters",
  "t-click-or-drag-file-upload-file": "Cliquez ou faites glisser un fichier dans cette zone pour le télécharger",
  "t-input-invalid-pattern-special-char-name":"Composé de chiffres, lettres, soulignements, points, virgule, espaces et...,&,(,),-,/,@, et ne peut ni commencer ni terminer avec des espaces.",
  "t-cancel-message": "Annuler le message ",
  "t-cancel-ad": "Annuler le planificateur publicitaire",
  "t-warning-to-cancel-message": "Êtes-vous sûr de vouloir annuler le message?",
  "t-warning-to-cancel-ad": "Êtes-vous sûr de vouloir annuler la publicité?",
  "t-select-device-for-operation": "Veuillez sélectionner l'appareil sur lequel vous souhaitez effectuer l'opération par lots",
  "t-select-operation-for-performed": "Veuillez sélectionner les actions à effectuer en masse",
  "t-themes": "Thèmes",
  "t-theme-customizer": "Personnalisateur de thème",
  "t-layout": "disposition",
  "t-choose-layout": "Choisissez votre disposition",
  "t-color-scheme": "Schéma de couleurs",
  "t-choose-color-scheme": "Choisissez un schéma clair ou sombre",
  "t-sidebar": "Barre latérale",
  "t-choose-sidebar-size": "Choisissez la taille de la barre latérale",
  "t-sidebar-color": "Couleur de la barre latérale",
  "t-choose-sidebar-color": "Choisissez une couleur claire ou sombre pour la barre latérale",
  "t-choose-sidebar-image": "Choisissez une image pour la barre latérale",
  "t-light": "Clair",
  "t-dark": "Sombre",
  "t-vertical": "Vertical",
  "t-horizontal": "Horizontal",
  "t-small": "Petit",
  "t-gradient": "Dégradé",
  "t-add-more-notifier-tips": "Pour ajouter plusieurs contacts, veuillez les séparer par \",\"",
  "t-items": "Projets",
  "t-events": "Événements",
  "t-event": "Événement",
  "t-working-time-period": "Période de travail",
  "t-repetition-interval-time": "Temps entre les répétitions",
  "t-means-of-notification": "Mode de notification",
  "t-close-left-tabs": "Fermer les onglets à gauche",
  "t-close-right-tabs": "Fermer les onglets à droite",
  "t-close-other-tabs": "Fermer les autres onglets",
  "t-push.abort.successfully": "Abandonner l'envoi' avec succès !",
  "t-parameter-settings": "Paramètres des paramètres",
  "t-transaction-mgmt": "Gestion des transactions",
  "t-restore-default": "Restore Default",
  "t-device-extend-attribute": "Attribut étendu de l'appareil",
  "t-device-life-cycle": "Cycle de vie de l'appareil",
  "t-otp-type-ft": "OTP Mobile",
  "t-otp-type-feitian": "Feitian OTP",
  "t-otp-type-google": "Google Authenticator",
  "t-otp-google-download-detail": "Télécharger et installer",
  "t-otp-google-download-detail-2": "Sur votre téléphone",
  "t-otp-install-notes": "Instructions d'installation",
  "t-otp-mobile-download": "Téléchargez une application OTP Mobile",
  "t-error-enter-otp-code": "Le mot de passe dynamique est de 6 à 10 chiffres !",
  "t-scan-QRCode": "Scanner le code QR",
  "t-scan-QRCode-detail": "Ouvrez l'application d'authentification et utilisez l'appareil photo de votre téléphone pour scanner l'image à gauche",
  "t-otp-google-download": "Téléchargez l'application d'authentification",
  "t-google-otp-link-invalid": "Échec de l'activation de l'authentificateur : Le lien est invalide",
  "t-product-model": "Modèle du produit",
  "t-release-time": "Date de sortie",
  "t-wallpaper-format": "Format du fond d'écran",
  "t-bootPicture-format": "Format de l'image de démarrage",
  "t-BootAnimation-format": "Format de l'animation de démarrage",
  "t-model-version-identification": "Identification de la version du modèle",
  "t-enable-device-extend-attribute": "l’attribut étendu de l’appareil",
  "t-enable-device-life-cycle": "le cycle de vie de l’appareil",
  "t-is-empty": "{param} Ne peut pas être vide",
  "t-error-updating-device-extend-attribute-value": "Une erreur est survenue lors de la mise à jour de la valeur de l'attribut étendu de l'appareil",
  "t-enter-attribute-value": "Entrez la valeur de l'attribut étendu",
  "t-server-attribute-type-string": "Longueur de la valeur de l'attribut : 0-50 ; Format : lettres, chiffres",
  "t-server-attribute-type-integer": "La valeur de l'attribut doit être comprise entre 0 et 65535",
  "t-server-attribute-type-boolean": "La valeur de l'attribut est de type booléen. Veuillez vérifier et modifier",
  "t-device-extend-attribute-value-updated-successfully": "La valeur de l'attribut étendu de l'appareil a été mise à jour avec succès !",
  "t-export-to-csv": "Exportation vers CSV",
  "t-tooltip-device-tid": "SN、TID",
  "t-tid-list": "TID List",
  "t-device-life-cycle-desc": "Cycle de vie Description",
  "t-device-life-cycle-modifyTime": "Cycle de vie Modifier",
  "t-fence-boundary":"Limite de clôture",
  "t-more": "Plus",
  "t-visual-range": "Ouvert à",
  "t-belong-to": "Mobile à",
  "t-belong-to-application": "Mobile à l'application",
  "t-belong-to-firmware": "Mobile au firmware",
  "t-global-visibility": "Tout",
  "t-specified-range": "Hiérarchie autorisée",
  "t-not-open-to": "Non ouvert à",
  "t-shared-data-already-exists": "Une allocation de plage de même niveau existe déjà. Pour effectuer des modifications, veuillez d'abord supprimer la plage spécifiée existante avant d'ajouter la nouvelle plage.",
  "t-partner-users-cannot-add-partner-data": "Sélection des données de partenaires liés à soi-même non autorisée.",
  "t-belong-to-firmware-error": "La plage spécifiée ne peut pas être vide",
  "t-remember-password": "Attendez, je me souviens de mon mot de passe...",
  "t-log-in-again": "Attendez, je dois me connecter à nouveau...",
  "t-select-device-exist-disable-device": "Les périphériques sélectionnés contiennent des périphériques désactivés.",
  "t-select-device-exist-inactive-device": "Les périphériques sélectionnés contiennent des périphériques non activés",
  "t-device-sma-version-not-support": "ÉCHEC, VERSION SMA DU DISPOSITIF D'ENVOI NON SUPPORTE",
  "t-owner": "Owner",
  "t-operator": "Operator",
  "t-support-format": "Support Format",
  "t-support-resolution": "Soutenir la résolution",
  "t-device-life-cycle-bulk-upload": "Téléchargement en masse du cycle de vie de l'appareil",
  "t-import-device-life-cycle-information-details": "Détails de l'importation des informations sur le cycle de vie de l'appareil",
  "t-have-joined-download-queue":"En cours",
  "t-key-value-length-is-too-long":"LA LONGUEUR DE LA VALEUR DE LA CLÉ EST TROP LONGUE",
  "t-pad-mode":"Identifiant de mode de plaque",
  "t-key-not-support-pad-mode-type":"Le type de mode de pad n'est pas supporté",
  "t-cipher-by-pubKey":"Chiffrement par clé publique",
  "t-not-export":"Non exporté",
  "t-exported":"Exporté",
  "t-key-has-been-changed":"La clé a été changée",
  "t-marker":"Marqueur",
  "t-export-device-public-key":"Exporter la clé publique",
  "t-import-tid-device-tid-conflict":"Il y a un conflit entre le TID de l'appareil et le TID dans le fichier importé",
  "t-please-enter-account-password": "Veuillez saisir le mot de passe de votre compte",
  "t-authorization-file":"fichier d'autorisation",
  "t-select-device-unbind": "Veuillez sélectionner l'appareil à délier",
  "t-signature-name": "Signature Nom",
  "t-select-installed-numbers": "Seulement trois fichiers APK ou moins peuvent être sélectionnés",
  "t-success-process-message": "oh, oui, vous avez réussi à traiter ce message d'alarme.",
  "t-fail-process-message": "oh, oui, vous n'avez pas réussi à traiter ce message d'alarme.",
  "t-device-apk-password-length": "Le mot de passe doit comporter uniquement 6 caractères.",
  "t-no-permission": "L'utilisateur n'a pas accès au système STORM. Veuillez contacter l'administrateur.",
  "t-hsm-message-header": "En-tête de message HSM",
  "t-direct-connection": "Connexion directe",
  "t-username-password": "Nom d'utilisateur et mot de passe",
  "t-tls-certificate-connect": "Certificat TLS",
  "t-client-ks-certificate": "Certificat client (.ks)",
  "t-client-ks-password": "Mot de passe du certificat client",
  "t-ca-ts-certificate": "Certificat CA (.ts)",
  "t-ca-ts-password": "Mot de passe du certificat CA",
  "t-cert-uploaded": "Téléchargé",
  "t-cert-not-uploaded": "Non téléchargé",
  "t-push-device-information": "Attention : L'interface d'envoi affiche uniquement les appareils activés, sauf lors de l'envoi de la commande d'activation, où seuls les appareils non activés sont affichés.",
  "t-delete-push-success": "Suppression de la notification poussée réussie",
  "t-warning-to-delete-push-scheduled-tasks": "Êtes-vous sûr de vouloir supprimer les tâches planifiées de push?",
  "t-app-uninstall-block": "App Uninstall Block",
  "t-app-password": "App Password",
  "t-mfa-type": "Type MFA",
  "t-only-add-up-to-10-items-events": "Ajoutez seulement jusqu'à 10 événements d'articles.",
  "t-search-name-sn": "Name、SN",
  "t-search-name-version": "Name、Version",
  "t-recorded-in-audit": "Enregistré uniquement dans le journal d'audit",
  "t-device-status-active-key-not-exist": "Clé publique inexistante",
  "t-pos-server-version": "Version du serveur POS",
  "t-transaction-param-version-json-desc": "(STORM a déjà intégré automatiquement TID et MID dans Json selon SN, donc vous n'avez pas besoin de configurer TID et MID à l'intérieur du Json. Si vous configurez toujours TID et MID, nous utiliserons votre version)",
  "t-select-algorithm": "Veuillez sélectionner un algorithme",
  "t-direct-push-success": "Push direct réussi",
  "t-app-file-upload-right-spec": "Les noms de fichier ne supportent que les lettres, les chiffres, les tirets bas et le point anglais.",
  "t-range": "Plage",
  "t-add-more-package-name-tips": "Pour ajouter plusieurs noms de package, utilisez une virgule (,) pour les séparer",
  "t-authorization-has-expired-contact-administrator": "L'autorisation a expiré, veuillez contacter l'administrateur",
  "t-confirm-modify-password": "Mot de passe expiré : Votre mot de passe n’a pas été modifié depuis plus de {param} jours. Réinitialisez-le pour continuer.",
  "t-static-report": "Rapport Statique",
  "t-customize-time-before-days": "Il y a combien de jours avez-vous personnalisé",
  "t-report_export_successfully": "L'exportation a réussi. Veuillez aller à \"Télécharger le rapport\" pour le télécharger",
  "t-report-type": "Type de rapport",
  "t-chart-type": "Chart Type",
  "t-confirm-stop": "Êtes-vous sûr de vouloir arrêter ce record ?",
  "t-enter-maximum-package": "Saisissez un maximum de 3 noms de paquet, séparés par des virgules",
  "t-log-capture-stop": "Capture arrêtée",
  "t-generate": "Générer",
  "t-schedule": "Planifier",
  "t-data-scope": "Portée des données",
  "t-report-data-range": "Plage de données du rapport",
  "t-table-head": "En-tête de tableau",
  "t-visual-widget": "Widget Visuel",
  "t-custom-report": "Rapport Personnalisé",
  "t-generate-schedule": "Générer un emploi du temps",
  "t-authorized-list": "Liste Autorisée",
  "t-pushed": "Poussé",
  "t-search-criteria": "Critères de recherche",
  "t-days-range": "Plage de jours",
  "t-maximum-json-length": "La longueur maximale prise en charge pour JSON est de 32 000 caractères",
  "t-push-status-same-file-exist": "Échec, le même fichier existe",
  "t-push-status": "Push Status",
  "t-app": "Application",
  "t-only-show-groups-with-available-devices": "Afficher uniquement les groupes avec appareils disponibles",
  "t-only-show-available-devices": "Afficher uniquement les groupes avec appareils disponibles",
  "t-licensed-features": "Fonctionnalités Sous Licence",
  "t-period": "Période",
  "t-device-is-disabled-status": "L'appareil est désactivé, veuillez l'activer",
  "t-send-type": "Type d'envoi",
  "t-smtp": "SMTP",
  "t-sendgrid": "SendGrid",
  "t-key-capture-device-encrypted-key-not-exist": "La clé de chiffrement n'existe pas",
  "t-select-all-device-note": "Note : La capture des touches s'effectuera sur tous les appareils dans la plage spécifiée qui sont dans un état actif et fonctionnent normalement.",
  "t-select-device": "Sélectionner l'appareil",
  "t-select-group": "Sélectionner l'groupe",
  "t-all-device": "Tous les appareils",
  "t-all-group": "Tous les groupe",
  "t-proxy-settings": "Configuration du canal de téléchargement",
  "t-download-setting": "Paramètres de téléchargement",
  "t-proxy": "Proxy",
  "t-mpush": "MPUSH",
  "t-mqtt": "MQTT",
  "t-download-directly": "Amazon S3",
  "t-cdn-download": "AWS Cloud Front",
  "t-platform-download": "Plateforme de service STORM",
  "t-feitian-proxy": "Proxy par FT",
  "t-proxy-service-by-ip": "Serveur proxy Feitian (IP)",
  "t-proxy-service-by-domain": "Serveur proxy Feitian (domaine)",
  "t-proxy-service": "Service de proxy",
  "t-successful-push-tasks": "Tâches de Push réussies",
  "t-all-push-tasks": "Toutes les tâches de Push",
  "t-real-time-logs": "Débogage ADB à distance",
  "t-issue-the-command": "Commande",
  "t-communication-log": "Journal de communication",
  "t-refresh-interval": "Intervalle d'actualisation",
  "t-local-log": "Journal local",
  "t-keywords": "Mots-clés",
  "t-start-scraping": "Démarrer le Scraping",
  "t-stop-scraping": "Arrêter le Scraping",
  "t-only-supported-high-version": "Valable uniquement pour SMA 100517 et versions ultérieures",
  "t-only-supported-high-version-old-version-prompt-Upgrade": "Applicable uniquement pour SMA 100517 et versions supérieures; les versions inférieures indiquent uniquement la mise à jour nécessaire",
  "t-overwrite": "écraser",
  "t-append": "ajouter",
  "t-user-login-stats": "Journaux de connexion",
  "t-search-by-user": "Rechercher par utilisateur",
  "t-new-login-count": "Nombre de connexions à la nouvelle version",
  "t-old-login-count": "Nombre de connexions à l'ancienne version",
  "t-last-login-time": "Heure de la dernière connexion",
  "t-data-load-failed": "Échec du chargement des données",
  "t-new-storm": "Nouveau STORM",
  "t-login-type": "Page de connexion",
  "t-google-maps-error-tips": "Échec du chargement de la carte. Veuillez vérifier votre connexion réseau ou réessayer plus tard.",
  "t-frequent-operations-try-again-later": "Opérations fréquentes, veuillez patienter et réessayer plus tard",
  "t-captcha-required": "Veuillez compléter la vérification par glissement",
  "t-captcha-length-error": "La longueur du code de vérification doit être de {param} caractères",
  "t-captcha-error": "Code de vérification incorrect, veuillez le saisir à nouveau",
  "t-captcha-success": "Vérification réussie",
  "t-captcha": "Code de vérification",
  "t-captcha-input-placeholder": "Entrez le code de vérification",
  "t-captcha-expired": "Le code de vérification a expiré, veuillez le saisir à nouveau",
  "t-captcha-slide-to-verify": "Faites glisser le curseur pour terminer la vérification",
  "t-captcha-verify-success": "Vérification réussie",
  "t-unlock-user": "Déverrouiller l'utilisateur",
  "t-lock-user": "Verrouiller l'utilisateur",
  "t-user-locked-successfully": "L'utilisateur a été bloqué avec succès",
  "t-user-unlocked-successfully": "L'utilisateur a été déverrouillé avec succès",
  "t-warning-lock-user": "Êtes-vous sûr de vouloir bloquer cet utilisateur ?",
  "t-warning-unlock-user": "Êtes-vous sûr de vouloir déverrouiller cet utilisateur ?",
  "t-change-the-password-error-protect": "Activer la protection contre les erreurs de mot de passe",
  "t-more-wrong-password-temporarily-locking": "Nombre de tentatives de mot de passe incorrectes consécutives. Après avoir atteint ce nombre, le compte sera temporairement verrouillé [Valeur: 5-10]",
  "t-more-wrong-password-permanently-locking": "Nombre cumulé de tentatives de mot de passe incorrectes. Après avoir atteint ce nombre, le compte sera verrouillé de manière permanente et nécessitera l'intervention d'un administrateur pour le déverrouiller [Valeur: 10-30]",
  "t-temporarily-locking-automatically": "Lorsque le compte est verrouillé temporairement, il sera automatiquement déverrouillé après le temps défini ici (minutes) [Valeur: 5-60]",
  "t-dict": "Configuration des variables système",
  "t-dictionary": "Paramètres",
  "t-dictionary-type": "Type de paramètre",
  "t-enabled": "Enabled",
  "t-disabled": "Disabled",
  "t-dict-data": "Données des paramètres",
  "t-dict-label": "Libellé du paramètre",
  "t-dict-value": "Valeur du paramètre",
  "t-rca-logs": "RCA Logs",
  "t-application-not-installed": "L'application n'est pas détectée, veuillez l'installer pour effectuer cette action, cliquez sur le bouton “Installer l'application” ci-dessous",
  "t-application-waiting-installed": "The device is currently being installed, please wait ..",
  "t-install-application": "Install application",
  "t-reinstall-application": "Reinstall application",
  "t-remote-assistance": "Invite FT Remote Assistance",
  "t-device-needs-app-for-remote-control": "Device needs to install application for remote control",
  "t-checking-app-installation-status": "Checking application installation status...",
  "t-transfer-files": "Transfer files",
  "t-request-sent-device-failed": "Request sent to device failed",
  "t-start-downloading-apps": "START DOWNLOADING APPLICATIONS TASK",
  "t-create-push-task": "Créer une tâche de poussée",
  "t-from-version": "Depuis la version",
  "t-to-version": "À la version",
  "t-delta-package": "Correctif",
  "t-whole-package": "Complet",
  "t-push-status-apn-sim-state-not-ready": "FAIL, ÉTAT SIM APN NON PRÊT",
  "t-push-status-apn-slotindex-mistake": "FAIL, ERREUR D'INDICE DE TROU D'APN",
  "t-push-status-apn-numeric-mistake": "FAIL, ERREUR NUMÉRIQUE D'APN",
  "t-push-status-apn-mnc-mistake": "FAIL, ERREUR MNC D'APN",
  "t-push-status-apn-and-name-not-mistake": "FAIL, APN ET NOM NE CORRESPONDENT PAS",
  "t-push-status-apn-insert-failed": "FAIL, ÉCHEC DE L'INSERTION D'APN",
  "t-push-status-task-superseded": "FAIL, REMPLACÉE PAR NOUVELLE TÂCHE",
  "t-push-status-revoked-terminal-confirmed": "Révoqué (Terminal Confirmé)",
  "t-push-status-reverting": "Révocation",
  "t-push-status-init-firmware-not-supported": "FAIL, FIRMWARE D'INITIALISATION NON SUPPORTÉ",
  "t-push-status-upgrade-in-progress": "FAIL, MISE À NIVEAU EN COURS",
  "t-push-status-already-target-version": "FAIL, DÉJÀ VERSION CIBLE",
  "t-push-status-some-tasks-succeeded-others-failed": "FAIL, CERTAINES TARES RÉUSSIES, AUTRES ÉCHOUÉES",
  "t-push-status-insufficient-battery-will-execute-when-charged": "BATTERIE INSUFFISANTE, S'EXÉCUTERA QUAND ELLE SERA CHARGÉE",
  "t-push-status-second-signature-enabled-device-not-bound-to-customer": "FAIL, SIGNATURE SECONDAIRE ACTIVÉE, APPAREIL NON LIÉ AU CLIENT",
  "server.mpm.device.not.in.customer": "Le partenaire a activé la signature secondaire. Les appareils doivent être liés à un client.",
  "server.mpm.customer.without.signature.application.signed.fail": "Le client ne dispose pas de signature. La signature de l'application a échoué.",
  "t-open-remote-control-model-notes": "Veuillez noter",
  "t-open-remote-control-model-notes-1": "cette opération entraînera une certaine consommation de données (dans les scénarios sans transfert de fichiers). À titre de référence, il est estimé que environ 7 Mo de données seront consommés lors de l'utilisation du dispositif F20 pendant 10 minutes.",
  "t-open-remote-control-model-notes-tha": "cette opération entraînera une certaine consommation de données.",
  "t-open-remote-control-model-notes-2": "La consommation réelle de données est soumise à des facteurs tels que les performances de l'appareil, la fréquence d'utilisation et la résolution de l'écran.",
  "t-open-remote-control-model-waiting": "La demande de contrôle à distance a été initiée, veuillez patienter ..",
  "t-sma-manager": "Gestionnaire SMA",
  "t-select-target-device": "Sélectionner l'appareil cible",
  "t-filter-device-by-version-group": "Les appareils peuvent être filtrés par version/groupe de modèle et la sélection par lots est prise en charge",
  "t-match": "Correspondre",
  "t-match-result": "Résultat de correspondance",
  "t-system-auto-match-version": "Le système a automatiquement fait correspondre les packages différentiels en fonction de la version actuelle de l'appareil et de la version cible ({param})",
  "t-task": "Tâche",
  "t-target": "Cible",
  "t-task-confirmation-submit": "Soumission de confirmation de tâche",
  "t-number-of-success-match": "Nombre de correspondances réussies",
  "t-skip-number-of-unpackaged-devices": "Ignorer le nombre d'appareils non emballés",
  "t-target-os-version": "Version du système d'exploitation cible",
  "t-current-os-version": "Version actuelle du système d'exploitation",
  "t-upgrade-package-type": "Type de package de mise à niveau",
  "t-submitting": "Soumission",
  "t-file-type-not-patch-package": "Le fichier téléchargé ne respecte pas les règles du package différentiel",
  "t-information": "Information",
  "t-match-diff-package": "Correspondre au package différentiel",
  "t-steps": "Étapes",
  "t-websocket-connected": "--- WebSocket Connecté ---",
  "t-start-scraping-logs": "--- Commencer à extraire les journaux ---",
  "t-stop-scraping-logs": "--- Arrêter l'extraction des journaux ---",
  "t-websocket-connection-error": "--- Erreur de connexion WebSocket, veuillez vérifier la console ---",
  "t-websocket-closed": "--- Connexion WebSocket Fermée ---",
  "t-logs-cleared": "--- Journaux Effacés ---",
  "t-command-issued": "> Commande Émise: {command}",
  "t-command-failed": "> Échec de la Commande: {command}",
  "t-command-exception": "> Exception de Commande: {message}",
  "t-websocket-not-connected": "> WebSocket Non Connecté, impossible d'émettre la commande",
  "t-websocket-reconnecting": "> WebSocket Non Connecté, tentative de reconnexion...",
  "t-reconnection-success": "> Reconnexion Réussie",
  "t-reconnection-attempt-failed": "> Tentative de Reconnexion {i}/5 Échouée",
  "t-reconnection-failed-cannot-issue": "> Échec de la Reconnexion, impossible d'émettre la commande",
  "t-command-sent-wait": "> Commande envoyée, veuillez attendre le résultat...",
  "t-ft-remote-control": "FT RCA",
  "t-adb-debug-logs": "Journaux de débogage ADB à distance",
  "t-differential-upgrade-strategy": "Règles du paquet différentiel",
  "t-diff-package-rule-configuration": "Configuration des règles du paquet différentiel",
  "t-version-identifier": "Identifiant de version",
  "t-derivative-flag": "Indicateur dérivé",
  "t-diff-package-push": "Poussée de paquet différentiel",
  "t-diff-package": "Paquet différentiel",
  "t-full-package": "Paquet complet",
  "t-scheduler-firmware-delta-package": "Mise à niveau du micrologiciel - Correctif",
  "t-scheduler-firmware-full-package": "Mise à niveau du micrologiciel - Paquet complet",
  "t-upload-package-tips": "Par exemple : Les fichiers de la version {formVersion} à la version {toVersion} doivent être téléchargés",
  "t-selected-records": "Enregistrements sélectionnés",
  "t-all-records-this-query": "Tous les enregistrements de cette requête",
  "t-no-corresponding-differential-package": "Aucun fichier de package correspondant",
  "t-ota-mgmt": "Gestion OTA",
  "t-grayscale-publishing-strategy": "Stratégie de publication en niveaux de gris",
  "t-grayscale-stage": "Étape en niveaux de gris",
  "t-suggested-add": "Ajout suggéré",
  "t-model-addable": "Modèle ajoutable (Unités)",
  "t-model-added": "Modèle ajouté (Unités)",
  "t-release-strategy": "Stratégie de publication",
  "t-full-release": "Publication complète",
  "t-grayscale-release": "Publication en niveaux de gris",
  "t-auto-upgrade": "Mise à niveau automatique",
  "t-scheduled-upgrade": "Mise à niveau planifiée",
  "t-remind-customer-on-upgrade": "Rappeler au client la mise à niveau",
  "t-upgrade-task": "Tâche de mise à niveau",
  "t-task-name": "Nom de la tâche",
  "t-target-version": "Version cible",
  "t-release-strategy-type": "Type de stratégie de publication",
  "t-upgrade-mgmt": "Gestion des mises à niveau",
  "t-upgrade-type": "Type de mise à niveau",
  "t-upgrade-option": "Option de mise à niveau",
  "t-current-version": "Version actuelle",
  "t-update-log": "Journal des mises à jour",
  "t-last-request-time": "Dernière heure de demande",
  "t-cancel-upgrade": "Annuler la mise à niveau",
  "t-task-cannot-be-revoked": "La tâche ne peut pas être annulée",
  "t-device-list": "Liste des appareils",
  "t-distribution-map": "Carte de distribution",
  "t-whole-package-push": "Poussée de paquet complet",
  "t-full-upgrade": "Mise à niveau complète",
  "t-delta-upgrade": "Mise à niveau delta",
  "t-not-equipped-upgrades": "Exclure Les Dispositifs Avec Des Taches De Mise À Jour",
  "t-source-to-target": "De la source à la cible",
  "t-confirm-change": "Confirmer le changement",
  "t-confirm-change-proxy": "Confirmer le changement de configuration du proxy ?",
  "t-warning": "Avertissement",
  "t-change-model-warning": "Avertissement de changement de modèle",
  "t-app-used-quota": "Quota d'application utilisé",
  "t-firmware-used-quota": "Quota de micrologiciel utilisé",
  "t-switch-to": "Passer à",
  "t-app-available-use": "Application disponible",
  "t-firmware-available-use": "Micrologiciel disponible",
  "t-forced-switch":"Commut. forcée",
  "t-start-time-cannot-be-greater-than-end-time": "L'heure de début ne doit pas être postérieure à l'heure de fin",
  "t-allow-download-during-sleep": "Autoriser le téléchargement en mode veille",
  "t-allow-download-during-sleep-desc": "Sélectionnez cette option et le terminal permettra le téléchargement de fichiers de firmware en mode veille",
  "t-not-upgrade-task-by-firmware-tips": "Aucune tâche de mise à niveau du système d'exploitation",
  "t-not-upgrade-task-by-firmware-tips-desc": "Exclut les appareils ayant des tâches de mise à niveau du système d'exploitation existantes.",
  "t-filters-device-by-status-title": "Appareils Exclus par Défaut",
  "t-filters-device-by-status-desc1": "- Déjà sur la version cible",
  "t-filters-device-by-status-desc2": "- Inactif",
  "t-filters-device-by-status-desc3": "- En dehors de la clôture géographique",
  "t-filters-device-by-status-desc4": "- En dehors du pays",
  "t-succeeded": "Réussi",
  "t-failed": "Échec",
  "t-revoked": "Révoqué",
  "t-auto-recognize-version": "Reconnaissance automatique de version",
  "t-revoked-task-tips": "Seules les tâches qui ont été créées mais pas encore initiées par le terminal peuvent être révoquées (la version SMA doit être 200112 ou supérieure).",
  "t-product": "Produit",
  "t-ota-error-logs": "Événement D'Exception Du Dispositif",
  "t-event-type": "Type D'Événement",
  "t-active-os-upgrade-tasks": "Tâches actives de mise à jour du firmware (12 Derniers Mois)",
  "t-file-upload-error-try-again": "Le format du firmware téléchargé est incorrect, veuillez réessayer",
  "t-update-time": "Heure de mise à jour",
  "t-filter-same-versions": "Exclure Les Dispositifs De La Version Cible",
  "t-filter-same-versions-desc": "Lorsque cette option est cochée, les appareils qui sont déjà sur la version cible seront exclus.",
  "t-allow-same-version-upgrade": "Permettre La Mise À Niveau De La Même Version",
  "t-allow-same-version-upgrade-desc": "Si vous sélectionnez cette option, le terminal permettra la mise à niveau vers la même version de firmware que la version actuelle",
  "t-replace-uncompleted-tasks": "Remplacer La Tâche",
  "t-replace-uncompleted-tasks-desc": "La nouvelle tâche remplacera la tâche précédente qui n'est pas terminée dans le dispositif.",
  "t-time-period-not-allowed-across-days": "La période de temps ne peut pas s'étendre sur plusieurs jours",
  "t-file-upload-successful": "Le fichier {type} correspondant au dispositif {device} a été téléchargé avec succès!",
  "t-select-identical-rule": "Vous avez sélectionné une règle en double",
  "t-formversion-toversion-same": "La version source et la version cible ne peuvent pas être les mêmes",
  "t-please-complete-the-information-for-all-rules": "Veuillez remplir les informations complètes de la règle",
  "t-all-day": "Toute la journée",
  "t-custom-period": "Période personnalisée",
  "t-json-err-check-retry": "Erreur de format JSON, veuillez vérifier le contenu saisi",
  "t-only-supported-high-version-new": "Le support est fourni pour la version SMA 100517 et supérieure.",
  "t-search_report_name_user": "Nom du rapport、Créé par",
  "t-password-must-be-6-digits": "Veuillez entrer un mot de passe à 6 chiffres",
  "t-batch-operation": "Opération par lots",
  "t-sub-action": "Sous-opération",
  "t-batch-application-fail-cause" : "Cause d'échec de l'application",
  "t-display-only-devices-without-generated-keys": "Afficher uniquement les appareils sans clés générées",
  "t-historical-records-have-been-detected": "{count} enregistrements historiques ont été détectés. Si le dispositif sélectionné a déjà généré cette Clé, les nouvelles données remplaceront automatiquement les anciens enregistrements.",
  "t-firmware-sma-version-warning": "Note : Les appareils avec des versions SMA inférieures à 200117 ne supportent pas cette configuration. Le contenu lié au firmware sera exclu lors de la création de profils de terminal.",
  "t-exclude-devices-with-terminal-profile-tasks": "Exclure Les Dispositifs Avec Tâches De Profil De Terminal",
  "t-encrypt-type": "Type de Chiffrement",
  "t-auto-select-recommended": "AUTO - Sélection Automatique (Recommandé)",
  "t-force-ecc": "ECC",
  "t-force-rsa": "RSA",
  "t-tr34": "TR34",
  "t-encrypt-type-hint-auto": "AUTO: Privilégier le chiffrement ECC, revenir automatiquement à RSA si l'appareil ne le prend pas en charge",
  "t-encrypt-type-hint-ecc": "ECC: Utiliser uniquement le chiffrement ECC, l'injection échoue si l'appareil ne le prend pas en charge",
  "t-encrypt-type-hint-rsa": "RSA: Utiliser uniquement le chiffrement RSA",
  "t-encrypt-type-hint-tr34": "TR34: Utiliser le format standard TR34 pour l'injection de clés",
  "t-tr34-auth-required": "Veuillez compléter l'authentification mutuelle avant de sélectionner le format TR34",
  "t-go-to-mutual-auth": "Aller aux Métadonnées de Clé Liée",
  "t-device-ecc-not-supported": "L'appareil ne prend pas en charge le chiffrement ECC",
  "t-key-capture-device-cert-not-exist": "CERTIFICAT DE L'APPAREIL INEXISTANT",
  "t-key-capture-device-not-authenticated": "APPAREIL NON AUTHENTIFIÉ",
  "t-key-capture-device-mutual-auth-unbound-key-invalidated": "AUTHENTIFICATION MUTUELLE DE L'APPAREIL NON LIÉE, CLÉ INVALIDÉE",
  "t-key-capture-key-derivation-failed": "ÉCHEC DE LA DÉRIVATION DE CLÉ",
  "t-root-ca-certificate": "Certificat Root CA",
  "t-sub-ca-certificate": "Certificat Sub CA",
  "t-server-certificate": "Certificat Serveur",
  "t-import-certificate": "Importer le Certificat",
  "t-export-csr": "Exporter le CSR",
  "t-generate-csr": "Générer le CSR",
  "t-key-size": "Taille de la clé",
  "t-valid": "Valide",
  "t-expired": "Expiré",
  "t-public-key-algorithm": "Algorithme de Clé Publique",
  "t-private-key-location": "Emplacement de la Clé Privée",
  "t-re-import": "Réimporter",
  "t-rki-root-ca-alert": "Le certificat Root CA est émis par l'usine FT Safe. La plateforme ne le stocke que pour la vérification de la chaîne de certificats et ne peut pas le modifier.",
  "t-rki-sub-ca-alert": "Le certificat Sub CA est émis par l'usine FT Safe et importé sur la plateforme. Il est utilisé pour vérifier la chaîne de certificats Device Cert lors de l'authentification mutuelle.",
  "t-rki-server-cert-alert": "Server Cert est généré par la plateforme dans le HSM. Le CSR est exporté vers l'usine FT Safe pour signature. La clé privée ne quitte jamais le HSM.",
  "server.cert.root.ca.not.found": "Root CA introuvable, impossible de vérifier Sub CA",
  "server.cert.verify.sub.ca.failed": "La vérification du certificat a échoué",
  "server.cert.import.failed": "L'importation du certificat serveur a échoué",
  "server.cert.private.key.not.found": "Clé privée introuvable, générez d'abord un CSR",
  "server.cert.private.key.mismatch": "La clé privée ne correspond pas au certificat serveur",
  "server.cert.expired": "Le certificat a expiré. Veuillez émettre un certificat valide",
  "server.cert.not.yet.valid": "Le certificat n'est pas encore valide. Vérifiez la date d'émission",
  "server.cert.not.exists": "Le certificat serveur n'existe pas",
  "t-mutual-auth": "Bind Key Metadata",
  "t-initiate-auth": "Bind Key Metadata",
  "t-batch-auth": "Authentification par Lot",
  "t-rki-mutual-auth-alert": "Flux d'authentification mutuelle : TMS envoie la commande d'authentification → Appareil envoie Device Cert → TMS vérifie avec Sub CA → TMS envoie Server Cert → Appareil vérifie avec Sub CA → Authentification réussie",
  "t-auth-status": "Statut",
  "t-auth-time": "Heure de Liaison",
  "t-authenticated": "Liaison Réussie",
  "t-unauthenticated": "Non Lié",
  "t-authenticating": "Liaison en cours",
  "t-auth-failed": "Échec de la Liaison",
  "t-auth-fail-cause": "Raison de l'Échec",
  "t-not-authenticated": "En Attente de Liaison",
  "t-unbound": "En Attente de Génération CSR",
  "t-server-cert-not-exist": "Le certificat serveur du partenaire n'existe pas. Configurez-le avant de lancer la liaison.",
  "t-csr-pending": "CSR En attente",
  "t-csr-received": "CSR Reçu",
  "t-download-csr": "Télécharger le CSR",
  "t-download-success": "Téléchargement Réussi",
  "t-csr-content-empty": "Le contenu CSR est vide",
  "t-upload-cert": "Télécharger le Certificat",
  "t-sync-device-cert": "Synchroniser le Certificat de l'Appareil",
  "t-sync-device-random-number": "Synchroniser le Numéro Aléatoire de l'Appareil",
  "t-cert-file": "Fichier de Certificat",
  "t-upload-success": "Téléchargement Réussi",
  "t-server-exception-try-later": "Exception du serveur, veuillez réessayer plus tard!",
  "t-gray-release-template": "Modèle de Libération Progressive",
  "t-template-name": "Nom du Modèle",
  "t-strategy-type": "Type de Stratégie",
  "t-release-mode": "Mode de Libération",
  "t-batch-config": "Configuration d'étape",
  "t-auto-promote-threshold": "Seuil de Promotion Automatique",
  "t-auto-promote-threshold-required": "Le seuil de promotion automatique est obligatoire",
  "t-auto-promote-threshold-range": "Le seuil de promotion automatique doit être supérieur à 0 et ne peut pas dépasser 100",
  "t-fast-release": "Libération Rapide",
  "t-standard-release": "Libération Standard",
  "t-conservative-release": "Libération Conservative",
  "t-by-percentage": "Par Pourcentage",
  "t-by-device-count": "Par Nombre d'Appareils",
  "t-template-name-required": "Le nom du modèle est requis",
  "t-batch-config-required": "La configuration des lots est requise",
  "t-enabled-success": "Activé avec succès",
  "t-disabled-success": "Désactivé avec succès",
  "t-enabled-cannot-delete": "Impossible de supprimer lorsque activé",
  "t-operation-failed": "Échec de l'opération",
  "t-add-batch": "Ajouter une étape",
  "t-threshold-hint": "Promotion automatique vers l'étape suivante lorsque le taux de réussite de la mise à jour ≥ seuil",
  "t-collect-duration": "Durée de collecte des données de santé",
  "t-collect-count": "Nombre de collectes de données de santé",
  "t-collect-duration-required": "La durée de collecte des données de santé est obligatoire",
  "t-collect-count-required": "Le nombre de collectes de données de santé est obligatoire",
  "t-times": "fois",
  "t-units": "unité(s)",
  "t-percentage": "Pourcentage",
  "t-device-count": "Nombre d'Appareils",
  "t-custom": "Personnalisé",
  "t-must-be-greater": "doit être supérieur au précédent",
  "t-use-gray-release-template": "Déploiement progressif",
  "t-select-template": "Sélectionner un modèle",
  "t-gray-release-allocation-valid": "Les {count} appareils sélectionnés satisfont la répartition requise pour {stages} étapes de mise à niveau.",
  "t-gray-release-allocation-insufficient": "{count} appareils sont sélectionnés. Le nombre sélectionné doit être supérieur au nombre total d'appareils de toutes les étapes ({required}) ; il en manque {missing}.",
  "t-gray-release-allocation-invalid-template": "Ce modèle de déploiement progressif ne peut pas attribuer au moins un appareil à chaque étape de mise à niveau.",
  "t-gray-release-task-detail": "Détail de la tâche de déploiement progressif",
  "t-gray-task": "Tâche progressive",
  "t-gray-detail": "Voir le détail progressif",
  "t-gray-template-name": "Nom du modèle progressif",
  "t-current-batch": "Lot actuel",
  "t-total-progress": "Progression totale",
  "t-health-rate": "Taux de santé",
  "t-task-status": "Statut de la tâche",
  "t-pause": "Pause",
  "t-resume": "Reprendre",
  "t-force-promote": "Forcer la promotion",
  "t-enter-next-stage": "Passer directement à l’étape suivante",
  "t-cancel-task": "Annuler la tâche",
  "t-batch-progress": "Progression des lots",
  "t-progress": "Progression",
  "t-success-rate": "Taux de réussite",
  "t-threshold": "Seuil",
  "t-no-batch-data": "Aucune donnée de lot",
  "t-health-evaluation": "Aperçu de la mise à niveau des appareils",
  "t-pass": "Réussi",
  "t-no-health-data": "Aucune donnée de santé",
  "t-paused-success": "Tâche mise en pause avec succès",
  "t-resume-success": "Tâche reprise avec succès",
  "t-force-promote-success": "Promotion forcée réussie",
  "t-enter-next-stage-success": "Étape suivante démarrée directement",
  "t-stage": "Étape",
  "t-upgrade-stage-progress-overview": "Aperçu de la progression des étapes de mise à niveau",
  "t-cancel-success": "Tâche annulée",
  "t-not-started": "Non commencé",
  "t-in-progress": "En cours",
  "t-paused": "En pause",
  "t-completed": "Terminé",
  "t-cancelled": "Annulé",
  "t-terminated": "Arrêté",
  "t-auto-promote": "Promotion automatique",
  "t-health-evaluated-success": "Évaluation de santé terminée",
  "t-health-all-passed": "Tous les contrôles de santé réussis",
  "t-health-not-passed": "Contrôle de santé échoué",
  "t-health-all-passed-desc": "Tous les indicateurs principaux atteignent le seuil",
  "t-health-not-passed-desc": "Certains indicateurs principaux n'ont pas atteint le seuil",
  "t-card-read-success-rate": "Taux de réussite de lecture de carte",
  "t-print-status": "État d'impression",
  "t-core-health": "Indicateurs de santé principaux",
  "t-ft-applications": "FT Applications",
  "t-app-name": "Nom de l'application",
  "t-file-path": "Chemin du fichier",
  "t-app-type": "Type d'application",
  "t-ftrca-desc": "Agent de contrôle à distance",
  "t-fttha-desc": "Agent de santé du terminal",
  "t-apk-parse-result": "Résultat de l'analyse APK",
  "t-file-not-found": "Fichier non trouvé",
  "server.partner.traffic.quota.config.already.exists": "La configuration de quota pour ce partenaire existe déjà"
}
